var _style, _path, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs10, _defs11, _defs12, _defs13, _defs14, _defs15, _defs16, _defs17, _defs18, _defs19, _defs20, _defs21, _defs22, _defs23, _defs24, _defs25, _defs26, _defs27, _defs28, _defs29, _defs30, _defs31, _defs32, _defs33, _defs34, _defs35, _defs36, _defs37, _defs38, _polygon, _defs39, _defs40, _defs41, _defs42, _defs43, _defs44, _defs45, _defs46, _defs47, _defs48, _defs49, _defs50, _defs51, _defs52, _defs53, _defs54, _defs55, _defs56, _defs57, _defs58, _defs59, _defs60, _defs61, _defs62, _defs63, _defs64, _defs65, _defs66, _defs67, _defs68, _defs69, _defs70, _defs71, _defs72, _defs73, _defs74, _defs75, _defs76, _polygon2, _defs77, _defs78, _defs79, _defs80, _defs81, _defs82, _defs83, _defs84, _defs85, _defs86, _defs87, _defs88, _defs89, _defs90, _defs91, _defs92, _defs93, _defs94, _defs95, _defs96, _defs97, _defs98, _defs99, _defs100, _defs101, _defs102, _defs103, _defs104, _defs105, _defs106, _defs107, _defs108, _defs109, _defs110, _defs111, _defs112, _defs113, _defs114, _defs115, _defs116, _defs117, _defs118, _defs119, _defs120, _defs121, _defs122, _defs123, _defs124, _defs125, _defs126, _defs127, _defs128, _defs129, _defs130, _defs131, _defs132, _defs133, _defs134, _defs135, _defs136, _defs137, _defs138, _defs139, _defs140, _defs141, _defs142, _defs143, _defs144, _defs145, _defs146, _defs147, _defs148, _defs149, _defs150, _defs151, _defs152, _path2, _defs153, _defs154, _defs155, _defs156, _defs157, _defs158, _defs159, _defs160, _defs161, _defs162, _defs163, _defs164, _defs165, _defs166, _defs167, _defs168, _defs169, _defs170, _defs171, _defs172, _defs173, _defs174, _defs175, _defs176, _defs177, _defs178, _defs179, _defs180, _defs181, _defs182, _defs183, _defs184, _defs185, _defs186, _defs187, _defs188, _defs189, _defs190, _defs191, _defs192, _defs193, _defs194, _defs195, _defs196, _defs197, _defs198, _defs199, _defs200, _defs201, _defs202, _defs203, _defs204, _defs205, _defs206, _defs207, _defs208, _defs209, _defs210, _defs211, _defs212, _defs213, _defs214, _defs215, _defs216, _defs217, _defs218, _defs219, _defs220, _defs221, _defs222, _defs223, _defs224, _defs225, _defs226, _defs227, _defs228, _defs229, _defs230, _defs231, _defs232, _defs233, _defs234, _defs235, _defs236, _defs237, _defs238, _defs239, _defs240, _defs241, _defs242, _defs243, _defs244, _defs245, _defs246, _defs247, _defs248, _defs249, _defs250, _defs251, _defs252, _defs253, _defs254, _defs255, _defs256, _defs257, _defs258, _defs259, _defs260, _defs261, _defs262, _defs263, _defs264, _defs265, _defs266, _defs267, _defs268, _defs269, _defs270, _defs271, _defs272, _defs273, _defs274, _defs275, _defs276, _defs277, _defs278, _defs279, _defs280, _defs281, _defs282, _defs283, _defs284, _defs285, _defs286, _defs287, _defs288, _defs289, _defs290, _defs291, _defs292, _defs293, _defs294, _defs295, _defs296, _defs297, _defs298, _defs299, _defs300, _defs301, _defs302, _defs303, _defs304, _defs305, _defs306, _defs307, _defs308, _defs309, _defs310, _defs311, _defs312, _defs313, _defs314, _defs315, _defs316, _defs317, _defs318, _defs319, _defs320, _defs321, _defs322, _defs323, _defs324, _defs325, _defs326, _defs327, _defs328, _defs329, _defs330, _defs331, _defs332, _defs333, _defs334, _defs335, _defs336, _defs337, _defs338, _defs339, _defs340, _defs341, _defs342, _polygon3, _defs343, _defs344, _defs345, _defs346, _defs347, _defs348, _defs349, _defs350, _defs351, _defs352, _defs353, _defs354, _defs355, _defs356, _defs357, _defs358, _defs359, _defs360, _defs361, _defs362, _defs363, _defs364, _defs365, _defs366, _defs367, _defs368, _defs369, _defs370, _defs371, _defs372, _defs373, _defs374, _defs375, _defs376, _defs377, _defs378, _defs379, _defs380, _polygon4, _defs381, _defs382, _defs383, _defs384, _defs385, _defs386, _defs387, _defs388, _defs389, _defs390, _defs391, _defs392, _defs393, _defs394, _defs395, _defs396, _defs397, _defs398, _defs399, _defs400, _defs401, _defs402, _defs403, _defs404, _defs405, _defs406, _defs407, _defs408, _defs409, _defs410, _defs411, _defs412, _defs413, _defs414, _defs415, _defs416, _defs417, _defs418, _defs419, _defs420, _defs421, _defs422, _defs423, _defs424, _defs425, _defs426, _defs427, _defs428, _defs429, _defs430, _defs431, _defs432, _defs433, _defs434, _defs435, _defs436, _defs437, _defs438, _defs439, _defs440, _defs441, _defs442, _defs443, _defs444, _defs445, _defs446, _defs447, _defs448, _defs449, _defs450, _defs451, _defs452, _defs453, _defs454, _defs455, _defs456, _path3, _defs457, _defs458, _defs459, _defs460, _defs461, _defs462, _defs463, _defs464, _defs465, _defs466, _defs467, _defs468, _defs469, _defs470, _defs471, _defs472, _defs473, _defs474, _defs475, _defs476, _defs477, _defs478, _defs479, _defs480, _defs481, _defs482, _defs483, _defs484, _defs485, _defs486, _defs487, _defs488, _defs489, _defs490, _defs491, _defs492, _defs493, _defs494, _defs495, _defs496, _defs497, _defs498, _defs499, _defs500, _defs501, _defs502, _defs503, _defs504, _defs505, _defs506, _defs507, _defs508, _defs509, _defs510, _defs511, _defs512, _defs513, _defs514, _defs515, _defs516, _defs517, _defs518, _defs519, _defs520, _defs521, _defs522, _defs523, _defs524, _defs525, _defs526, _defs527, _defs528, _defs529, _defs530, _defs531, _defs532, _defs533, _defs534, _defs535, _defs536, _defs537, _defs538, _defs539, _defs540, _defs541, _defs542, _defs543, _defs544, _defs545, _defs546, _defs547, _defs548, _defs549, _defs550, _defs551, _defs552, _defs553, _defs554, _defs555, _defs556, _defs557, _defs558, _defs559, _defs560, _defs561, _defs562, _defs563, _defs564, _defs565, _defs566, _defs567, _defs568, _defs569, _defs570, _defs571, _defs572, _defs573, _defs574, _defs575, _defs576, _defs577, _defs578, _defs579, _defs580, _defs581, _defs582, _defs583, _defs584, _defs585, _defs586, _defs587, _defs588, _defs589, _defs590, _defs591, _defs592, _defs593, _defs594, _defs595, _defs596, _defs597, _defs598, _defs599, _defs600, _defs601, _defs602, _defs603, _defs604, _defs605, _defs606, _defs607, _defs608;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeWidget2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1_kopie_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 115.9 243.3",
    style: {
      enableBackground: "new 0 0 115.9 243.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_00000143603952283874157650000009137377419470732692_);}\r\n\t.st2{fill:url(#SVGID_00000067205950159246296860000013499347516776766382_);}\r\n\t.st3{fill:url(#SVGID_00000085946436773717869130000013051208308038134701_);}\r\n\t.st4{clip-path:url(#SVGID_00000155104218768527072440000000691827704150913718_);}\r\n\t.st5{filter:url(#Adobe_OpacityMaskFilter);}\r\n\t.st6{clip-path:url(#SVGID_00000042003183997074983840000001560903715859070369_);}\r\n\t.st7{clip-path:url(#SVGID_00000140711912420031330210000015624445825785687722_);}\r\n\t.st8{clip-path:url(#SVGID_00000114773887035575863580000013390312445399225528_);}\r\n\t.st9{clip-path:url(#SVGID_00000042736648443615717720000001589727901459692207_);}\r\n\t.st10{clip-path:url(#SVGID_00000018930784369015131290000005383322124567338168_);}\r\n\t.st11{clip-path:url(#SVGID_00000095340625747287874880000016926862584225021072_);}\r\n\t.st12{clip-path:url(#SVGID_00000016053173587982499610000005639772564735845286_);}\r\n\t.st13{clip-path:url(#SVGID_00000050638552719320803730000007093234830112265141_);}\r\n\t.st14{clip-path:url(#SVGID_00000071534185332589801140000005815479174941184702_);}\r\n\t.st15{clip-path:url(#SVGID_00000145031504085297090510000000775799046821834133_);}\r\n\t.st16{clip-path:url(#SVGID_00000148659699230137897510000016814607297584540064_);}\r\n\t.st17{clip-path:url(#SVGID_00000096047254159000559000000005317535668763823506_);}\r\n\t.st18{clip-path:url(#SVGID_00000007425317489226268860000003899512362649951159_);}\r\n\t.st19{clip-path:url(#SVGID_00000098185318595314633210000016684833375433418160_);}\r\n\t.st20{clip-path:url(#SVGID_00000026163632544846536760000016551717852932025279_);}\r\n\t.st21{clip-path:url(#SVGID_00000103956885070597003750000009280861281898252431_);}\r\n\t.st22{clip-path:url(#SVGID_00000088093015538758725410000013519652621416056967_);}\r\n\t.st23{clip-path:url(#SVGID_00000080893887115109698740000001802844341284428716_);}\r\n\t.st24{clip-path:url(#SVGID_00000000206403320220194520000007799253707234456468_);}\r\n\t.st25{clip-path:url(#SVGID_00000003810112142496040820000017210356925932369031_);}\r\n\t.st26{clip-path:url(#SVGID_00000153707617588466921480000001607241748017701768_);}\r\n\t.st27{clip-path:url(#SVGID_00000139988551524798251730000006772674719091909772_);}\r\n\t.st28{clip-path:url(#SVGID_00000165208770389389703480000012706638164927692200_);}\r\n\t.st29{clip-path:url(#SVGID_00000109713122428114266050000010683039120015975091_);}\r\n\t.st30{clip-path:url(#SVGID_00000123431742983001693430000004694819615702004117_);}\r\n\t\r\n\t\t.st31{clip-path:url(#SVGID_00000039114683963793778960000014834187711551634364_);fill:url(#SVGID_00000036252809205003988860000002120587645879719306_);}\r\n\t\r\n\t\t.st32{clip-path:url(#SVGID_00000042003183997074983840000001560903715859070369_);mask:url(#SVGID_00000098205536018099535110000018239108834979048580_);fill:url(#SVGID_00000059292374237083501040000010819963464764074892_);}\r\n\t.st33{fill:#1E110E;}\r\n\t.st34{clip-path:url(#SVGID_00000125579721094981627280000010883080394559083705_);}\r\n\t.st35{filter:url(#Adobe_OpacityMaskFilter_00000134968067599596755820000005146538260405359246_);}\r\n\t.st36{clip-path:url(#SVGID_00000003085622166793402860000016414276031157987225_);}\r\n\t.st37{clip-path:url(#SVGID_00000092434337355419660210000016303834377171238583_);}\r\n\t.st38{clip-path:url(#SVGID_00000158727572287832003350000005370641086354923394_);}\r\n\t.st39{clip-path:url(#SVGID_00000049207387041267512790000014737632969481530288_);}\r\n\t.st40{clip-path:url(#SVGID_00000098903248237633876740000014947198857822647170_);}\r\n\t.st41{clip-path:url(#SVGID_00000164473449876316322640000016103539908571133332_);}\r\n\t.st42{clip-path:url(#SVGID_00000150797725397505022790000012968414999777580677_);}\r\n\t.st43{clip-path:url(#SVGID_00000132784156885865640410000000620546631654229418_);}\r\n\t.st44{clip-path:url(#SVGID_00000075149489151224286260000011444646863821565573_);}\r\n\t.st45{clip-path:url(#SVGID_00000025412727879811302760000009846293266576975009_);}\r\n\t.st46{clip-path:url(#SVGID_00000096767271291303428860000016657200378693805975_);}\r\n\t.st47{clip-path:url(#SVGID_00000137107835436662833590000002346440528640945566_);}\r\n\t.st48{clip-path:url(#SVGID_00000078765463053155197830000001721938113721020569_);}\r\n\t.st49{clip-path:url(#SVGID_00000097490141940360178660000014608258079737605539_);}\r\n\t.st50{clip-path:url(#SVGID_00000144304717255060192560000004500974137756202164_);}\r\n\t.st51{clip-path:url(#SVGID_00000031894253890158842380000003075252394770725298_);}\r\n\t.st52{clip-path:url(#SVGID_00000137110431090051940100000014107692361968907707_);}\r\n\t.st53{clip-path:url(#SVGID_00000086655142021879043090000005028032671145128065_);}\r\n\t.st54{clip-path:url(#SVGID_00000037686955259046915210000017095683592805547170_);}\r\n\t.st55{clip-path:url(#SVGID_00000116951902120552614980000012979349549486510209_);}\r\n\t.st56{clip-path:url(#SVGID_00000034060754981203404250000005769383322455690368_);}\r\n\t.st57{clip-path:url(#SVGID_00000158024989585338684690000008823663494415191171_);}\r\n\t.st58{clip-path:url(#SVGID_00000168825843705567004260000006075112552719790015_);}\r\n\t.st59{clip-path:url(#SVGID_00000129911147403859144350000003206810322316731808_);}\r\n\t.st60{clip-path:url(#SVGID_00000114786030889651247480000012641063835197721786_);}\r\n\t\r\n\t\t.st61{clip-path:url(#SVGID_00000067206934602049023030000007316160414400688774_);fill:url(#SVGID_00000140732687638437052340000005557372667487317155_);}\r\n\t\r\n\t\t.st62{clip-path:url(#SVGID_00000003085622166793402860000016414276031157987225_);mask:url(#SVGID_00000145039375900570916100000016106559278132189604_);fill:url(#SVGID_00000131327793891484537360000004732232239378459785_);}\r\n\t.st63{fill:url(#SVGID_00000116943332030236479580000017275568022267768204_);}\r\n\t.st64{clip-path:url(#SVGID_00000002348639112359995490000017299428256891098795_);}\r\n\t.st65{filter:url(#Adobe_OpacityMaskFilter_00000026158479683279207040000015824516252201809596_);}\r\n\t.st66{clip-path:url(#SVGID_00000029726744311746976100000000487673703746314368_);}\r\n\t.st67{clip-path:url(#SVGID_00000062898878068943210260000005529228231568979891_);}\r\n\t.st68{clip-path:url(#SVGID_00000100361180087653180360000003298711450826351773_);}\r\n\t.st69{clip-path:url(#SVGID_00000013876580093557208770000017713832781227181480_);}\r\n\t.st70{clip-path:url(#SVGID_00000041285769625264111340000006816066852729617819_);}\r\n\t.st71{clip-path:url(#SVGID_00000060017546106834145910000015845697644203414714_);}\r\n\t.st72{clip-path:url(#SVGID_00000129926559787654674060000005035748554121324945_);}\r\n\t.st73{clip-path:url(#SVGID_00000065789392319982766580000017613878924381218198_);}\r\n\t.st74{clip-path:url(#SVGID_00000147905586009448456600000008318303329398678173_);}\r\n\t.st75{clip-path:url(#SVGID_00000052070826833005086610000006390414718299503495_);}\r\n\t.st76{clip-path:url(#SVGID_00000167378973575349975340000007937842130378968508_);}\r\n\t.st77{clip-path:url(#SVGID_00000064323509303476635480000000285426395723915667_);}\r\n\t.st78{clip-path:url(#SVGID_00000176029838972570110880000018138634881932780960_);}\r\n\t.st79{clip-path:url(#SVGID_00000051366495791053628460000002389647445100377274_);}\r\n\t.st80{clip-path:url(#SVGID_00000139974396746781373270000011300291711272936359_);}\r\n\t.st81{clip-path:url(#SVGID_00000043427300388012673800000000044792946789948311_);}\r\n\t.st82{clip-path:url(#SVGID_00000084523050071515122610000011950356028594494863_);}\r\n\t.st83{clip-path:url(#SVGID_00000066493912503937505380000017860645121851923329_);}\r\n\t.st84{clip-path:url(#SVGID_00000106140390125794782100000014553557121842871183_);}\r\n\t.st85{clip-path:url(#SVGID_00000155830266226871295050000004314839647594121856_);}\r\n\t.st86{clip-path:url(#SVGID_00000111164552702248635810000009180471330809731773_);}\r\n\t.st87{clip-path:url(#SVGID_00000092455124478753782440000015604768153068425132_);}\r\n\t.st88{clip-path:url(#SVGID_00000056385316175495495130000004994227570787588992_);}\r\n\t.st89{clip-path:url(#SVGID_00000132774365808769786150000011139725914051948691_);}\r\n\t.st90{clip-path:url(#SVGID_00000134954654217021508950000013587475048086179994_);}\r\n\t\r\n\t\t.st91{clip-path:url(#SVGID_00000145030405483011771890000006437135701325564583_);fill:url(#SVGID_00000080198685023365470270000017650585725797459105_);}\r\n\t\r\n\t\t.st92{clip-path:url(#SVGID_00000029726744311746976100000000487673703746314368_);mask:url(#SVGID_00000086671477949970161480000017292391517292546231_);fill:url(#SVGID_00000058553937193711019190000015550638990882257084_);}\r\n\t.st93{fill:url(#SVGID_00000147908807909477378310000013227663537444677012_);}\r\n\t.st94{fill:url(#SVGID_00000027605465109822408100000012304964081875701671_);}\r\n\t.st95{fill:url(#SVGID_00000062902352764129884240000016418990839905723046_);}\r\n\t.st96{fill:url(#SVGID_00000131350536056621103440000005070020360610481043_);}\r\n\t.st97{clip-path:url(#SVGID_00000140706935087173467030000006360435916530231941_);}\r\n\t.st98{filter:url(#Adobe_OpacityMaskFilter_00000030483642140726994760000016547863883060627864_);}\r\n\t.st99{clip-path:url(#SVGID_00000154420613557201962540000017220429089580298891_);}\r\n\t.st100{clip-path:url(#SVGID_00000011745958565963204240000011023378241216263847_);}\r\n\t.st101{clip-path:url(#SVGID_00000015323595869338668850000000794262854529534647_);}\r\n\t.st102{clip-path:url(#SVGID_00000170974725468419300420000009481615161886613684_);}\r\n\t.st103{clip-path:url(#SVGID_00000134248708764014497120000017916673337141223827_);}\r\n\t.st104{clip-path:url(#SVGID_00000140009907957555457080000014202573218605287300_);}\r\n\t.st105{clip-path:url(#SVGID_00000056386367324713061550000005883499482843160740_);}\r\n\t.st106{clip-path:url(#SVGID_00000049902218888891935920000018272396261684067969_);}\r\n\t.st107{clip-path:url(#SVGID_00000076592177590166072170000005326383157654950038_);}\r\n\t.st108{clip-path:url(#SVGID_00000071560564534957692180000002455108442248008584_);}\r\n\t.st109{clip-path:url(#SVGID_00000109004120950475645270000001930416252917163690_);}\r\n\t.st110{clip-path:url(#SVGID_00000093162718957274327920000015863328082003053759_);}\r\n\t.st111{clip-path:url(#SVGID_00000000929709869309493540000013207962922879358348_);}\r\n\t.st112{clip-path:url(#SVGID_00000140712780652204934840000001442638053268640133_);}\r\n\t.st113{clip-path:url(#SVGID_00000053531014007147891870000018075318679224191629_);}\r\n\t.st114{clip-path:url(#SVGID_00000013187148357430531040000018139372868110894521_);}\r\n\t.st115{clip-path:url(#SVGID_00000045588915385765318610000014951123083777938318_);}\r\n\t.st116{clip-path:url(#SVGID_00000001647655574250116750000015721129325512806798_);}\r\n\t.st117{clip-path:url(#SVGID_00000135691513131706212700000001657934294721739963_);}\r\n\t.st118{clip-path:url(#SVGID_00000122693999716941731250000016476322164801663671_);}\r\n\t.st119{clip-path:url(#SVGID_00000016767892950348551860000013880626007225284761_);}\r\n\t.st120{clip-path:url(#SVGID_00000080896520607174397900000016855513246606291864_);}\r\n\t.st121{clip-path:url(#SVGID_00000174575092528825476710000009111780910014998934_);}\r\n\t.st122{clip-path:url(#SVGID_00000092431405112391794920000012817316243035103652_);}\r\n\t.st123{clip-path:url(#SVGID_00000183947659046575062730000016597071587610166450_);}\r\n\t\r\n\t\t.st124{clip-path:url(#SVGID_00000016050664880079778320000002076133292861743745_);fill:url(#SVGID_00000143583779465636824690000011805525975450478489_);}\r\n\t\r\n\t\t.st125{clip-path:url(#SVGID_00000154420613557201962540000017220429089580298891_);mask:url(#SVGID_00000038403602023882672620000013071550106691496104_);fill:url(#SVGID_00000015355415540726007450000002894647427427751609_);}\r\n\t.st126{clip-path:url(#SVGID_00000117664642955019225680000004732251469259409333_);}\r\n\t.st127{filter:url(#Adobe_OpacityMaskFilter_00000085962834947061772460000004474103300387333052_);}\r\n\t.st128{clip-path:url(#SVGID_00000010307769586501138450000000222984386193450117_);}\r\n\t.st129{clip-path:url(#SVGID_00000096039351477875020180000012104717678062243512_);}\r\n\t.st130{clip-path:url(#SVGID_00000042724094562561223520000008645327939269940884_);}\r\n\t.st131{clip-path:url(#SVGID_00000003827566460837290290000013122851339937331091_);}\r\n\t.st132{clip-path:url(#SVGID_00000028317091323322537500000014716271157346139812_);}\r\n\t.st133{clip-path:url(#SVGID_00000061462873554110392660000000122737907992213936_);}\r\n\t.st134{clip-path:url(#SVGID_00000163767155150302242080000006534281274436938670_);}\r\n\t.st135{clip-path:url(#SVGID_00000166648415056534730990000000250182344063282066_);}\r\n\t.st136{clip-path:url(#SVGID_00000102506705985323149810000015798106374687014543_);}\r\n\t.st137{clip-path:url(#SVGID_00000180350314150548209120000001146198661775460230_);}\r\n\t.st138{clip-path:url(#SVGID_00000116223282439814724040000013628542993556228027_);}\r\n\t.st139{clip-path:url(#SVGID_00000015322536458484750630000000650964172306224262_);}\r\n\t.st140{clip-path:url(#SVGID_00000165941588610521309880000003350772762591077564_);}\r\n\t.st141{clip-path:url(#SVGID_00000180354179413153223700000012388757128400264116_);}\r\n\t.st142{clip-path:url(#SVGID_00000062898233231659130400000017229779522623846577_);}\r\n\t.st143{clip-path:url(#SVGID_00000171691265613701457600000004150566654004285568_);}\r\n\t.st144{clip-path:url(#SVGID_00000181077242564320686000000009047973700405965758_);}\r\n\t.st145{clip-path:url(#SVGID_00000135672329126290228370000001577497415856975778_);}\r\n\t.st146{clip-path:url(#SVGID_00000087409546075899682360000011336590070963101340_);}\r\n\t.st147{clip-path:url(#SVGID_00000078003626042788405610000001319936057771121329_);}\r\n\t.st148{clip-path:url(#SVGID_00000136371964330609259870000000301163107937228714_);}\r\n\t.st149{clip-path:url(#SVGID_00000081624537095124456250000000048371629680065672_);}\r\n\t.st150{clip-path:url(#SVGID_00000008854704022152688890000011390721905437925310_);}\r\n\t.st151{clip-path:url(#SVGID_00000035516729022686039060000008759516209769158316_);}\r\n\t.st152{clip-path:url(#SVGID_00000023959723642462782440000002551996110864150162_);}\r\n\t\r\n\t\t.st153{clip-path:url(#SVGID_00000013894933971666938150000006299586675954830743_);fill:url(#SVGID_00000037668239536215843540000000391690453809548717_);}\r\n\t\r\n\t\t.st154{clip-path:url(#SVGID_00000010307769586501138450000000222984386193450117_);mask:url(#SVGID_00000094579118633890923690000005376697554863416983_);fill:url(#SVGID_00000076574897066657045510000017007328190002139817_);}\r\n\t.st155{opacity:0.48;fill:url(#SVGID_00000150804777624843121610000000345411634469514635_);enable-background:new    ;}\r\n\t.st156{fill:url(#SVGID_00000152964399424536919960000005138299699135286951_);}\r\n\t.st157{fill:url(#SVGID_00000045603464121201761220000001124175535925530772_);}\r\n\t.st158{clip-path:url(#SVGID_00000042709365928336227340000012230080718242382777_);}\r\n\t.st159{filter:url(#Adobe_OpacityMaskFilter_00000069370955358995093910000015145163728433230753_);}\r\n\t.st160{clip-path:url(#SVGID_00000169545148232665951310000009050726199741486741_);}\r\n\t.st161{clip-path:url(#SVGID_00000088835355456984217050000014904635764416241555_);}\r\n\t.st162{clip-path:url(#SVGID_00000116938891820227463940000016613978219956801206_);}\r\n\t.st163{clip-path:url(#SVGID_00000176748088864619847240000014967753623692331692_);}\r\n\t.st164{clip-path:url(#SVGID_00000148619238497885290460000004035659636866481820_);}\r\n\t.st165{clip-path:url(#SVGID_00000012447002164910638040000015434218320976673445_);}\r\n\t.st166{clip-path:url(#SVGID_00000101085084302283706760000015964664143109738652_);}\r\n\t.st167{clip-path:url(#SVGID_00000165933877872843612110000012230126176029373629_);}\r\n\t.st168{clip-path:url(#SVGID_00000071546648242932580560000000096374366845416359_);}\r\n\t.st169{clip-path:url(#SVGID_00000029044531301644412010000012463395539785370777_);}\r\n\t.st170{clip-path:url(#SVGID_00000078743647880578923830000011305833178213405093_);}\r\n\t.st171{clip-path:url(#SVGID_00000141430468897047295690000015445625176809550771_);}\r\n\t.st172{clip-path:url(#SVGID_00000065076651491607066790000018002570283991422100_);}\r\n\t.st173{clip-path:url(#SVGID_00000014614753467288176410000009078560481258148542_);}\r\n\t.st174{clip-path:url(#SVGID_00000013172861491561059260000002075625905742996660_);}\r\n\t.st175{clip-path:url(#SVGID_00000145055835754754842640000005157017357274694785_);}\r\n\t.st176{clip-path:url(#SVGID_00000050659798415510885160000009720938453947137943_);}\r\n\t.st177{clip-path:url(#SVGID_00000160179840019023417940000000742427981051012770_);}\r\n\t.st178{clip-path:url(#SVGID_00000163042356802639162980000017351383807771696575_);}\r\n\t.st179{clip-path:url(#SVGID_00000168827168269210578000000012888135036489022852_);}\r\n\t.st180{clip-path:url(#SVGID_00000097487721803278827310000003708605704905390996_);}\r\n\t.st181{clip-path:url(#SVGID_00000071524860176855707900000002233631141161138060_);}\r\n\t.st182{clip-path:url(#SVGID_00000126309455562749319890000003522845637556452224_);}\r\n\t.st183{clip-path:url(#SVGID_00000165237050168255534400000003807990178038532270_);}\r\n\t.st184{clip-path:url(#SVGID_00000102532896715180882470000014610809813356634545_);}\r\n\t\r\n\t\t.st185{clip-path:url(#SVGID_00000078036910349577448010000014365654945610137533_);fill:url(#SVGID_00000003102025077377272990000017220313505707423662_);}\r\n\t\r\n\t\t.st186{clip-path:url(#SVGID_00000169545148232665951310000009050726199741486741_);mask:url(#SVGID_00000100380826706935040680000015462664244254026657_);fill:url(#SVGID_00000104679100433678414150000010939323558585255335_);}\r\n\t.st187{fill:url(#SVGID_00000034066639196585101070000001289235995625080254_);}\r\n\t.st188{fill:url(#SVGID_00000062898895637329971740000011571086470976711315_);}\r\n\t.st189{fill:url(#SVGID_00000044137114143165878830000010621697105014875787_);}\r\n\t.st190{clip-path:url(#SVGID_00000073703103549198913020000015881387209042930817_);}\r\n\t.st191{filter:url(#Adobe_OpacityMaskFilter_00000086650091341116172180000011734360821706348180_);}\r\n\t.st192{clip-path:url(#SVGID_00000065766559347917211580000006825895713544382380_);}\r\n\t.st193{clip-path:url(#SVGID_00000072272035543618246670000011908467508114209161_);}\r\n\t.st194{clip-path:url(#SVGID_00000132772641127245056950000013550050840649825705_);}\r\n\t.st195{clip-path:url(#SVGID_00000155863399766859400850000011769052860531262082_);}\r\n\t.st196{clip-path:url(#SVGID_00000101096679719765274020000014561198735639591808_);}\r\n\t.st197{clip-path:url(#SVGID_00000057107224669187738570000006087433332970455437_);}\r\n\t.st198{clip-path:url(#SVGID_00000047751371326942831030000017604103027850247329_);}\r\n\t.st199{clip-path:url(#SVGID_00000164511445130309068740000013541564825901868934_);}\r\n\t.st200{clip-path:url(#SVGID_00000162327168615315918780000002968340335069198751_);}\r\n\t.st201{clip-path:url(#SVGID_00000049211974448457444620000018212246027395866780_);}\r\n\t.st202{clip-path:url(#SVGID_00000123435006675997798970000006128171887146738062_);}\r\n\t.st203{clip-path:url(#SVGID_00000142877958293583585480000013004512373242565039_);}\r\n\t.st204{clip-path:url(#SVGID_00000008126991998851832020000012562232159600508037_);}\r\n\t.st205{clip-path:url(#SVGID_00000125579199583112338510000013505629367688622263_);}\r\n\t.st206{clip-path:url(#SVGID_00000096751819508245689300000009555032305441954457_);}\r\n\t.st207{clip-path:url(#SVGID_00000162339962737715274690000000960293966072080791_);}\r\n\t.st208{clip-path:url(#SVGID_00000106869002050173408110000010156348288831924900_);}\r\n\t.st209{clip-path:url(#SVGID_00000059991851517844189040000009217974001349775281_);}\r\n\t.st210{clip-path:url(#SVGID_00000167370579763087550780000013886636737461393569_);}\r\n\t.st211{clip-path:url(#SVGID_00000010286642796139691080000013315296350447066024_);}\r\n\t.st212{clip-path:url(#SVGID_00000127023703792057257850000000266729795018640514_);}\r\n\t.st213{clip-path:url(#SVGID_00000067933474569769602930000009194704347978405784_);}\r\n\t.st214{clip-path:url(#SVGID_00000156561000739007046970000002291737788237093275_);}\r\n\t.st215{clip-path:url(#SVGID_00000065763217473592283480000007858757491223456128_);}\r\n\t.st216{clip-path:url(#SVGID_00000020397363818759765630000013999804261825887648_);}\r\n\t\r\n\t\t.st217{clip-path:url(#SVGID_00000116919891409402306270000002069641662213177250_);fill:url(#SVGID_00000052100877374584870430000013195528204604858779_);}\r\n\t\r\n\t\t.st218{clip-path:url(#SVGID_00000065766559347917211580000006825895713544382380_);mask:url(#SVGID_00000179616600317074372900000004251686568948989353_);fill:url(#SVGID_00000036950294798310881240000007795871049516722871_);}\r\n\t.st219{opacity:0.48;fill:url(#SVGID_00000127759925445672862020000014339504992488421803_);enable-background:new    ;}\r\n\t.st220{clip-path:url(#SVGID_00000097471910514036593520000011820649954453960891_);}\r\n\t.st221{filter:url(#Adobe_OpacityMaskFilter_00000000916949625392946770000012991307222298853815_);}\r\n\t.st222{clip-path:url(#SVGID_00000180345271222884656790000015178967845191697288_);}\r\n\t.st223{clip-path:url(#SVGID_00000039132646381124563840000010232114805434090935_);}\r\n\t.st224{clip-path:url(#SVGID_00000129201301807411017270000016597444595114905017_);}\r\n\t.st225{clip-path:url(#SVGID_00000057109798337826282210000014250353038284090509_);}\r\n\t.st226{clip-path:url(#SVGID_00000136413334629924083150000010875915636074661039_);}\r\n\t.st227{clip-path:url(#SVGID_00000151515413936495688460000005197485552217796513_);}\r\n\t.st228{clip-path:url(#SVGID_00000112599790119673793910000013502240956107872135_);}\r\n\t.st229{clip-path:url(#SVGID_00000027571446735732434810000016473940113092344511_);}\r\n\t.st230{clip-path:url(#SVGID_00000173123826357618629740000003044129189944576896_);}\r\n\t.st231{clip-path:url(#SVGID_00000096743110582140014740000002640487493627701948_);}\r\n\t.st232{clip-path:url(#SVGID_00000129895500699381215720000005551343268566010806_);}\r\n\t.st233{clip-path:url(#SVGID_00000005958050438155538720000011296788253426406079_);}\r\n\t.st234{clip-path:url(#SVGID_00000072247342434593102230000000505986859931502222_);}\r\n\t.st235{clip-path:url(#SVGID_00000020374087401948176840000007625165845246422423_);}\r\n\t.st236{clip-path:url(#SVGID_00000152949449551149242150000013395104624748564646_);}\r\n\t.st237{clip-path:url(#SVGID_00000026862850621264138500000007243625397393024959_);}\r\n\t.st238{clip-path:url(#SVGID_00000082347145363172309650000016582036363317853570_);}\r\n\t.st239{clip-path:url(#SVGID_00000053506448263787717020000003972948625295932061_);}\r\n\t.st240{clip-path:url(#SVGID_00000085224902393499952970000004714399548922900874_);}\r\n\t.st241{clip-path:url(#SVGID_00000119822111412753866780000010606680889443403402_);}\r\n\t.st242{clip-path:url(#SVGID_00000135673545488817866980000014090409140563529616_);}\r\n\t.st243{clip-path:url(#SVGID_00000029003253347947631720000008976535757395230647_);}\r\n\t.st244{clip-path:url(#SVGID_00000003784084285317344380000008018902733676213402_);}\r\n\t.st245{clip-path:url(#SVGID_00000003813427713632344360000001755593917820808887_);}\r\n\t.st246{clip-path:url(#SVGID_00000015322685408502339530000002340114447780991927_);}\r\n\t\r\n\t\t.st247{clip-path:url(#SVGID_00000102544561633000099060000001022922722542642099_);fill:url(#SVGID_00000078756216207329574490000015909193559650468784_);}\r\n\t\r\n\t\t.st248{clip-path:url(#SVGID_00000180345271222884656790000015178967845191697288_);mask:url(#SVGID_00000172435514997990265230000013660528500153627050_);fill:url(#SVGID_00000020356482194104721030000014169898969010220216_);}\r\n\t.st249{opacity:0.48;fill:url(#SVGID_00000030472220580333461200000012075245196492534405_);enable-background:new    ;}\r\n\t.st250{fill:url(#SVGID_00000047747693055939657620000003411871149224775838_);}\r\n\t.st251{fill:url(#SVGID_00000031198835579626257800000006553301288191585161_);}\r\n\t.st252{fill:url(#SVGID_00000098203076041296255500000002131776526261219514_);}\r\n\t.st253{fill:url(#SVGID_00000018225001065968392320000004160069401649193645_);}\r\n\t.st254{clip-path:url(#SVGID_00000091731817889217729980000013573462190724803502_);}\r\n\t.st255{filter:url(#Adobe_OpacityMaskFilter_00000061464596176220350810000013537913236446466451_);}\r\n\t.st256{clip-path:url(#SVGID_00000129169994576181441800000012780550695463424128_);}\r\n\t.st257{clip-path:url(#SVGID_00000147181836009157694970000002538301039063059898_);}\r\n\t.st258{clip-path:url(#SVGID_00000139982295638437876760000017839226244026749847_);}\r\n\t.st259{clip-path:url(#SVGID_00000136397176820377497640000002293872320114901691_);}\r\n\t.st260{clip-path:url(#SVGID_00000183237466111999766440000013518856143078629015_);}\r\n\t.st261{clip-path:url(#SVGID_00000109023319644992125490000016892725789288213121_);}\r\n\t.st262{clip-path:url(#SVGID_00000147922794445211458870000016501611553858969784_);}\r\n\t.st263{clip-path:url(#SVGID_00000152259468568770188360000003093525271936826804_);}\r\n\t.st264{clip-path:url(#SVGID_00000052086662199524349880000017744396903952448652_);}\r\n\t.st265{clip-path:url(#SVGID_00000018229264277731322580000008787672339204674233_);}\r\n\t.st266{clip-path:url(#SVGID_00000183957815746330718970000015404934628465129389_);}\r\n\t.st267{clip-path:url(#SVGID_00000172440589683056006590000013933067058431616438_);}\r\n\t.st268{clip-path:url(#SVGID_00000081624974110524884200000009774530905696195466_);}\r\n\t.st269{clip-path:url(#SVGID_00000018195068235720844690000013841764846371544988_);}\r\n\t.st270{clip-path:url(#SVGID_00000066517469678129400830000015283491122097041077_);}\r\n\t.st271{clip-path:url(#SVGID_00000075158192636427214400000017852001097815233671_);}\r\n\t.st272{clip-path:url(#SVGID_00000033333965352989281340000003256990987793750681_);}\r\n\t.st273{clip-path:url(#SVGID_00000158004947647395715360000000560207794538129829_);}\r\n\t.st274{clip-path:url(#SVGID_00000005262007676677951290000007125590174424431536_);}\r\n\t.st275{clip-path:url(#SVGID_00000009571665888653274830000009941354617121123244_);}\r\n\t.st276{clip-path:url(#SVGID_00000030470733893266780300000016551952220520866950_);}\r\n\t.st277{clip-path:url(#SVGID_00000056403777638053594100000008730155106919028113_);}\r\n\t.st278{clip-path:url(#SVGID_00000112627476840292284160000011828565503675049865_);}\r\n\t.st279{clip-path:url(#SVGID_00000138532764965728598180000012713048406881960621_);}\r\n\t.st280{clip-path:url(#SVGID_00000097467551350022846290000005555706393737515953_);}\r\n\t\r\n\t\t.st281{clip-path:url(#SVGID_00000022561788842077147620000011386025353488426424_);fill:url(#SVGID_00000142177516846377164340000004285482418021063299_);}\r\n\t\r\n\t\t.st282{clip-path:url(#SVGID_00000129169994576181441800000012780550695463424128_);mask:url(#SVGID_00000011024488671851050180000006095091450528520113_);fill:url(#SVGID_00000108282713289862545690000010917410131904399242_);}\r\n\t.st283{clip-path:url(#SVGID_00000141438780231275128010000000698055235568634776_);}\r\n\t.st284{filter:url(#Adobe_OpacityMaskFilter_00000044167774758857035300000003011946116476999045_);}\r\n\t.st285{clip-path:url(#SVGID_00000134934332618810278850000001655020049403767943_);}\r\n\t.st286{clip-path:url(#SVGID_00000060028315626530407880000005549042002515457931_);}\r\n\t.st287{clip-path:url(#SVGID_00000018942866885266959520000008935973316482678941_);}\r\n\t.st288{clip-path:url(#SVGID_00000160872118082292299080000001365053076053118127_);}\r\n\t.st289{clip-path:url(#SVGID_00000126306899114587577050000018274637522169216438_);}\r\n\t.st290{clip-path:url(#SVGID_00000037662505728243404660000017067611137447337147_);}\r\n\t.st291{clip-path:url(#SVGID_00000165204800712056319370000010847943620797919122_);}\r\n\t.st292{clip-path:url(#SVGID_00000119115197634740103880000010423507690014688643_);}\r\n\t.st293{clip-path:url(#SVGID_00000138545232243641924270000016454412905766792382_);}\r\n\t.st294{clip-path:url(#SVGID_00000065758635978649075510000012634098344580128934_);}\r\n\t.st295{clip-path:url(#SVGID_00000110470193219328879090000008031665663104217240_);}\r\n\t.st296{clip-path:url(#SVGID_00000016757237414829631580000013099487454884642474_);}\r\n\t.st297{clip-path:url(#SVGID_00000181768504918368245850000001148285686543090599_);}\r\n\t.st298{clip-path:url(#SVGID_00000132774310294322334890000015390063859189556906_);}\r\n\t.st299{clip-path:url(#SVGID_00000176725559912473271520000013932589718500905895_);}\r\n\t.st300{clip-path:url(#SVGID_00000179623742461993965840000014673794513980640190_);}\r\n\t.st301{clip-path:url(#SVGID_00000127726837890629158800000006298013630304729268_);}\r\n\t.st302{clip-path:url(#SVGID_00000143612694068542841430000009360689202966697616_);}\r\n\t.st303{clip-path:url(#SVGID_00000153687462582985616630000010264057144450958765_);}\r\n\t.st304{clip-path:url(#SVGID_00000098911443104135758260000005054105418771340174_);}\r\n\t.st305{clip-path:url(#SVGID_00000173855073615279908440000006752065987289713824_);}\r\n\t.st306{clip-path:url(#SVGID_00000121276710570085499700000014403045114702222743_);}\r\n\t.st307{clip-path:url(#SVGID_00000159447925931795331120000006551664879311768718_);}\r\n\t.st308{clip-path:url(#SVGID_00000007406585381087130060000014409192356824824704_);}\r\n\t.st309{clip-path:url(#SVGID_00000132081901756971605850000003403681035670873995_);}\r\n\t\r\n\t\t.st310{clip-path:url(#SVGID_00000063627931537542375640000001574442488068085426_);fill:url(#SVGID_00000027580289547088455350000014158741054979619484_);}\r\n\t\r\n\t\t.st311{clip-path:url(#SVGID_00000134934332618810278850000001655020049403767943_);mask:url(#SVGID_00000062904498422152936080000001791277987459333050_);fill:url(#SVGID_00000153694598898184217680000001869386038416390334_);}\r\n\t.st312{fill:url(#SVGID_00000023964837706001716340000012472511263217609367_);}\r\n\t.st313{clip-path:url(#SVGID_00000020360438502533092360000005953906473396528257_);}\r\n\t.st314{filter:url(#Adobe_OpacityMaskFilter_00000011732784043830812740000014923748387345081529_);}\r\n\t.st315{clip-path:url(#SVGID_00000183227235124304831740000015283740495932485539_);}\r\n\t.st316{clip-path:url(#SVGID_00000034806011524311133560000016642745271376930982_);}\r\n\t.st317{clip-path:url(#SVGID_00000040539147760834871790000018115871584606299535_);}\r\n\t.st318{clip-path:url(#SVGID_00000134248504171387357010000004556310608016136110_);}\r\n\t.st319{clip-path:url(#SVGID_00000041271566865079777680000014432949334328481433_);}\r\n\t.st320{clip-path:url(#SVGID_00000060001947888244988800000012950733660350911933_);}\r\n\t.st321{clip-path:url(#SVGID_00000062872506415360573200000005723911380184592564_);}\r\n\t.st322{clip-path:url(#SVGID_00000183939941575833337650000008075854457865467057_);}\r\n\t.st323{clip-path:url(#SVGID_00000057106409343573911470000009558189274008894653_);}\r\n\t.st324{clip-path:url(#SVGID_00000092458177798794101070000017971522234926472862_);}\r\n\t.st325{clip-path:url(#SVGID_00000041993247676042893060000001471687924089110913_);}\r\n\t.st326{clip-path:url(#SVGID_00000168075654407343912340000006284391313828774325_);}\r\n\t.st327{clip-path:url(#SVGID_00000101790160464578771530000010517767853147751565_);}\r\n\t.st328{clip-path:url(#SVGID_00000066490692180744989620000003349116030631982981_);}\r\n\t.st329{clip-path:url(#SVGID_00000013871217365881498260000017260343509388744859_);}\r\n\t.st330{clip-path:url(#SVGID_00000180341567237736383400000000855194674101407622_);}\r\n\t.st331{clip-path:url(#SVGID_00000127737972968970656420000010582286202466732932_);}\r\n\t.st332{clip-path:url(#SVGID_00000005243374413827202090000002612035682413798557_);}\r\n\t.st333{clip-path:url(#SVGID_00000142149961058502561420000018430645468182012350_);}\r\n\t.st334{clip-path:url(#SVGID_00000032608834741481385640000003234551001464392600_);}\r\n\t.st335{clip-path:url(#SVGID_00000034068482590341413790000002154864196402751676_);}\r\n\t.st336{clip-path:url(#SVGID_00000146501476475024969340000000229343498665276575_);}\r\n\t.st337{clip-path:url(#SVGID_00000114047596786182697010000016518356454083430306_);}\r\n\t.st338{clip-path:url(#SVGID_00000089554049359689370410000010850515635573749889_);}\r\n\t.st339{clip-path:url(#SVGID_00000177469099850074625790000010340872467276175021_);}\r\n\t\r\n\t\t.st340{clip-path:url(#SVGID_00000112611290175801892850000009257964578573618606_);fill:url(#SVGID_00000133511006389537484720000013021983390746387596_);}\r\n\t\r\n\t\t.st341{clip-path:url(#SVGID_00000183227235124304831740000015283740495932485539_);mask:url(#SVGID_00000129906697429501440260000012177575606192798911_);fill:url(#SVGID_00000155115083370989934520000005171254376215912889_);}\r\n\t.st342{fill:url(#SVGID_00000052076451250654304210000016770023325957067192_);}\r\n\t.st343{fill:url(#SVGID_00000054223743447671582170000000935442980310984633_);}\r\n\t.st344{fill:url(#SVGID_00000005266438963094216700000013672165420702772409_);}\r\n\t.st345{fill:url(#SVGID_00000061437859496334747600000008010662733728994463_);}\r\n\t.st346{clip-path:url(#SVGID_00000150811874942136268110000005158392464042743693_);}\r\n\t.st347{filter:url(#Adobe_OpacityMaskFilter_00000002385787379795856740000000090399130673659540_);}\r\n\t.st348{clip-path:url(#SVGID_00000094598970990712917090000009830070233134233246_);}\r\n\t.st349{clip-path:url(#SVGID_00000170993479255687377890000008115452517097923712_);}\r\n\t.st350{clip-path:url(#SVGID_00000133515793078801553270000002632014375322987149_);}\r\n\t.st351{clip-path:url(#SVGID_00000168106436992969756300000017905017398859740033_);}\r\n\t.st352{clip-path:url(#SVGID_00000017514783445683509180000011112813983963311021_);}\r\n\t.st353{clip-path:url(#SVGID_00000083776302641319807800000002094878407307948164_);}\r\n\t.st354{clip-path:url(#SVGID_00000066473406752719388220000017633546513887648959_);}\r\n\t.st355{clip-path:url(#SVGID_00000102509786831523855070000002770723985938550913_);}\r\n\t.st356{clip-path:url(#SVGID_00000124882540354973415950000014094250973264990899_);}\r\n\t.st357{clip-path:url(#SVGID_00000069370508947584742110000001514566216113262752_);}\r\n\t.st358{clip-path:url(#SVGID_00000008869989433107878150000009120270417028020623_);}\r\n\t.st359{clip-path:url(#SVGID_00000041285072796484309150000018186414707209303958_);}\r\n\t.st360{clip-path:url(#SVGID_00000176023305292058385980000013961360916907287477_);}\r\n\t.st361{clip-path:url(#SVGID_00000034058606924278438730000009646319775255687065_);}\r\n\t.st362{clip-path:url(#SVGID_00000081617176854872916600000017052175700281636236_);}\r\n\t.st363{clip-path:url(#SVGID_00000048462094307357595010000013365267102792184474_);}\r\n\t.st364{clip-path:url(#SVGID_00000071550708017268355990000001201921356734312080_);}\r\n\t.st365{clip-path:url(#SVGID_00000054962598443639020910000000093184429718838200_);}\r\n\t.st366{clip-path:url(#SVGID_00000129207855290894727600000006351165541123284143_);}\r\n\t.st367{clip-path:url(#SVGID_00000151542611729848119310000009285869253673848980_);}\r\n\t.st368{clip-path:url(#SVGID_00000000912410813715011800000005678494496170141606_);}\r\n\t.st369{clip-path:url(#SVGID_00000101824547636181509240000010789682183060507830_);}\r\n\t.st370{clip-path:url(#SVGID_00000172424572825367944550000005809661556305704838_);}\r\n\t.st371{clip-path:url(#SVGID_00000140727181844559208630000001922595739588930742_);}\r\n\t.st372{clip-path:url(#SVGID_00000114780539848934440200000018438293796902008237_);}\r\n\t\r\n\t\t.st373{clip-path:url(#SVGID_00000167356427858150767440000004961040992221053361_);fill:url(#SVGID_00000158706964147665133210000002658568359703477948_);}\r\n\t\r\n\t\t.st374{clip-path:url(#SVGID_00000094598970990712917090000009830070233134233246_);mask:url(#SVGID_00000065761686033015311660000016149903317097060276_);fill:url(#SVGID_00000182519704610890398910000018115250251764362379_);}\r\n\t.st375{clip-path:url(#SVGID_00000044164631306199853480000007107956912609984141_);}\r\n\t.st376{filter:url(#Adobe_OpacityMaskFilter_00000057118893940613977580000014626511606354040714_);}\r\n\t.st377{clip-path:url(#SVGID_00000010269180146264353040000011745064407341208978_);}\r\n\t.st378{clip-path:url(#SVGID_00000054255869269399614400000015262652414804461231_);}\r\n\t.st379{clip-path:url(#SVGID_00000016034434540940787760000015575998633728422034_);}\r\n\t.st380{clip-path:url(#SVGID_00000040552730187806342480000016283044711483200436_);}\r\n\t.st381{clip-path:url(#SVGID_00000107562825253254575250000009780753670097085592_);}\r\n\t.st382{clip-path:url(#SVGID_00000181054738126848089830000015748307807434766999_);}\r\n\t.st383{clip-path:url(#SVGID_00000061455822895353694600000001179479276397583024_);}\r\n\t.st384{clip-path:url(#SVGID_00000060733355626476833870000004045922656440172721_);}\r\n\t.st385{clip-path:url(#SVGID_00000047752730750290794180000009303954552543793570_);}\r\n\t.st386{clip-path:url(#SVGID_00000076598515182355460520000010587667101017737132_);}\r\n\t.st387{clip-path:url(#SVGID_00000055671418470121657890000012808014555904896424_);}\r\n\t.st388{clip-path:url(#SVGID_00000000203414170858547030000016559282085319027115_);}\r\n\t.st389{clip-path:url(#SVGID_00000081611013352333896040000015246608312735704194_);}\r\n\t.st390{clip-path:url(#SVGID_00000150819349295389516040000012773162129565515444_);}\r\n\t.st391{clip-path:url(#SVGID_00000142878726385442146520000012591118627650881434_);}\r\n\t.st392{clip-path:url(#SVGID_00000026870150165671804670000005760317543756636309_);}\r\n\t.st393{clip-path:url(#SVGID_00000027599515900674910490000012678985740072063664_);}\r\n\t.st394{clip-path:url(#SVGID_00000081627910994065689320000006949330461280150708_);}\r\n\t.st395{clip-path:url(#SVGID_00000163752482405858391830000011523656014465570697_);}\r\n\t.st396{clip-path:url(#SVGID_00000137109615061456756180000002507279087201467791_);}\r\n\t.st397{clip-path:url(#SVGID_00000108276210387924223970000014513439309992204988_);}\r\n\t.st398{clip-path:url(#SVGID_00000096763453283157839650000011837549060898769065_);}\r\n\t.st399{clip-path:url(#SVGID_00000044161542228745809090000013993826514302128780_);}\r\n\t.st400{clip-path:url(#SVGID_00000101810647050590768820000017363717127040007867_);}\r\n\t.st401{clip-path:url(#SVGID_00000068649599733984476750000004072103248527351184_);}\r\n\t\r\n\t\t.st402{clip-path:url(#SVGID_00000035525545264277508300000008205985520432076959_);fill:url(#SVGID_00000054961460677360758080000009506746027774399900_);}\r\n\t\r\n\t\t.st403{clip-path:url(#SVGID_00000010269180146264353040000011745064407341208978_);mask:url(#SVGID_00000157303756271952430730000002227046807094341819_);fill:url(#SVGID_00000008107895108013104540000001607861639414313112_);}\r\n\t.st404{opacity:0.48;fill:url(#SVGID_00000036966375431951933420000005264171312135304576_);enable-background:new    ;}\r\n\t.st405{fill:url(#SVGID_00000005239441719156220630000005977629719367900832_);}\r\n\t.st406{fill:url(#SVGID_00000031173297504673468710000014586357326033064892_);}\r\n\t.st407{clip-path:url(#SVGID_00000127749916810334633670000008669091575140268939_);}\r\n\t.st408{filter:url(#Adobe_OpacityMaskFilter_00000019678605822410567920000013367938110061115274_);}\r\n\t.st409{clip-path:url(#SVGID_00000022521977026975776280000000678792934206834304_);}\r\n\t.st410{clip-path:url(#SVGID_00000083081497242645454360000008010971027621479850_);}\r\n\t.st411{clip-path:url(#SVGID_00000132079244885625780650000018215591869755798175_);}\r\n\t.st412{clip-path:url(#SVGID_00000138551995845824408890000002023120402137551500_);}\r\n\t.st413{clip-path:url(#SVGID_00000029004536649178410190000013024911287343853704_);}\r\n\t.st414{clip-path:url(#SVGID_00000069381853573488722420000017291103623352877957_);}\r\n\t.st415{clip-path:url(#SVGID_00000172431174746856281210000013922951890170369455_);}\r\n\t.st416{clip-path:url(#SVGID_00000121994268244183972890000016401372272945583800_);}\r\n\t.st417{clip-path:url(#SVGID_00000169526350290647706920000017436183647890412222_);}\r\n\t.st418{clip-path:url(#SVGID_00000161605606854514771270000017671262574374653827_);}\r\n\t.st419{clip-path:url(#SVGID_00000175315935365956692390000002739474281130868644_);}\r\n\t.st420{clip-path:url(#SVGID_00000081639316153387248780000015722036561341610895_);}\r\n\t.st421{clip-path:url(#SVGID_00000174571296204940597970000006021872277317182363_);}\r\n\t.st422{clip-path:url(#SVGID_00000005240695784757110520000013437850020549413256_);}\r\n\t.st423{clip-path:url(#SVGID_00000005989289458496805510000002041355815130113968_);}\r\n\t.st424{clip-path:url(#SVGID_00000040567537469899202120000012948381536262913194_);}\r\n\t.st425{clip-path:url(#SVGID_00000083788782791302351350000004714857101823999392_);}\r\n\t.st426{clip-path:url(#SVGID_00000047742298233916102070000002702122589821361847_);}\r\n\t.st427{clip-path:url(#SVGID_00000012463826671554849350000015028608865197596069_);}\r\n\t.st428{clip-path:url(#SVGID_00000120530100696365058150000016252797967366245538_);}\r\n\t.st429{clip-path:url(#SVGID_00000099623985423680179930000013181473773649032375_);}\r\n\t.st430{clip-path:url(#SVGID_00000124877702668456834800000004689675216992982951_);}\r\n\t.st431{clip-path:url(#SVGID_00000024001975198574892870000009771272685481060775_);}\r\n\t.st432{clip-path:url(#SVGID_00000110451055365264046750000014383817360684438714_);}\r\n\t.st433{clip-path:url(#SVGID_00000137127265222148470250000015009462507016366523_);}\r\n\t\r\n\t\t.st434{clip-path:url(#SVGID_00000042009248236244884990000014611520341764552881_);fill:url(#SVGID_00000024719697224401332280000009676125043326499501_);}\r\n\t\r\n\t\t.st435{clip-path:url(#SVGID_00000022521977026975776280000000678792934206834304_);mask:url(#SVGID_00000084504480041518429150000012038922080463095702_);fill:url(#SVGID_00000152259626855406824660000007484135122436668090_);}\r\n\t.st436{fill:url(#SVGID_00000098942876422721825830000013017268284598137218_);}\r\n\t.st437{fill:url(#SVGID_00000096778861457052393590000015231979224360299199_);}\r\n\t.st438{fill:url(#SVGID_00000115473069473922581480000001930036502470041502_);}\r\n\t.st439{clip-path:url(#SVGID_00000122686555655951142430000018316699051420523695_);}\r\n\t.st440{filter:url(#Adobe_OpacityMaskFilter_00000049217225964050166750000001585993672927222411_);}\r\n\t.st441{clip-path:url(#SVGID_00000107548726286513826530000017500688826727715482_);}\r\n\t.st442{clip-path:url(#SVGID_00000091717582161866105260000006335516479126761607_);}\r\n\t.st443{clip-path:url(#SVGID_00000125580157782554141660000016390388641866521479_);}\r\n\t.st444{clip-path:url(#SVGID_00000006676540577842716050000007865082403093588385_);}\r\n\t.st445{clip-path:url(#SVGID_00000060711629068522678130000012120900354532832670_);}\r\n\t.st446{clip-path:url(#SVGID_00000127760767573581055970000009166393901983316392_);}\r\n\t.st447{clip-path:url(#SVGID_00000062875647773993592080000008960910738389085580_);}\r\n\t.st448{clip-path:url(#SVGID_00000026849815449777026160000005177318187680036783_);}\r\n\t.st449{clip-path:url(#SVGID_00000168816130163161697750000011700936825974476967_);}\r\n\t.st450{clip-path:url(#SVGID_00000086666215428083365980000010880445749503223710_);}\r\n\t.st451{clip-path:url(#SVGID_00000169554038650988445530000005762909014577653138_);}\r\n\t.st452{clip-path:url(#SVGID_00000112605634910021268780000013473523599459090608_);}\r\n\t.st453{clip-path:url(#SVGID_00000054234856692493817920000018032542521732963248_);}\r\n\t.st454{clip-path:url(#SVGID_00000088120203162163576500000011129982235709712556_);}\r\n\t.st455{clip-path:url(#SVGID_00000009568756349700305490000005791140507084005534_);}\r\n\t.st456{clip-path:url(#SVGID_00000003104421663521705730000005319919337988868525_);}\r\n\t.st457{clip-path:url(#SVGID_00000101819451004478814990000008804926689765797005_);}\r\n\t.st458{clip-path:url(#SVGID_00000116929517221642352910000007442949177402991800_);}\r\n\t.st459{clip-path:url(#SVGID_00000008119547810579614960000010954487228065036931_);}\r\n\t.st460{clip-path:url(#SVGID_00000153703541973842268800000000613441662724021139_);}\r\n\t.st461{clip-path:url(#SVGID_00000059997437410061615120000017870180453450148496_);}\r\n\t.st462{clip-path:url(#SVGID_00000125573653469021768490000009399710338570228362_);}\r\n\t.st463{clip-path:url(#SVGID_00000110472417553989297270000018052588191872609709_);}\r\n\t.st464{clip-path:url(#SVGID_00000124844315037177924090000003201347716059238050_);}\r\n\t.st465{clip-path:url(#SVGID_00000130609765981131184900000015687815708924575125_);}\r\n\t\r\n\t\t.st466{clip-path:url(#SVGID_00000021841207944277461520000005300180492459728552_);fill:url(#SVGID_00000080903305042804711940000006229463863785883046_);}\r\n\t\r\n\t\t.st467{clip-path:url(#SVGID_00000107548726286513826530000017500688826727715482_);mask:url(#SVGID_00000029031480218474137670000017068951029419592372_);fill:url(#SVGID_00000052799900516980033390000010071270225602081675_);}\r\n\t.st468{opacity:0.48;fill:url(#SVGID_00000075151187560296627300000006973030762894081692_);enable-background:new    ;}\r\n\t.st469{clip-path:url(#SVGID_00000145746141746933207890000016014955786206558612_);}\r\n\t.st470{filter:url(#Adobe_OpacityMaskFilter_00000061467665131386016640000003682207837161008267_);}\r\n\t.st471{clip-path:url(#SVGID_00000039839258187109602860000002038669273072038814_);}\r\n\t.st472{clip-path:url(#SVGID_00000112625362049761855330000012382333793580344977_);}\r\n\t.st473{clip-path:url(#SVGID_00000163072917219717249180000004356790394697305224_);}\r\n\t.st474{clip-path:url(#SVGID_00000062153281030639269560000016061739057178983316_);}\r\n\t.st475{clip-path:url(#SVGID_00000096051224212286683090000010333745304802999190_);}\r\n\t.st476{clip-path:url(#SVGID_00000057827296090821992980000004049747832684644510_);}\r\n\t.st477{clip-path:url(#SVGID_00000067234868538232844940000016613031448430754442_);}\r\n\t.st478{clip-path:url(#SVGID_00000083787402762177499490000018081644275817881220_);}\r\n\t.st479{clip-path:url(#SVGID_00000165215448774891494060000003040587813809377706_);}\r\n\t.st480{clip-path:url(#SVGID_00000147926455097931894240000003716324638313127086_);}\r\n\t.st481{clip-path:url(#SVGID_00000077296142689265398950000004539375606688543872_);}\r\n\t.st482{clip-path:url(#SVGID_00000026855978404310975950000005777744144779829899_);}\r\n\t.st483{clip-path:url(#SVGID_00000151541665219041491940000009642076320917284543_);}\r\n\t.st484{clip-path:url(#SVGID_00000004513340615141474910000004136393829785701552_);}\r\n\t.st485{clip-path:url(#SVGID_00000090986174627340425530000016956576854127880364_);}\r\n\t.st486{clip-path:url(#SVGID_00000122679318991568044750000016606246987502115745_);}\r\n\t.st487{clip-path:url(#SVGID_00000035502843407346510670000009802738798722483880_);}\r\n\t.st488{clip-path:url(#SVGID_00000166660592402433996600000012255579921186110620_);}\r\n\t.st489{clip-path:url(#SVGID_00000093173455223166375700000000050325506748047247_);}\r\n\t.st490{clip-path:url(#SVGID_00000122689869506179249970000007492469824542286522_);}\r\n\t.st491{clip-path:url(#SVGID_00000079464898824361934410000011539731379150674352_);}\r\n\t.st492{clip-path:url(#SVGID_00000052823574995687185620000014876417773235006650_);}\r\n\t.st493{clip-path:url(#SVGID_00000176021106000405976000000001729426866493579407_);}\r\n\t.st494{clip-path:url(#SVGID_00000075843306816693521000000006680048720997069957_);}\r\n\t.st495{clip-path:url(#SVGID_00000123413177486042321660000007142807799716202926_);}\r\n\t\r\n\t\t.st496{clip-path:url(#SVGID_00000055701830814838242070000002417033788961751472_);fill:url(#SVGID_00000081640490013451421740000007349512066242263449_);}\r\n\t\r\n\t\t.st497{clip-path:url(#SVGID_00000039839258187109602860000002038669273072038814_);mask:url(#SVGID_00000169544227182250955240000014722914001369640358_);fill:url(#SVGID_00000116223074062761715780000016932577320894456766_);}\r\n\t.st498{opacity:0.48;fill:url(#SVGID_00000068643272825376299130000002194020266746728847_);enable-background:new    ;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -560.8526,
    y1: -840.286,
    x2: -560.8526,
    y2: -807.6401,
    gradientTransform: "matrix(1 0 0 -1 588.6593 -709.3386)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00193075,
    style: {
      stopColor: "#F9EF8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F5A017"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34,97.9c1.6,20.5-6,33.1-6,33.1c-8.6-19.9-6.2-33.1-6.2-33.1H34z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000180355431716357080180000001533011575757094078_",
    cx: -276.8561,
    cy: 196.1703,
    r: 0,
    gradientTransform: "matrix(1 0 0 -1 313.6061 221.4703)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7316"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4358,
    style: {
      stopColor: "#FE7316"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#14161C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000180355431716357080180000001533011575757094078_)"
    },
    d: "M36.8,25.3"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121974904284838784240000017941215191721466532_",
    gradientUnits: "userSpaceOnUse",
    x1: -578.4593,
    y1: -779.3186,
    x2: -578.4593,
    y2: -809.4578,
    gradientTransform: "matrix(1 0 0 -1 588.6593 -709.3386)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1E110E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7931A"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000121974904284838784240000017941215191721466532_)"
    },
    points: "13.6,69.2 8.7,71.7  3.2,101.9 17.3,89.7  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036247172584892034230000004607636267309864629_",
    gradientUnits: "userSpaceOnUse",
    x1: -543.0593,
    y1: -779.3186,
    x2: -543.0593,
    y2: -809.4578,
    gradientTransform: "matrix(1 0 0 -1 588.6593 -709.3386)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1E110E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7931A"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000036247172584892034230000004607636267309864629_)"
    },
    points: "42.2,69.2 47.2,71.7  52.7,101.9 38.6,89.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000011713204599112412500000006122059884848681344_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000175310848318266841840000011361934080282965666_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000011713204599112412500000006122059884848681344_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000007423741926683975330000006143822570426037691_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000158026361902928688030000001222017391346936991_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000052815011994823464430000011831738181122268854_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000007423741926683975330000006143822570426037691_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000108276005837955056760000015973155752587843456_",
    style: {
      clipPath: "url(#SVGID_00000052815011994823464430000011831738181122268854_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000158026361902928688030000001222017391346936991_",
    style: {
      overflow: "visible"
    }
  })), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 40,
    y: 70.2,
    width: 7.8,
    height: 27.4
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 70.2,
    width: 7.8,
    height: 27.4,
    id: "SVGID_00000098205536018099535110000018239108834979048580_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000159466236688460287050000008291610278663250085_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000159465672449364269900000015614742091820948892_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000062904472368562949520000009608559818279672197_",
    style: {
      clipPath: "url(#SVGID_00000108276005837955056760000015973155752587843456_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000159466236688460287050000008291610278663250085_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000060728605645163035500000001169921027301101984_",
    style: {
      clipPath: "url(#SVGID_00000062904472368562949520000009608559818279672197_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000159465672449364269900000015614742091820948892_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000093891955336213304110000004274688852342396597_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000077318472187638215340000002700299759187848884_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000093879174039673160950000007346062881365703564_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000077321480140797820960000000919439310370607289_",
    style: {
      clipPath: "url(#SVGID_00000108276005837955056760000015973155752587843456_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000093891955336213304110000004274688852342396597_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000122692330726868280980000014592876321250364544_",
    style: {
      clipPath: "url(#SVGID_00000077321480140797820960000000919439310370607289_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000077318472187638215340000002700299759187848884_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000016797496041700537830000001284113798332771507_",
    style: {
      clipPath: "url(#SVGID_00000122692330726868280980000014592876321250364544_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000093879174039673160950000007346062881365703564_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000171717354549905112940000007311327376228951231_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000039120643986492563600000012601772329654477997_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000145761675201751204740000000963201346292236205_",
    style: {
      clipPath: "url(#SVGID_00000108276005837955056760000015973155752587843456_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000171717354549905112940000007311327376228951231_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000026884397966440001690000017302441995750074792_",
    style: {
      clipPath: "url(#SVGID_00000145761675201751204740000000963201346292236205_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000039120643986492563600000012601772329654477997_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000128452181306177673630000016844031930544778431_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000084500135982861320060000011470666438967380144_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000000907986667483776500000005596628153030076032_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000008117900629364599430000014625092594972135566_",
    style: {
      clipPath: "url(#SVGID_00000108276005837955056760000015973155752587843456_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000128452181306177673630000016844031930544778431_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000124152532642395694490000001199979593853344655_",
    style: {
      clipPath: "url(#SVGID_00000008117900629364599430000014625092594972135566_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000084500135982861320060000011470666438967380144_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000101066027425944157510000017678793945278044587_",
    style: {
      clipPath: "url(#SVGID_00000124152532642395694490000001199979593853344655_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000000907986667483776500000005596628153030076032_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000010268778323890111900000012347057982709185207_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000011727726796202368200000013225366076424739733_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000096028917796843007400000000266128304382959280_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000103962862992951781640000000939258015679199156_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000152980408814940455150000000468533516783406259_",
    style: {
      clipPath: "url(#SVGID_00000108276005837955056760000015973155752587843456_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000010268778323890111900000012347057982709185207_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000005981926276950831090000012262878558606146460_",
    style: {
      clipPath: "url(#SVGID_00000152980408814940455150000000468533516783406259_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000011727726796202368200000013225366076424739733_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000069356456384463086570000009494275673586314154_",
    style: {
      clipPath: "url(#SVGID_00000005981926276950831090000012262878558606146460_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000096028917796843007400000000266128304382959280_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000005243396955814477830000002526462389741760903_",
    style: {
      clipPath: "url(#SVGID_00000069356456384463086570000009494275673586314154_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000103962862992951781640000000939258015679199156_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000149379822291439101960000009623360257985644973_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000098187957481755087720000003146274647176273794_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000047018086181884568320000016676899637850512790_",
    style: {
      clipPath: "url(#SVGID_00000108276005837955056760000015973155752587843456_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000149379822291439101960000009623360257985644973_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000110433566047688197870000014976005635173301658_",
    style: {
      clipPath: "url(#SVGID_00000047018086181884568320000016676899637850512790_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000098187957481755087720000003146274647176273794_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000116954165569824048870000004325470678564821950_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000048463087337921959430000006946646907618944694_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs23 || (_defs23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000155843110819103969860000012783710236876583847_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000117670164784955736670000000305662590438895288_",
    style: {
      clipPath: "url(#SVGID_00000108276005837955056760000015973155752587843456_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000116954165569824048870000004325470678564821950_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000098190377215925777920000003957805315571348138_",
    style: {
      clipPath: "url(#SVGID_00000117670164784955736670000000305662590438895288_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000048463087337921959430000006946646907618944694_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000029039933240148418390000015311689028008301969_",
    style: {
      clipPath: "url(#SVGID_00000098190377215925777920000003957805315571348138_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000155843110819103969860000012783710236876583847_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs24 || (_defs24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000016788241778662384510000002324663486527570831_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs25 || (_defs25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000163040265537350131160000005961364820158330008_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs26 || (_defs26 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000174574246076409915950000015702395840992272816_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs27 || (_defs27 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000156557194275446984420000005084247214038375070_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000023258667966735411400000011527396544265037486_",
    style: {
      clipPath: "url(#SVGID_00000108276005837955056760000015973155752587843456_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000016788241778662384510000002324663486527570831_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000144327977321633256360000012308068302421393056_",
    style: {
      clipPath: "url(#SVGID_00000023258667966735411400000011527396544265037486_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000163040265537350131160000005961364820158330008_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000114067992059853295180000013927325561534439597_",
    style: {
      clipPath: "url(#SVGID_00000144327977321633256360000012308068302421393056_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000174574246076409915950000015702395840992272816_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000060718592991367470400000002388829108909930919_",
    style: {
      clipPath: "url(#SVGID_00000114067992059853295180000013927325561534439597_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000156557194275446984420000005084247214038375070_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs28 || (_defs28 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000145039561250902954000000009794262313901631368_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs29 || (_defs29 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000170250447547050005080000016171057959396950962_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs30 || (_defs30 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000105408196710617303460000009902682164073748884_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs31 || (_defs31 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000137811814508478087030000015400399102467158925_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs32 || (_defs32 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000139272418002982605510000007878333282819560580_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000068650230420483376010000017257122473483169669_",
    style: {
      clipPath: "url(#SVGID_00000108276005837955056760000015973155752587843456_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000145039561250902954000000009794262313901631368_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000003795467558394082700000008213387696299085977_",
    style: {
      clipPath: "url(#SVGID_00000068650230420483376010000017257122473483169669_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000170250447547050005080000016171057959396950962_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000168081736908842383190000013218510726644701363_",
    style: {
      clipPath: "url(#SVGID_00000003795467558394082700000008213387696299085977_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000105408196710617303460000009902682164073748884_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000056412126346098862090000002882872461213125291_",
    style: {
      clipPath: "url(#SVGID_00000168081736908842383190000013218510726644701363_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000137811814508478087030000015400399102467158925_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000081621295573612464670000008968225546254036619_",
    style: {
      clipPath: "url(#SVGID_00000056412126346098862090000002882872461213125291_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000139272418002982605510000007878333282819560580_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs33 || (_defs33 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000061460983171787674340000016554240731306724491_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs34 || (_defs34 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000155145002011841151520000011406462446249734556_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs35 || (_defs35 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000148640186225904065200000015469363264187133058_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs36 || (_defs36 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000001633808745662238550000006279468591126256564_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs37 || (_defs37 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000008864633430520076960000006386252629412449198_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs38 || (_defs38 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000053543656219242304970000013992487441385361840_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000010269940169217407880000006534407944885524150_",
    style: {
      clipPath: "url(#SVGID_00000108276005837955056760000015973155752587843456_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000061460983171787674340000016554240731306724491_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000004514675054758011970000005619089350787251877_",
    style: {
      clipPath: "url(#SVGID_00000010269940169217407880000006534407944885524150_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000155145002011841151520000011406462446249734556_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000026848957273425835780000016428483253567687100_",
    style: {
      clipPath: "url(#SVGID_00000004514675054758011970000005619089350787251877_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000148640186225904065200000015469363264187133058_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000150089236064076952890000012934354452858627242_",
    style: {
      clipPath: "url(#SVGID_00000026848957273425835780000016428483253567687100_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000001633808745662238550000006279468591126256564_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000028292627321390451660000001008581362095094972_",
    style: {
      clipPath: "url(#SVGID_00000150089236064076952890000012934354452858627242_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000008864633430520076960000006386252629412449198_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000037669671641413243350000013034589583853050250_",
    style: {
      clipPath: "url(#SVGID_00000028292627321390451660000001008581362095094972_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000053543656219242304970000013992487441385361840_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000074408040820554580550000016699675394826362046_",
    gradientUnits: "userSpaceOnUse",
    x1: -262.3947,
    y1: 136.1122,
    x2: -296.2533,
    y2: 145.5853,
    gradientTransform: "matrix(1 0 0 -1 313.6061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000037669671641413243350000013034589583853050250_)",
      fill: "url(#SVGID_00000074408040820554580550000016699675394826362046_)"
    },
    points: " 40,91 47.8,97.6 45.4,70.8 44.3,70.2  "
  })))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142856596542759011490000006930883335017690552_",
    gradientUnits: "userSpaceOnUse",
    x1: -262.3947,
    y1: 136.1122,
    x2: -296.2533,
    y2: 145.5853,
    gradientTransform: "matrix(1 0 0 -1 313.6061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000108276005837955056760000015973155752587843456_)",
      mask: "url(#SVGID_00000098205536018099535110000018239108834979048580_)",
      fill: "url(#SVGID_00000142856596542759011490000006930883335017690552_)"
    },
    points: " 40,91 47.8,97.6 45.4,70.8 44.3,70.2  "
  }))))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "40,91 47.8,97.6 45.4,70.8 44.3,70.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs39 || (_defs39 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000175312960512519360200000010283059922046281121_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000008864415371413472190000015907931777749949849_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000175312960512519360200000010283059922046281121_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs40 || (_defs40 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000179641355499057739640000013974244114427217541_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs41 || (_defs41 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000052824887665172545610000012146818486323367856_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000093161543613808127330000001777323905546671764_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000179641355499057739640000013974244114427217541_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000028317918126598439020000004484099964851960197_",
    style: {
      clipPath: "url(#SVGID_00000093161543613808127330000001777323905546671764_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000052824887665172545610000012146818486323367856_",
    style: {
      overflow: "visible"
    }
  })), _defs42 || (_defs42 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000183944174520160532880000006607748075425116572_",
    filterUnits: "userSpaceOnUse",
    x: 8.1,
    y: 70.2,
    width: 7.8,
    height: 27.4
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 8.1,
    y: 70.2,
    width: 7.8,
    height: 27.4,
    id: "SVGID_00000145039375900570916100000016106559278132189604_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000183944174520160532880000006607748075425116572_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs43 || (_defs43 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000025437664233501539530000011272867112969069231_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs44 || (_defs44 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000051360969480843439700000005051079925183144360_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000046323975355475044370000005698709007056320915_",
    style: {
      clipPath: "url(#SVGID_00000028317918126598439020000004484099964851960197_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000025437664233501539530000011272867112969069231_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000156546738351523515640000017645445769690411199_",
    style: {
      clipPath: "url(#SVGID_00000046323975355475044370000005698709007056320915_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000051360969480843439700000005051079925183144360_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs45 || (_defs45 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000039819086025556232970000005438514501672181658_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs46 || (_defs46 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000162322950538510794630000012595822719608877454_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs47 || (_defs47 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000112605148617442111910000015612127802649528472_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000059267928577696908530000010597543858095896226_",
    style: {
      clipPath: "url(#SVGID_00000028317918126598439020000004484099964851960197_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000039819086025556232970000005438514501672181658_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000090981598943457892580000014812872780608978335_",
    style: {
      clipPath: "url(#SVGID_00000059267928577696908530000010597543858095896226_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000162322950538510794630000012595822719608877454_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000141424829504056744170000014269587185840149888_",
    style: {
      clipPath: "url(#SVGID_00000090981598943457892580000014812872780608978335_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000112605148617442111910000015612127802649528472_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs48 || (_defs48 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000103970673215763656490000011623017612099427244_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs49 || (_defs49 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000121965561536961642900000010527243715223507356_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000065791440845225857940000015874178534439949979_",
    style: {
      clipPath: "url(#SVGID_00000028317918126598439020000004484099964851960197_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000103970673215763656490000011623017612099427244_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000140008611973857047060000000669840928876550827_",
    style: {
      clipPath: "url(#SVGID_00000065791440845225857940000015874178534439949979_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000121965561536961642900000010527243715223507356_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs50 || (_defs50 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000101103118456794184230000017482368661420206739_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs51 || (_defs51 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000074408389235421428510000007486036778639277742_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs52 || (_defs52 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000024718001824062303270000013115507634580347014_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000052793615121189742130000014144380942887831951_",
    style: {
      clipPath: "url(#SVGID_00000028317918126598439020000004484099964851960197_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000101103118456794184230000017482368661420206739_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000144308482287443430190000014314961268665757836_",
    style: {
      clipPath: "url(#SVGID_00000052793615121189742130000014144380942887831951_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000074408389235421428510000007486036778639277742_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000063609100588116462850000012319955283556020397_",
    style: {
      clipPath: "url(#SVGID_00000144308482287443430190000014314961268665757836_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000024718001824062303270000013115507634580347014_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs53 || (_defs53 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000110462882026473489530000001042517615255737003_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs54 || (_defs54 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000036959735685578614010000015190970649306380463_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs55 || (_defs55 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000043433941998716648130000005884318302237504665_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs56 || (_defs56 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000033352670042059392100000004196271411891327156_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000179631878332287525820000002166551225135899546_",
    style: {
      clipPath: "url(#SVGID_00000028317918126598439020000004484099964851960197_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000110462882026473489530000001042517615255737003_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000085228077988198375060000012520954641052571820_",
    style: {
      clipPath: "url(#SVGID_00000179631878332287525820000002166551225135899546_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000036959735685578614010000015190970649306380463_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000096042670358002744330000015516090058181166225_",
    style: {
      clipPath: "url(#SVGID_00000085228077988198375060000012520954641052571820_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000043433941998716648130000005884318302237504665_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000137090099568272287070000010351133174268403613_",
    style: {
      clipPath: "url(#SVGID_00000096042670358002744330000015516090058181166225_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000033352670042059392100000004196271411891327156_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs57 || (_defs57 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000076605473256619325860000008166919476160601500_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs58 || (_defs58 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000079486152737175469880000018002134249346738310_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000157299308551549326910000014599643161204408709_",
    style: {
      clipPath: "url(#SVGID_00000028317918126598439020000004484099964851960197_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000076605473256619325860000008166919476160601500_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000056409949306075814600000000016611366651230129_",
    style: {
      clipPath: "url(#SVGID_00000157299308551549326910000014599643161204408709_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000079486152737175469880000018002134249346738310_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs59 || (_defs59 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000058588240858533469290000013693239822040651434_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs60 || (_defs60 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000044153929446902864480000006614337318912151939_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs61 || (_defs61 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000140707714757183530120000005334026060231928993_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000102516039358200498560000006363596333427645828_",
    style: {
      clipPath: "url(#SVGID_00000028317918126598439020000004484099964851960197_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000058588240858533469290000013693239822040651434_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000034808406392032947310000014744377976527730100_",
    style: {
      clipPath: "url(#SVGID_00000102516039358200498560000006363596333427645828_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000044153929446902864480000006614337318912151939_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000022530660016130449000000001974329933003882143_",
    style: {
      clipPath: "url(#SVGID_00000034808406392032947310000014744377976527730100_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000140707714757183530120000005334026060231928993_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs62 || (_defs62 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000066513148199156850000000002759870934683222968_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs63 || (_defs63 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000123399679828399626250000007934462214410096267_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs64 || (_defs64 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000097481485731661739090000003377109622361705858_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs65 || (_defs65 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000039823564795276027920000008358289309157389469_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000153678580045305082860000007299560305600612284_",
    style: {
      clipPath: "url(#SVGID_00000028317918126598439020000004484099964851960197_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000066513148199156850000000002759870934683222968_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000178922419738559736880000006163750691939228068_",
    style: {
      clipPath: "url(#SVGID_00000153678580045305082860000007299560305600612284_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000123399679828399626250000007934462214410096267_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000099638074936354566280000009517104195518075025_",
    style: {
      clipPath: "url(#SVGID_00000178922419738559736880000006163750691939228068_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000097481485731661739090000003377109622361705858_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000000206639830250806120000018394248859799141795_",
    style: {
      clipPath: "url(#SVGID_00000099638074936354566280000009517104195518075025_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000039823564795276027920000008358289309157389469_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs66 || (_defs66 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000024680142711973343200000018005911053922995370_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs67 || (_defs67 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000123406746248987139890000010937681755275667604_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs68 || (_defs68 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000113335299465373787310000008683507713019537280_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs69 || (_defs69 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000056401428475842684430000016267551695432394375_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs70 || (_defs70 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000011007545024420667480000014524798721132060589_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000005259040333639395190000017830677644243092113_",
    style: {
      clipPath: "url(#SVGID_00000028317918126598439020000004484099964851960197_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000024680142711973343200000018005911053922995370_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000172441869321660215630000004572143352384815779_",
    style: {
      clipPath: "url(#SVGID_00000005259040333639395190000017830677644243092113_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000123406746248987139890000010937681755275667604_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000132774178487755985700000015181218138729764272_",
    style: {
      clipPath: "url(#SVGID_00000172441869321660215630000004572143352384815779_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000113335299465373787310000008683507713019537280_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000082331887718446840360000016362004463410810045_",
    style: {
      clipPath: "url(#SVGID_00000132774178487755985700000015181218138729764272_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000056401428475842684430000016267551695432394375_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000095308118176243814400000012235230069236965531_",
    style: {
      clipPath: "url(#SVGID_00000082331887718446840360000016362004463410810045_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000011007545024420667480000014524798721132060589_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs71 || (_defs71 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000170999958906783322290000008827335575816222632_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs72 || (_defs72 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000116945322214281669140000002522082715117616520_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs73 || (_defs73 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000026136546451462455610000009742445756597469100_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs74 || (_defs74 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000010296147857768744040000017642912841775311263_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs75 || (_defs75 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000165221279921701479910000013607304450680754325_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs76 || (_defs76 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000055682082888313810940000009005154688610181504_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000082339317580471970220000015275399706617312703_",
    style: {
      clipPath: "url(#SVGID_00000028317918126598439020000004484099964851960197_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000170999958906783322290000008827335575816222632_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000013182805589894507860000007039531013452019862_",
    style: {
      clipPath: "url(#SVGID_00000082339317580471970220000015275399706617312703_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000116945322214281669140000002522082715117616520_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000106131227025792010210000003585230661950609299_",
    style: {
      clipPath: "url(#SVGID_00000013182805589894507860000007039531013452019862_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000026136546451462455610000009742445756597469100_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000104704821905921597690000008452840405739117227_",
    style: {
      clipPath: "url(#SVGID_00000106131227025792010210000003585230661950609299_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000010296147857768744040000017642912841775311263_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000128450612601121661360000013607587453684945035_",
    style: {
      clipPath: "url(#SVGID_00000104704821905921597690000008452840405739117227_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000165221279921701479910000013607304450680754325_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000150060816943870945350000011540018192254657183_",
    style: {
      clipPath: "url(#SVGID_00000128450612601121661360000013607587453684945035_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000055682082888313810940000009005154688610181504_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158007871476611499950000005079299685075782274_",
    gradientUnits: "userSpaceOnUse",
    x1: -302.052,
    y1: 132.9505,
    x2: -305.9579,
    y2: 189.977,
    gradientTransform: "matrix(1 0 0 -1 313.6061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000150060816943870945350000011540018192254657183_)",
      fill: "url(#SVGID_00000158007871476611499950000005079299685075782274_)"
    },
    points: " 15.9,91 8.1,97.6 10.5,70.8 11.7,70.2  "
  })))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111894592563083860770000011127441955893761410_",
    gradientUnits: "userSpaceOnUse",
    x1: -302.052,
    y1: 132.9505,
    x2: -305.9579,
    y2: 189.977,
    gradientTransform: "matrix(1 0 0 -1 313.6061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000028317918126598439020000004484099964851960197_)",
      mask: "url(#SVGID_00000145039375900570916100000016106559278132189604_)",
      fill: "url(#SVGID_00000111894592563083860770000011127441955893761410_)"
    },
    points: " 15.9,91 8.1,97.6 10.5,70.8 11.7,70.2  "
  }))))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "15.9,91 8.1,97.6 10.5,70.8 11.7,70.2  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000153694156711005262860000006998533392250456503_",
    gradientUnits: "userSpaceOnUse",
    x1: -560.8093,
    y1: -805.8766,
    x2: -560.8093,
    y2: -801.6418,
    gradientTransform: "matrix(1 0 0 -1 588.6593 -709.3386)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1E110E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7931A"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000153694156711005262860000006998533392250456503_)"
    },
    points: "38,91.4 17.8,91.4  17.8,96.8 38,96.8  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs77 || (_defs77 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000079444407368351299370000002942734883038108040_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000142882733057406068040000013286601206405155728_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000079444407368351299370000002942734883038108040_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs78 || (_defs78 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000134945194299854462680000010870067502696777650_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs79 || (_defs79 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000151535633847396899380000011121767273214722223_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000009589008525542654680000013392483007129883550_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000134945194299854462680000010870067502696777650_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000008868931136696715980000001869748028612367005_",
    style: {
      clipPath: "url(#SVGID_00000009589008525542654680000013392483007129883550_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000151535633847396899380000011121767273214722223_",
    style: {
      overflow: "visible"
    }
  })), _defs80 || (_defs80 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000116935441977257799130000017384346812281850774_",
    filterUnits: "userSpaceOnUse",
    x: 17.8,
    y: 91.4,
    width: 20.2,
    height: 5.4
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 17.8,
    y: 91.4,
    width: 20.2,
    height: 5.4,
    id: "SVGID_00000086671477949970161480000017292391517292546231_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000116935441977257799130000017384346812281850774_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs81 || (_defs81 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000098221008461103771000000003282433055452059298_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs82 || (_defs82 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000031896116258508351820000001620615293482622869_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000092430866746657195870000012837771210409448109_",
    style: {
      clipPath: "url(#SVGID_00000008868931136696715980000001869748028612367005_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000098221008461103771000000003282433055452059298_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000168807072722392193030000008794833318571011231_",
    style: {
      clipPath: "url(#SVGID_00000092430866746657195870000012837771210409448109_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000031896116258508351820000001620615293482622869_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs83 || (_defs83 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000058590715691476824940000004480732352314476984_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs84 || (_defs84 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000083071647113874079490000004890279990659633827_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs85 || (_defs85 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000018942750175971985720000010933682326003091109_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000018937396639111674810000005886739351639763104_",
    style: {
      clipPath: "url(#SVGID_00000008868931136696715980000001869748028612367005_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000058590715691476824940000004480732352314476984_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000117678989150580281870000010524325544962094723_",
    style: {
      clipPath: "url(#SVGID_00000018937396639111674810000005886739351639763104_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000083071647113874079490000004890279990659633827_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000157299359160435878560000011153432947550809989_",
    style: {
      clipPath: "url(#SVGID_00000117678989150580281870000010524325544962094723_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000018942750175971985720000010933682326003091109_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs86 || (_defs86 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000011029067161718119520000011949797301205441701_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs87 || (_defs87 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000171679361789241524900000005465359057662979481_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000135690158900525415070000007578570335175360438_",
    style: {
      clipPath: "url(#SVGID_00000008868931136696715980000001869748028612367005_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000011029067161718119520000011949797301205441701_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000065785598715248800570000015272465686983488129_",
    style: {
      clipPath: "url(#SVGID_00000135690158900525415070000007578570335175360438_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000171679361789241524900000005465359057662979481_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs88 || (_defs88 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000175281261159594482380000003784095568112777375_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs89 || (_defs89 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000127042929383505074030000016200122872061067691_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs90 || (_defs90 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000136385146533204767900000015768791592452577164_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000088114608442554302430000012984330391571806884_",
    style: {
      clipPath: "url(#SVGID_00000008868931136696715980000001869748028612367005_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000175281261159594482380000003784095568112777375_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000110443713564367779630000005190477930185417390_",
    style: {
      clipPath: "url(#SVGID_00000088114608442554302430000012984330391571806884_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000127042929383505074030000016200122872061067691_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000167393059996098769520000013484974688927829919_",
    style: {
      clipPath: "url(#SVGID_00000110443713564367779630000005190477930185417390_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000136385146533204767900000015768791592452577164_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs91 || (_defs91 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000106840634463185596340000012361788831700398984_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs92 || (_defs92 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000031923379977323676730000014731762043769490307_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs93 || (_defs93 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000067205128993819429150000000528697836968725645_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs94 || (_defs94 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000138569141062622271710000004469508473037872812_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000024690254934676882010000013396685718294889109_",
    style: {
      clipPath: "url(#SVGID_00000008868931136696715980000001869748028612367005_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000106840634463185596340000012361788831700398984_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000005963643749419433590000001872293927252588425_",
    style: {
      clipPath: "url(#SVGID_00000024690254934676882010000013396685718294889109_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000031923379977323676730000014731762043769490307_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000090290996356507646810000015916981042755620282_",
    style: {
      clipPath: "url(#SVGID_00000005963643749419433590000001872293927252588425_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000067205128993819429150000000528697836968725645_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000046311733319404227250000013257284553213575579_",
    style: {
      clipPath: "url(#SVGID_00000090290996356507646810000015916981042755620282_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000138569141062622271710000004469508473037872812_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs95 || (_defs95 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000011733796415049015830000014913330183662932399_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs96 || (_defs96 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000155849621023932557620000006023335320827796372_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000101061216455066082870000007430554210165884598_",
    style: {
      clipPath: "url(#SVGID_00000008868931136696715980000001869748028612367005_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000011733796415049015830000014913330183662932399_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000056421454844400437020000003244194893431266986_",
    style: {
      clipPath: "url(#SVGID_00000101061216455066082870000007430554210165884598_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000155849621023932557620000006023335320827796372_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs97 || (_defs97 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000108274875841137395810000012589508138522475667_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs98 || (_defs98 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000000186027510979605030000017595079157385317508_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs99 || (_defs99 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000065763093902286581220000011036781544838534316_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000157297241516023499760000004504509251550006701_",
    style: {
      clipPath: "url(#SVGID_00000008868931136696715980000001869748028612367005_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000108274875841137395810000012589508138522475667_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000071524434019031914390000018330724425725465218_",
    style: {
      clipPath: "url(#SVGID_00000157297241516023499760000004504509251550006701_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000000186027510979605030000017595079157385317508_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000093888609723633238630000011683716322135070616_",
    style: {
      clipPath: "url(#SVGID_00000071524434019031914390000018330724425725465218_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000065763093902286581220000011036781544838534316_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs100 || (_defs100 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000031204971894568602750000016753669901135503276_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs101 || (_defs101 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000066480483827702823860000017764340309531377801_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs102 || (_defs102 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000058557743358686275710000013346046060799530942_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs103 || (_defs103 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000073715800414099091620000014696063621549903533_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000056395642095598448460000015392931704072971651_",
    style: {
      clipPath: "url(#SVGID_00000008868931136696715980000001869748028612367005_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000031204971894568602750000016753669901135503276_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000080909523728093582790000004141485574106915222_",
    style: {
      clipPath: "url(#SVGID_00000056395642095598448460000015392931704072971651_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000066480483827702823860000017764340309531377801_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000098917921954397053700000006295258395105022889_",
    style: {
      clipPath: "url(#SVGID_00000080909523728093582790000004141485574106915222_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000058557743358686275710000013346046060799530942_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000048491038608468468760000017124278072814469820_",
    style: {
      clipPath: "url(#SVGID_00000098917921954397053700000006295258395105022889_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000073715800414099091620000014696063621549903533_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs104 || (_defs104 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000121973001052724831210000001000224672648185481_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs105 || (_defs105 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000071557206199180088530000009704287442181930141_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs106 || (_defs106 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000082331059086910894350000012201176189217272762_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs107 || (_defs107 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000163042056295793621120000004629799417940463003_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs108 || (_defs108 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000031182780351332644190000001300159054925119645_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000098205706048919952460000002512887452095725211_",
    style: {
      clipPath: "url(#SVGID_00000008868931136696715980000001869748028612367005_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000121973001052724831210000001000224672648185481_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000139261925150806038750000013833216568387896476_",
    style: {
      clipPath: "url(#SVGID_00000098205706048919952460000002512887452095725211_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000071557206199180088530000009704287442181930141_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000072253222805528480840000012158628072632261769_",
    style: {
      clipPath: "url(#SVGID_00000139261925150806038750000013833216568387896476_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000082331059086910894350000012201176189217272762_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000011712752123802736320000013157840540822424708_",
    style: {
      clipPath: "url(#SVGID_00000072253222805528480840000012158628072632261769_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000163042056295793621120000004629799417940463003_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000110461397394382856090000009446388828658367897_",
    style: {
      clipPath: "url(#SVGID_00000011712752123802736320000013157840540822424708_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000031182780351332644190000001300159054925119645_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs109 || (_defs109 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000116231273973158790480000013408931270622128550_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs110 || (_defs110 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000180357198459793991030000010391278848176352904_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs111 || (_defs111 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000038373031586765594340000001158623000905268870_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs112 || (_defs112 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000127764509664457805970000008068524545938640286_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs113 || (_defs113 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000032616477424333383890000000905610841949317262_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs114 || (_defs114 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000100345623302223989120000016879828730353597363_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000088122931486376242990000012451090702578694297_",
    style: {
      clipPath: "url(#SVGID_00000008868931136696715980000001869748028612367005_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000116231273973158790480000013408931270622128550_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000142881071396440884170000013348905913689612438_",
    style: {
      clipPath: "url(#SVGID_00000088122931486376242990000012451090702578694297_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000180357198459793991030000010391278848176352904_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000112590697226918024470000011648879806350023050_",
    style: {
      clipPath: "url(#SVGID_00000142881071396440884170000013348905913689612438_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000038373031586765594340000001158623000905268870_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000096742332730016294780000014910676282501967805_",
    style: {
      clipPath: "url(#SVGID_00000112590697226918024470000011648879806350023050_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000127764509664457805970000008068524545938640286_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000054946487183439733760000013393644160998797708_",
    style: {
      clipPath: "url(#SVGID_00000096742332730016294780000014910676282501967805_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000032616477424333383890000000905610841949317262_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000026857962569969034290000000785251772186380446_",
    style: {
      clipPath: "url(#SVGID_00000054946487183439733760000013393644160998797708_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000100345623302223989120000016879828730353597363_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000118382627336242632670000000234163211211475624_",
    gradientUnits: "userSpaceOnUse",
    x1: -285.4539,
    y1: 123.2452,
    x2: -287.4707,
    y2: 163.1239,
    gradientTransform: "matrix(1 0 0 -1 313.6061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000026857962569969034290000000785251772186380446_)",
      fill: "url(#SVGID_00000118382627336242632670000000234163211211475624_)"
    },
    points: " 17.8,93.1 36.5,93.1 36.5,96.8 38,96.8 38,91.4 17.8,91.4  "
  })))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031204497502232158280000016318278944779451540_",
    gradientUnits: "userSpaceOnUse",
    x1: -285.4539,
    y1: 123.2452,
    x2: -287.4707,
    y2: 163.1239,
    gradientTransform: "matrix(1 0 0 -1 313.6061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000008868931136696715980000001869748028612367005_)",
      mask: "url(#SVGID_00000086671477949970161480000017292391517292546231_)",
      fill: "url(#SVGID_00000031204497502232158280000016318278944779451540_)"
    },
    points: " 17.8,93.1 36.5,93.1 36.5,96.8 38,96.8 38,91.4 17.8,91.4  "
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127743272254410131870000015415018294327750024_",
    gradientUnits: "userSpaceOnUse",
    x1: -285.4539,
    y1: 123.2452,
    x2: -287.4707,
    y2: 163.1239,
    gradientTransform: "matrix(1 0 0 -1 313.6061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#06090F"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000127743272254410131870000015415018294327750024_)"
    },
    points: "17.8,93.1 36.5,93.1  36.5,96.8 38,96.8 38,91.4 17.8,91.4  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000004526828431039189450000014124374507698608572_",
    gradientUnits: "userSpaceOnUse",
    x1: -569.4093,
    y1: -806.6886,
    x2: -552.2093,
    y2: -806.6886,
    gradientTransform: "matrix(1 0 0 -1 588.6593 -709.3386)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1E110E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7931A"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000004526828431039189450000014124374507698608572_)"
    },
    points: "36.5,96.8 19.3,96.8  19.3,97.9 36.5,97.9  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000028307224565827932970000005085178691305580220_",
    gradientUnits: "userSpaceOnUse",
    x1: -560.8093,
    y1: -797.1982,
    x2: -560.8093,
    y2: -752.3248,
    gradientTransform: "matrix(1 0 0 -1 588.6593 -709.3386)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1E110E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7931A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000028307224565827932970000005085178691305580220_)"
    },
    d: "M45.4,49.9c0,4.7-0.2,9-0.4,12.9 c-1.3,18.3-5.1,28.6-5.1,28.6h-12l0,0h-12c0,0-3.8-10.3-5.1-28.5c-0.3-4-0.4-8.3-0.4-12.9c0-5.3,0.7-10.3,1.9-15 C16.8,16.3,27.9,3.1,27.9,3.1l0,0l0,0c0.2,0.3,11.2,13.3,15.7,31.8C44.7,39.6,45.4,44.6,45.4,49.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000157282855470368862050000015287343994606787989_",
    gradientUnits: "userSpaceOnUse",
    x1: -267.1208,
    y1: 203.0574,
    x2: -317.5071,
    y2: 197.9796,
    gradientTransform: "matrix(1 0 0 -1 313.6061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1E110E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7931A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000157282855470368862050000015287343994606787989_)"
    },
    d: "M27.9,3.1c0,0-11.1,13.2-15.7,31.8 c5,1.5,10.2,2.3,15.7,2.3s10.7-0.8,15.7-2.3C39.1,16.3,27.9,3.1,27.9,3.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs115 || (_defs115 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000047766173013528305810000016226720581397079205_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000044859828862691347460000016358412140234242714_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000047766173013528305810000016226720581397079205_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs116 || (_defs116 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000075155420906664096450000002145959798340356490_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs117 || (_defs117 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000162320752958156659310000000937270211048588207_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000170963621615399955760000015047169174608553917_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000075155420906664096450000002145959798340356490_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000020369176692403554200000014688289009446493621_",
    style: {
      clipPath: "url(#SVGID_00000170963621615399955760000015047169174608553917_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000162320752958156659310000000937270211048588207_",
    style: {
      overflow: "visible"
    }
  })), _defs118 || (_defs118 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000178198529932750592090000006595769369553659272_",
    filterUnits: "userSpaceOnUse",
    x: 27.9,
    y: 3.1,
    width: 17.5,
    height: 88.3
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 27.9,
    y: 3.1,
    width: 17.5,
    height: 88.3,
    id: "SVGID_00000038403602023882672620000013071550106691496104_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000178198529932750592090000006595769369553659272_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs119 || (_defs119 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000153672398186244060190000012061135995732402309_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs120 || (_defs120 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000175317205664861723110000009958532830317272472_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000065049413831432312030000007566616003259128753_",
    style: {
      clipPath: "url(#SVGID_00000020369176692403554200000014688289009446493621_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000153672398186244060190000012061135995732402309_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000031177005255616054670000014802075579620709004_",
    style: {
      clipPath: "url(#SVGID_00000065049413831432312030000007566616003259128753_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000175317205664861723110000009958532830317272472_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs121 || (_defs121 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000110444221920527815540000016464475032961518223_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs122 || (_defs122 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000122714513368684233930000016783440894270693764_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs123 || (_defs123 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000145054971134693852610000017946774746441578920_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000170985161227050168360000018285455496902043803_",
    style: {
      clipPath: "url(#SVGID_00000020369176692403554200000014688289009446493621_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000110444221920527815540000016464475032961518223_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000158749751653679559590000014435847231270278804_",
    style: {
      clipPath: "url(#SVGID_00000170985161227050168360000018285455496902043803_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000122714513368684233930000016783440894270693764_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000183929160634945301950000007070411235885505441_",
    style: {
      clipPath: "url(#SVGID_00000158749751653679559590000014435847231270278804_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000145054971134693852610000017946774746441578920_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs124 || (_defs124 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000060716824190724595930000004557004067288351894_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs125 || (_defs125 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000011015686427569728630000014649174073912544405_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000154389453722100345310000012580461931232477875_",
    style: {
      clipPath: "url(#SVGID_00000020369176692403554200000014688289009446493621_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000060716824190724595930000004557004067288351894_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000034806435075281755670000014981975350566441099_",
    style: {
      clipPath: "url(#SVGID_00000154389453722100345310000012580461931232477875_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000011015686427569728630000014649174073912544405_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs126 || (_defs126 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000039815399736959922390000008488574555688603803_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs127 || (_defs127 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000080184390999443736920000010907271835816460436_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs128 || (_defs128 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000159433876668943975420000012844531202555563922_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000147938974453105750650000014733757672647671437_",
    style: {
      clipPath: "url(#SVGID_00000020369176692403554200000014688289009446493621_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000039815399736959922390000008488574555688603803_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000023265037881591453480000007723651393309531307_",
    style: {
      clipPath: "url(#SVGID_00000147938974453105750650000014733757672647671437_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000080184390999443736920000010907271835816460436_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000067958011514454085490000000954989913924223116_",
    style: {
      clipPath: "url(#SVGID_00000023265037881591453480000007723651393309531307_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000159433876668943975420000012844531202555563922_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs129 || (_defs129 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000090996079350100311250000009140748380338810758_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs130 || (_defs130 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000150795566817754823620000016633053968510848183_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs131 || (_defs131 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000173136470328079769960000007712564379590682508_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs132 || (_defs132 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000153669924477692643390000001324254428443529662_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000021823706949388467620000007699197528802605754_",
    style: {
      clipPath: "url(#SVGID_00000020369176692403554200000014688289009446493621_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000090996079350100311250000009140748380338810758_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000060720692112651260160000005954578016659483812_",
    style: {
      clipPath: "url(#SVGID_00000021823706949388467620000007699197528802605754_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000150795566817754823620000016633053968510848183_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000145770072132783431180000006854467987138116778_",
    style: {
      clipPath: "url(#SVGID_00000060720692112651260160000005954578016659483812_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000173136470328079769960000007712564379590682508_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000000221795242551169210000003463262268372900785_",
    style: {
      clipPath: "url(#SVGID_00000145770072132783431180000006854467987138116778_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000153669924477692643390000001324254428443529662_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs133 || (_defs133 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000001661709240433448630000010371379336032255619_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs134 || (_defs134 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000088853203510797869220000001192944354060999555_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000149364798610504431310000015643070207153025719_",
    style: {
      clipPath: "url(#SVGID_00000020369176692403554200000014688289009446493621_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000001661709240433448630000010371379336032255619_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000060011633016797999400000003361661600066597291_",
    style: {
      clipPath: "url(#SVGID_00000149364798610504431310000015643070207153025719_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000088853203510797869220000001192944354060999555_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs135 || (_defs135 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000127756086511254261470000004812933296309516682_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs136 || (_defs136 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000042721724670762804020000002442181066024846497_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs137 || (_defs137 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000070119956287728190140000001305732564475145398_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000149353013979996169050000004093636928821282746_",
    style: {
      clipPath: "url(#SVGID_00000020369176692403554200000014688289009446493621_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000127756086511254261470000004812933296309516682_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000090265995298136115040000007317000774174258827_",
    style: {
      clipPath: "url(#SVGID_00000149353013979996169050000004093636928821282746_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000042721724670762804020000002442181066024846497_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000149350159804966425210000016337629631774180250_",
    style: {
      clipPath: "url(#SVGID_00000090265995298136115040000007317000774174258827_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000070119956287728190140000001305732564475145398_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs138 || (_defs138 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000038383062529396788460000006790302633358839464_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs139 || (_defs139 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000144313168363952477300000006842335004800733347_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs140 || (_defs140 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000013166594864893784150000003133046182947882933_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs141 || (_defs141 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000040558442555996137570000000748831874011086505_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000168114545047579199460000008729920043068730008_",
    style: {
      clipPath: "url(#SVGID_00000020369176692403554200000014688289009446493621_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000038383062529396788460000006790302633358839464_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000124144723883653147360000003831664713942248581_",
    style: {
      clipPath: "url(#SVGID_00000168114545047579199460000008729920043068730008_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000144313168363952477300000006842335004800733347_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000099649558716137358210000010557714532996677552_",
    style: {
      clipPath: "url(#SVGID_00000124144723883653147360000003831664713942248581_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000013166594864893784150000003133046182947882933_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000106125344565020281580000006355026307754925242_",
    style: {
      clipPath: "url(#SVGID_00000099649558716137358210000010557714532996677552_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000040558442555996137570000000748831874011086505_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs142 || (_defs142 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000163042360787947127800000003552569138549186494_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs143 || (_defs143 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000086692263488073331290000004881680025673364876_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs144 || (_defs144 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000150070947587017655350000007683588417822709436_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs145 || (_defs145 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000004541707903835163780000000321939478610205878_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs146 || (_defs146 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000009549339722528310560000016452236519214070172_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000058559653376460646940000010419847371218976159_",
    style: {
      clipPath: "url(#SVGID_00000020369176692403554200000014688289009446493621_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000163042360787947127800000003552569138549186494_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000105393633823563322870000013180202212664707215_",
    style: {
      clipPath: "url(#SVGID_00000058559653376460646940000010419847371218976159_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000086692263488073331290000004881680025673364876_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000165936509717244873680000017158289940367557248_",
    style: {
      clipPath: "url(#SVGID_00000105393633823563322870000013180202212664707215_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000150070947587017655350000007683588417822709436_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000073698309169077331790000003826775240634675863_",
    style: {
      clipPath: "url(#SVGID_00000165936509717244873680000017158289940367557248_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000004541707903835163780000000321939478610205878_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000085217022950863740260000015169364416303646113_",
    style: {
      clipPath: "url(#SVGID_00000073698309169077331790000003826775240634675863_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000009549339722528310560000016452236519214070172_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs147 || (_defs147 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000085932612236818427540000017337841429274009518_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs148 || (_defs148 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000115473064088830605820000002653427394970950569_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs149 || (_defs149 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000050653329897490558590000016172442721061340584_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs150 || (_defs150 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000121245472634711056430000015660240183747823744_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs151 || (_defs151 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000078014413225283917900000005181038953479363463_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs152 || (_defs152 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000138539501222553658140000006526165250600456864_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000158710501911603742630000014413635248563736492_",
    style: {
      clipPath: "url(#SVGID_00000020369176692403554200000014688289009446493621_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000085932612236818427540000017337841429274009518_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000131325409131603839900000014251518712777270966_",
    style: {
      clipPath: "url(#SVGID_00000158710501911603742630000014413635248563736492_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000115473064088830605820000002653427394970950569_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000090264455364594339660000015755428415408755885_",
    style: {
      clipPath: "url(#SVGID_00000131325409131603839900000014251518712777270966_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000050653329897490558590000016172442721061340584_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000071518363260738226020000000877946739309025689_",
    style: {
      clipPath: "url(#SVGID_00000090264455364594339660000015755428415408755885_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000121245472634711056430000015660240183747823744_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000166651395695850215770000002032981079652424838_",
    style: {
      clipPath: "url(#SVGID_00000071518363260738226020000000877946739309025689_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000078014413225283917900000005181038953479363463_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000025415616781947153500000007856257356576241820_",
    style: {
      clipPath: "url(#SVGID_00000166651395695850215770000002032981079652424838_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000138539501222553658140000006526165250600456864_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072266980889503489770000013305027553240642469_",
    gradientUnits: "userSpaceOnUse",
    x1: -295.2216,
    y1: 185.0019,
    x2: -140.1082,
    y2: 56.0155,
    gradientTransform: "matrix(1 0 0 -1 313.6061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000025415616781947153500000007856257356576241820_)",
      fill: "url(#SVGID_00000072266980889503489770000013305027553240642469_)"
    },
    d: " M43.6,34.9C39.1,16.4,28.2,3.4,27.9,3.1c0.2,0.5,20.1,41.8,7,88.3h5c0,0,3.8-10.3,5.1-28.5c0.3-4,0.4-8.3,0.4-12.9 C45.4,44.6,44.7,39.6,43.6,34.9z"
  })))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183238401266951768270000012343226857459294130_",
    gradientUnits: "userSpaceOnUse",
    x1: -295.2216,
    y1: 185.0019,
    x2: -140.1082,
    y2: 56.0155,
    gradientTransform: "matrix(1 0 0 -1 313.6061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000020369176692403554200000014688289009446493621_)",
      mask: "url(#SVGID_00000038403602023882672620000013071550106691496104_)",
      fill: "url(#SVGID_00000183238401266951768270000012343226857459294130_)"
    },
    d: " M43.6,34.9C39.1,16.4,28.2,3.4,27.9,3.1c0.2,0.5,20.1,41.8,7,88.3h5c0,0,3.8-10.3,5.1-28.5c0.3-4,0.4-8.3,0.4-12.9 C45.4,44.6,44.7,39.6,43.6,34.9z"
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M43.6,34.9C39.1,16.4,28.2,3.4,27.9,3.1c0.2,0.5,20.1,41.8,7,88.3h5c0,0,3.8-10.3,5.1-28.5 c0.3-4,0.4-8.3,0.4-12.9C45.4,44.6,44.7,39.6,43.6,34.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs153 || (_defs153 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000032626481796816455300000003318649957191929756_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000043416998602150602280000014684912036779642782_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000032626481796816455300000003318649957191929756_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs154 || (_defs154 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000152948368208991130980000005348793453979001250_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs155 || (_defs155 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000055665635156861106090000003352687154016008834_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000017506006617343559510000006239950415720176808_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000152948368208991130980000005348793453979001250_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000098899377238744776490000010415823852198884506_",
    style: {
      clipPath: "url(#SVGID_00000017506006617343559510000006239950415720176808_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000055665635156861106090000003352687154016008834_",
    style: {
      overflow: "visible"
    }
  })), _defs156 || (_defs156 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000181052829747094064480000004724095933013327784_",
    filterUnits: "userSpaceOnUse",
    x: 10.6,
    y: 3.1,
    width: 17.4,
    height: 88.3
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 10.6,
    y: 3.1,
    width: 17.4,
    height: 88.3,
    id: "SVGID_00000094579118633890923690000005376697554863416983_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000181052829747094064480000004724095933013327784_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs157 || (_defs157 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000065075520869056833460000001853048881934557599_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs158 || (_defs158 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000095312814804533828050000002376574010335078018_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000177454096871227686680000014392944665740563621_",
    style: {
      clipPath: "url(#SVGID_00000098899377238744776490000010415823852198884506_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000065075520869056833460000001853048881934557599_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000085234884131413780140000015670238320731283367_",
    style: {
      clipPath: "url(#SVGID_00000177454096871227686680000014392944665740563621_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000095312814804533828050000002376574010335078018_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs159 || (_defs159 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000096054774428477784540000016222606810317375880_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs160 || (_defs160 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000179637147087030651630000017363625941866335158_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs161 || (_defs161 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000161615462336572705630000000065099709542825385_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000121259949292748847300000007686454656868646548_",
    style: {
      clipPath: "url(#SVGID_00000098899377238744776490000010415823852198884506_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000096054774428477784540000016222606810317375880_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000172400602361988007250000017440626559823203734_",
    style: {
      clipPath: "url(#SVGID_00000121259949292748847300000007686454656868646548_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000179637147087030651630000017363625941866335158_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000101075035495250939760000006653276899392657588_",
    style: {
      clipPath: "url(#SVGID_00000172400602361988007250000017440626559823203734_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000161615462336572705630000000065099709542825385_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs162 || (_defs162 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000079463454901598849780000006641422381390681516_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs163 || (_defs163 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000117673173924469246660000003362963547901612937_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000020377175245395247620000017790990042457133485_",
    style: {
      clipPath: "url(#SVGID_00000098899377238744776490000010415823852198884506_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000079463454901598849780000006641422381390681516_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000085215448230230271350000010042426097616437642_",
    style: {
      clipPath: "url(#SVGID_00000020377175245395247620000017790990042457133485_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000117673173924469246660000003362963547901612937_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs164 || (_defs164 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000145759078210447200450000001303994416736548254_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs165 || (_defs165 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000090275092196517389300000014753546622364133565_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs166 || (_defs166 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000119079580569289787350000017889494968244016063_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000103241218564860610770000000396612781370415807_",
    style: {
      clipPath: "url(#SVGID_00000098899377238744776490000010415823852198884506_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000145759078210447200450000001303994416736548254_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000088115519925379867540000016944262571890365326_",
    style: {
      clipPath: "url(#SVGID_00000103241218564860610770000000396612781370415807_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000090275092196517389300000014753546622364133565_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000147208820558171491550000015268773975795701428_",
    style: {
      clipPath: "url(#SVGID_00000088115519925379867540000016944262571890365326_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000119079580569289787350000017889494968244016063_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs167 || (_defs167 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000155131511101273685870000009418699090298806457_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs168 || (_defs168 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000165916022237378849560000014152648072444316583_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs169 || (_defs169 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000155850574244752446540000003517586679672664709_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs170 || (_defs170 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000124145497581398827770000006788203367116691868_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000085240063440934848290000007146971493167293847_",
    style: {
      clipPath: "url(#SVGID_00000098899377238744776490000010415823852198884506_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000155131511101273685870000009418699090298806457_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000168807876551406340490000002701438351441895588_",
    style: {
      clipPath: "url(#SVGID_00000085240063440934848290000007146971493167293847_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000165916022237378849560000014152648072444316583_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000183942658831831299600000007498204687706763191_",
    style: {
      clipPath: "url(#SVGID_00000168807876551406340490000002701438351441895588_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000155850574244752446540000003517586679672664709_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000112597836341254308190000014083363780968780677_",
    style: {
      clipPath: "url(#SVGID_00000183942658831831299600000007498204687706763191_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000124145497581398827770000006788203367116691868_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs171 || (_defs171 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000130623528412676418950000007193978113179878284_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs172 || (_defs172 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000032640556180283473500000017710957992069026961_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000125584464311132840970000018229824475022720952_",
    style: {
      clipPath: "url(#SVGID_00000098899377238744776490000010415823852198884506_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000130623528412676418950000007193978113179878284_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000085209252681959345040000010997461886313925550_",
    style: {
      clipPath: "url(#SVGID_00000125584464311132840970000018229824475022720952_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000032640556180283473500000017710957992069026961_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs173 || (_defs173 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000047754499683132373820000006044018788138265511_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs174 || (_defs174 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000153700605033112278400000000390929575047916453_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs175 || (_defs175 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000119828092969613982870000013908185438914643878_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000078038357360031007650000010749177156250263173_",
    style: {
      clipPath: "url(#SVGID_00000098899377238744776490000010415823852198884506_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000047754499683132373820000006044018788138265511_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000026154164620171806550000014580943299645655689_",
    style: {
      clipPath: "url(#SVGID_00000078038357360031007650000010749177156250263173_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000153700605033112278400000000390929575047916453_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000162344050472421981240000013157204853400414617_",
    style: {
      clipPath: "url(#SVGID_00000026154164620171806550000014580943299645655689_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000119828092969613982870000013908185438914643878_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs176 || (_defs176 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000095320056728262185830000015092277973854372528_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs177 || (_defs177 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000156570743927637737510000009619335724505282478_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs178 || (_defs178 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000069381350428794368500000003343866596669438352_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs179 || (_defs179 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000052798242763607546540000011362073533046226829_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000158741238845535920700000001600727006795782534_",
    style: {
      clipPath: "url(#SVGID_00000098899377238744776490000010415823852198884506_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000095320056728262185830000015092277973854372528_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000146482672710998602200000016827019698694375828_",
    style: {
      clipPath: "url(#SVGID_00000158741238845535920700000001600727006795782534_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000156570743927637737510000009619335724505282478_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000173119045251694779270000000438918919561003450_",
    style: {
      clipPath: "url(#SVGID_00000146482672710998602200000016827019698694375828_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000069381350428794368500000003343866596669438352_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000072986435274519875820000016814487883744257416_",
    style: {
      clipPath: "url(#SVGID_00000173119045251694779270000000438918919561003450_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000052798242763607546540000011362073533046226829_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs180 || (_defs180 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000018217722360287626020000001524476648030211259_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs181 || (_defs181 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000018229798806647578330000012851483273221015939_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs182 || (_defs182 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000045577540226243206820000005375931454832982404_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs183 || (_defs183 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000013181540784529393140000010449603306664708513_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs184 || (_defs184 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000002362261074538161080000018085116422030789804_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000080909545698289898770000003874553205432983708_",
    style: {
      clipPath: "url(#SVGID_00000098899377238744776490000010415823852198884506_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000018217722360287626020000001524476648030211259_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000098922343352443273530000001389073375604348054_",
    style: {
      clipPath: "url(#SVGID_00000080909545698289898770000003874553205432983708_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000018229798806647578330000012851483273221015939_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000168797090327202048420000007056219367165749890_",
    style: {
      clipPath: "url(#SVGID_00000098922343352443273530000001389073375604348054_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000045577540226243206820000005375931454832982404_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000052096128345649128610000014806159391722072457_",
    style: {
      clipPath: "url(#SVGID_00000168797090327202048420000007056219367165749890_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000013181540784529393140000010449603306664708513_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000023995695186216966190000012700352706514234814_",
    style: {
      clipPath: "url(#SVGID_00000052096128345649128610000014806159391722072457_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000002362261074538161080000018085116422030789804_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs185 || (_defs185 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000147920811694992560640000007533781853605045692_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs186 || (_defs186 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000043444807812690864080000017685899471844520365_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs187 || (_defs187 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000003805250387002423110000016106480288639218062_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs188 || (_defs188 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000090295901605374118750000010763404919805711506_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs189 || (_defs189 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000081624309450227362070000010048099862659210124_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs190 || (_defs190 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000146502005526308362310000006035758896123782333_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000109723319827794284080000012584071174042628504_",
    style: {
      clipPath: "url(#SVGID_00000098899377238744776490000010415823852198884506_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000147920811694992560640000007533781853605045692_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000003076515142247593840000013757243520128542123_",
    style: {
      clipPath: "url(#SVGID_00000109723319827794284080000012584071174042628504_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000043444807812690864080000017685899471844520365_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000149349592835842738170000006191703585209079732_",
    style: {
      clipPath: "url(#SVGID_00000003076515142247593840000013757243520128542123_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000003805250387002423110000016106480288639218062_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000019676772137001558790000010039143036867938736_",
    style: {
      clipPath: "url(#SVGID_00000149349592835842738170000006191703585209079732_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000090295901605374118750000010763404919805711506_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000048471582265647967280000015292556815126367388_",
    style: {
      clipPath: "url(#SVGID_00000019676772137001558790000010039143036867938736_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000081624309450227362070000010048099862659210124_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000176739017400976492200000010607707373881596601_",
    style: {
      clipPath: "url(#SVGID_00000048471582265647967280000015292556815126367388_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000146502005526308362310000006035758896123782333_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085252733979114192160000002427486439621081498_",
    gradientUnits: "userSpaceOnUse",
    x1: -284.7096,
    y1: 159.8732,
    x2: -328.8358,
    y2: 251.6705,
    gradientTransform: "matrix(1 0 0 -1 313.6061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000176739017400976492200000010607707373881596601_)",
      fill: "url(#SVGID_00000085252733979114192160000002427486439621081498_)"
    },
    d: " M12.4,34.9C16.9,16.4,27.8,3.4,28,3.1c-0.3,0.5-20.1,41.8-7,88.3h-4.9c0,0-3.8-10.3-5.1-28.5 c-0.3-4-0.4-8.3-0.4-12.9C10.6,44.6,11.3,39.6,12.4,34.9z"
  })))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121258469544763102670000013200786203184628634_",
    gradientUnits: "userSpaceOnUse",
    x1: -284.7096,
    y1: 159.8732,
    x2: -328.8358,
    y2: 251.6705,
    gradientTransform: "matrix(1 0 0 -1 313.6061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000098899377238744776490000010415823852198884506_)",
      mask: "url(#SVGID_00000094579118633890923690000005376697554863416983_)",
      fill: "url(#SVGID_00000121258469544763102670000013200786203184628634_)"
    },
    d: " M12.4,34.9C16.9,16.4,27.8,3.4,28,3.1c-0.3,0.5-20.1,41.8-7,88.3h-4.9c0,0-3.8-10.3-5.1-28.5c-0.3-4-0.4-8.3-0.4-12.9 C10.6,44.6,11.3,39.6,12.4,34.9z"
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008115268281562358260000005510268922369562784_",
    gradientUnits: "userSpaceOnUse",
    x1: -284.9085,
    y1: 159.871,
    x2: -329.0347,
    y2: 251.6683,
    gradientTransform: "matrix(1 0 0 -1 313.6061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.48,
      fill: "url(#SVGID_00000008115268281562358260000005510268922369562784_)",
      enableBackground: "new"
    },
    d: " M12.2,34.9C16.7,16.4,27.6,3.4,27.8,3.1c-0.3,0.5-20.1,41.8-7,88.3h-4.9c0,0-3.8-10.3-5.1-28.5c-0.3-4-0.4-8.3-0.4-12.9 C10.4,44.6,11.1,39.6,12.2,34.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000140694642938295627940000007525552649578918026_",
    gradientUnits: "userSpaceOnUse",
    x1: -561.4093,
    y1: -791.2906,
    x2: -561.4093,
    y2: -806.923,
    gradientTransform: "matrix(1 0 0 -1 588.6593 -709.3386)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1E110E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7931A"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000140694642938295627940000007525552649578918026_)"
    },
    points: "26.7,94.9 27.9,106.1  27.9,68.2  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000027602183546401275920000015852705525457216178_",
    gradientUnits: "userSpaceOnUse",
    x1: -560.2093,
    y1: -807.6018,
    x2: -560.2093,
    y2: -795.5774,
    gradientTransform: "matrix(1 0 0 -1 588.6593 -709.3386)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1E110E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7931A"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000027602183546401275920000015852705525457216178_)"
    },
    points: "29.1,94.9 27.9,106.1  27.9,68.2  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs191 || (_defs191 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000012433710392408690240000014725223316855159960_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000147191003775120207590000008328634029352051110_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000012433710392408690240000014725223316855159960_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs192 || (_defs192 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000129890462809471276450000012923567583929154959_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs193 || (_defs193 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000152235213188235132740000010863826969648472459_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000120545330922391753970000016720311678476478090_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000129890462809471276450000012923567583929154959_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000031167016572639871030000000968694525635401885_",
    style: {
      clipPath: "url(#SVGID_00000120545330922391753970000016720311678476478090_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000152235213188235132740000010863826969648472459_",
    style: {
      overflow: "visible"
    }
  })), _defs194 || (_defs194 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000021805177105976953850000009347643792658702486_",
    filterUnits: "userSpaceOnUse",
    x: 20.8,
    y: 42.1,
    width: 15.2,
    height: 15.2
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 20.8,
    y: 42.1,
    width: 15.2,
    height: 15.2,
    id: "SVGID_00000100380826706935040680000015462664244254026657_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000021805177105976953850000009347643792658702486_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs195 || (_defs195 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000124866681967477879060000000275691289625157771_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs196 || (_defs196 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000008123238949983889420000011208107934102405822_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000113315230290926444730000007330774773829172124_",
    style: {
      clipPath: "url(#SVGID_00000031167016572639871030000000968694525635401885_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000124866681967477879060000000275691289625157771_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000131332789831889720920000003923830378104891032_",
    style: {
      clipPath: "url(#SVGID_00000113315230290926444730000007330774773829172124_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000008123238949983889420000011208107934102405822_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs197 || (_defs197 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000010290255848737087840000011315165645984382117_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs198 || (_defs198 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000045584380685266209610000008496715369252414869_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs199 || (_defs199 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000128461655586067166830000014177023843639981191_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000063602425040605169650000010832001401355519666_",
    style: {
      clipPath: "url(#SVGID_00000031167016572639871030000000968694525635401885_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000010290255848737087840000011315165645984382117_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000169533957377199567770000008574113769392836028_",
    style: {
      clipPath: "url(#SVGID_00000063602425040605169650000010832001401355519666_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000045584380685266209610000008496715369252414869_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000086662375779955230140000009171819082346407559_",
    style: {
      clipPath: "url(#SVGID_00000169533957377199567770000008574113769392836028_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000128461655586067166830000014177023843639981191_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs200 || (_defs200 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000103982204781433434910000007302087842974202263_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs201 || (_defs201 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000155140417019355030600000016140251841167946131_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000176022336209781674540000007270321186925033643_",
    style: {
      clipPath: "url(#SVGID_00000031167016572639871030000000968694525635401885_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000103982204781433434910000007302087842974202263_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000111896534101413812840000004237679360583884990_",
    style: {
      clipPath: "url(#SVGID_00000176022336209781674540000007270321186925033643_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000155140417019355030600000016140251841167946131_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs202 || (_defs202 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000088843793227017478110000004854700582507691663_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs203 || (_defs203 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000057858212836502534180000002430199791472174231_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs204 || (_defs204 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000137846718896245523530000005349762789707062682_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000011717896483695159740000007272329053213252754_",
    style: {
      clipPath: "url(#SVGID_00000031167016572639871030000000968694525635401885_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000088843793227017478110000004854700582507691663_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000144326541080007899200000012819797768505100722_",
    style: {
      clipPath: "url(#SVGID_00000011717896483695159740000007272329053213252754_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000057858212836502534180000002430199791472174231_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000033328113599064485260000018354390659536014002_",
    style: {
      clipPath: "url(#SVGID_00000144326541080007899200000012819797768505100722_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000137846718896245523530000005349762789707062682_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs205 || (_defs205 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000055706509244737358760000001186694471580147843_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs206 || (_defs206 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000012445220546334965840000008591725188694708410_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs207 || (_defs207 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000014621054571378830920000004566093146899471523_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs208 || (_defs208 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000170247224356174910430000009365189606655987587_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000039814355764218550320000016481696125772741796_",
    style: {
      clipPath: "url(#SVGID_00000031167016572639871030000000968694525635401885_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000055706509244737358760000001186694471580147843_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000058566577884087639800000002020857707610591365_",
    style: {
      clipPath: "url(#SVGID_00000039814355764218550320000016481696125772741796_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000012445220546334965840000008591725188694708410_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000088120761710221340100000015789080457511357631_",
    style: {
      clipPath: "url(#SVGID_00000058566577884087639800000002020857707610591365_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000014621054571378830920000004566093146899471523_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000119090865895805404750000013052137260176047536_",
    style: {
      clipPath: "url(#SVGID_00000088120761710221340100000015789080457511357631_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000170247224356174910430000009365189606655987587_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs209 || (_defs209 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000176002189633262556440000010361243909983177104_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs210 || (_defs210 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000148622474589899081040000014421809538776189877_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000144307399322739651340000007944430178555703209_",
    style: {
      clipPath: "url(#SVGID_00000031167016572639871030000000968694525635401885_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000176002189633262556440000010361243909983177104_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000142166536077969538350000000942479424349656449_",
    style: {
      clipPath: "url(#SVGID_00000144307399322739651340000007944430178555703209_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000148622474589899081040000014421809538776189877_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs211 || (_defs211 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000035513958743838237680000009716347813877837969_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs212 || (_defs212 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000104678680918427688200000005391369848978464947_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs213 || (_defs213 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000100374900482390684210000016420160768901209776_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000154405471860501828770000010995275874378747066_",
    style: {
      clipPath: "url(#SVGID_00000031167016572639871030000000968694525635401885_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000035513958743838237680000009716347813877837969_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000086685878604146660110000003416233767970187141_",
    style: {
      clipPath: "url(#SVGID_00000154405471860501828770000010995275874378747066_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000104678680918427688200000005391369848978464947_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000023984623183475702080000018423906625269183622_",
    style: {
      clipPath: "url(#SVGID_00000086685878604146660110000003416233767970187141_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000100374900482390684210000016420160768901209776_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs214 || (_defs214 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000146479852190835283150000009666964896904926633_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs215 || (_defs215 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000165945701854331527660000015228617188061213858_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs216 || (_defs216 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000075128036643207920560000011823079026936012468_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs217 || (_defs217 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000155847906861647528530000015813306650909414836_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000062898744292534129790000001635650758805028231_",
    style: {
      clipPath: "url(#SVGID_00000031167016572639871030000000968694525635401885_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000146479852190835283150000009666964896904926633_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000041257835033601190530000014134001864869037482_",
    style: {
      clipPath: "url(#SVGID_00000062898744292534129790000001635650758805028231_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000165945701854331527660000015228617188061213858_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000035525836918898481600000001083229791439130525_",
    style: {
      clipPath: "url(#SVGID_00000041257835033601190530000014134001864869037482_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000075128036643207920560000011823079026936012468_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000062898137398712079050000013872115246010264244_",
    style: {
      clipPath: "url(#SVGID_00000035525836918898481600000001083229791439130525_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000155847906861647528530000015813306650909414836_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs218 || (_defs218 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000172402600799962733760000001419123055905741755_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs219 || (_defs219 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000151504015066608514460000011572704187551080873_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs220 || (_defs220 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000029027091042690917750000010686227888786110139_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs221 || (_defs221 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000062166751757408306320000010399720284449617850_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs222 || (_defs222 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000124852235017098780480000013240815868902609549_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000160183105649508972010000005319002105259431047_",
    style: {
      clipPath: "url(#SVGID_00000031167016572639871030000000968694525635401885_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000172402600799962733760000001419123055905741755_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000108281558465855295830000008173649812016680880_",
    style: {
      clipPath: "url(#SVGID_00000160183105649508972010000005319002105259431047_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000151504015066608514460000011572704187551080873_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000045598731369124078520000017383214338583028652_",
    style: {
      clipPath: "url(#SVGID_00000108281558465855295830000008173649812016680880_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000029027091042690917750000010686227888786110139_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000063593884499017151470000012794970501460664499_",
    style: {
      clipPath: "url(#SVGID_00000045598731369124078520000017383214338583028652_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000062166751757408306320000010399720284449617850_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000064314347669754515920000011980289528047878564_",
    style: {
      clipPath: "url(#SVGID_00000063593884499017151470000012794970501460664499_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000124852235017098780480000013240815868902609549_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs223 || (_defs223 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000156576870591075738680000011440105642027596202_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs224 || (_defs224 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000101105047731163182410000006105353047574171070_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs225 || (_defs225 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000179612958194245535380000002748173086332442037_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs226 || (_defs226 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000014601839263644912080000000124715533001204873_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs227 || (_defs227 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000018216900011525737520000016716163996141648051_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs228 || (_defs228 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000180366905562047934510000017614595770311050412_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000001633536970085238910000012765183828132287626_",
    style: {
      clipPath: "url(#SVGID_00000031167016572639871030000000968694525635401885_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000156576870591075738680000011440105642027596202_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000153685764719345338340000005326529626804346511_",
    style: {
      clipPath: "url(#SVGID_00000001633536970085238910000012765183828132287626_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000101105047731163182410000006105353047574171070_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000056386876983809910540000001501047764341257377_",
    style: {
      clipPath: "url(#SVGID_00000153685764719345338340000005326529626804346511_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000179612958194245535380000002748173086332442037_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000013163858727159039600000000515583322719746179_",
    style: {
      clipPath: "url(#SVGID_00000056386876983809910540000001501047764341257377_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000014601839263644912080000000124715533001204873_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000003101374771718656380000010193163263726941353_",
    style: {
      clipPath: "url(#SVGID_00000013163858727159039600000000515583322719746179_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000018216900011525737520000016716163996141648051_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000080176548119680255640000012732272326207149234_",
    style: {
      clipPath: "url(#SVGID_00000003101374771718656380000010193163263726941353_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000180366905562047934510000017614595770311050412_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000038391174307928750000000017039019895292582800_",
    gradientUnits: "userSpaceOnUse",
    x1: -280.5814,
    y1: 168.6556,
    x2: -320.689,
    y2: 195.3788,
    gradientTransform: "matrix(1 0 0 -1 313.6061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      clipPath: "url(#SVGID_00000080176548119680255640000012732272326207149234_)",
      fill: "url(#SVGID_00000038391174307928750000000017039019895292582800_)"
    },
    cx: 28.4,
    cy: 49.7,
    r: 7.6
  })))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000169541035984922885360000012203146442748177333_",
    gradientUnits: "userSpaceOnUse",
    x1: -280.5814,
    y1: 168.6556,
    x2: -320.689,
    y2: 195.3788,
    gradientTransform: "matrix(1 0 0 -1 313.6061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      clipPath: "url(#SVGID_00000031167016572639871030000000968694525635401885_)",
      mask: "url(#SVGID_00000100380826706935040680000015462664244254026657_)",
      fill: "url(#SVGID_00000169541035984922885360000012203146442748177333_)"
    },
    cx: 28.4,
    cy: 49.7,
    r: 7.6
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000151502145193762873880000016662322909306388412_",
    gradientUnits: "userSpaceOnUse",
    x1: -280.5814,
    y1: 168.6556,
    x2: -320.689,
    y2: 195.3788,
    gradientTransform: "matrix(1 0 0 -1 313.6061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#06090F"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000151502145193762873880000016662322909306388412_)"
    },
    cx: 28.4,
    cy: 49.7,
    r: 7.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052807095606030729360000006928370573165125037_",
    gradientUnits: "userSpaceOnUse",
    x1: -560.8093,
    y1: -751.5059,
    x2: -560.8093,
    y2: -762.7059,
    gradientTransform: "matrix(1 0 0 -1 588.6593 -709.3386)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09148491,
    style: {
      stopColor: "#14161C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2348,
    style: {
      stopColor: "#3A2317"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7931A"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000052807095606030729360000006928370573165125037_)"
    },
    cx: 27.9,
    cy: 49.3,
    r: 7
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000061450573788441723820000014699972491683570563_",
    gradientUnits: "userSpaceOnUse",
    x1: -558.3572,
    y1: -762.5106,
    x2: -561.9645,
    y2: -756.8646,
    gradientTransform: "matrix(1 0 0 -1 588.6593 -709.3386)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09148491,
    style: {
      stopColor: "#14161C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2348,
    style: {
      stopColor: "#3A2317"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7931A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000061450573788441723820000014699972491683570563_)"
    },
    d: "M32.6,47.8 c-0.2-0.7-0.5-1.2-0.9-1.7c-0.3-0.4-0.7-0.7-1.1-1c-0.8-0.5-1.7-0.8-2.7-0.8c-2.7,0-5,2.2-5,5c0,1,0.3,2,0.8,2.7 c0.3,0.4,0.6,0.8,1,1.1c0.5,0.4,1.1,0.7,1.7,0.9c0.5,0.1,1,0.2,1.5,0.2c2.7,0,5-2.2,5-5C32.9,48.7,32.8,48.2,32.6,47.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs229 || (_defs229 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000016778652559994945850000003015193868763423366_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000050624094736936552560000013103875185816597379_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000016778652559994945850000003015193868763423366_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs230 || (_defs230 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000065067208023224918210000015165563487957851303_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs231 || (_defs231 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000108306891872242296740000000655081628584632510_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000043416518104510328920000001007773105422770876_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000065067208023224918210000015165563487957851303_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000018218762760911776400000003110245336857957026_",
    style: {
      clipPath: "url(#SVGID_00000043416518104510328920000001007773105422770876_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000108306891872242296740000000655081628584632510_",
    style: {
      overflow: "visible"
    }
  })), _defs232 || (_defs232 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000021115709609534221320000003409181040372233643_",
    filterUnits: "userSpaceOnUse",
    x: 22.9,
    y: 44.3,
    width: 7.7,
    height: 7.7
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 22.9,
    y: 44.3,
    width: 7.7,
    height: 7.7,
    id: "SVGID_00000179616600317074372900000004251686568948989353_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000021115709609534221320000003409181040372233643_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs233 || (_defs233 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000173857368711672964610000014982512002538243508_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs234 || (_defs234 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000166642755433027931710000014355737919047854271_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000093158144908339150880000007668299680571853204_",
    style: {
      clipPath: "url(#SVGID_00000018218762760911776400000003110245336857957026_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000173857368711672964610000014982512002538243508_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000123429696446434877290000013805698842760652194_",
    style: {
      clipPath: "url(#SVGID_00000093158144908339150880000007668299680571853204_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000166642755433027931710000014355737919047854271_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs235 || (_defs235 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000097466661572230054710000000873579700067742613_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs236 || (_defs236 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000013169408411753043500000001094521490719744676_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs237 || (_defs237 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000054961009935276340480000009491597326060215171_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000015335003579179950990000001692322972607082377_",
    style: {
      clipPath: "url(#SVGID_00000018218762760911776400000003110245336857957026_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000097466661572230054710000000873579700067742613_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000019659592020511535760000017546875644830701716_",
    style: {
      clipPath: "url(#SVGID_00000015335003579179950990000001692322972607082377_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000013169408411753043500000001094521490719744676_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000055687383440460882980000001980235583334733484_",
    style: {
      clipPath: "url(#SVGID_00000019659592020511535760000017546875644830701716_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000054961009935276340480000009491597326060215171_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs238 || (_defs238 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000055685403281303553740000007801260136963261373_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs239 || (_defs239 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000096056486207460949900000016040634271828601761_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000062161089495770996980000001546854809830359171_",
    style: {
      clipPath: "url(#SVGID_00000018218762760911776400000003110245336857957026_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000055685403281303553740000007801260136963261373_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000082332485885406889910000010489863538287234192_",
    style: {
      clipPath: "url(#SVGID_00000062161089495770996980000001546854809830359171_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000096056486207460949900000016040634271828601761_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs240 || (_defs240 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000155826095839416248910000018408858216836255390_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs241 || (_defs241 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000149383020903015236720000006780520170086425504_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs242 || (_defs242 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000124847687990655860980000005343398937070562704_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000071550078434078615840000007396311624508919188_",
    style: {
      clipPath: "url(#SVGID_00000018218762760911776400000003110245336857957026_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000155826095839416248910000018408858216836255390_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000147207547721865552440000001910050580323063971_",
    style: {
      clipPath: "url(#SVGID_00000071550078434078615840000007396311624508919188_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000149383020903015236720000006780520170086425504_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000136382113523989893890000008036847550401782939_",
    style: {
      clipPath: "url(#SVGID_00000147207547721865552440000001910050580323063971_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000124847687990655860980000005343398937070562704_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs243 || (_defs243 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000163059290306424434450000017842958784719127441_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs244 || (_defs244 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000165194130827970832170000014900437447969785757_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs245 || (_defs245 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000155126076034397606100000005133101218253453461_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs246 || (_defs246 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000167360745530327391120000011907353164390079622_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000099662646400088799580000014896742790880478342_",
    style: {
      clipPath: "url(#SVGID_00000018218762760911776400000003110245336857957026_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000163059290306424434450000017842958784719127441_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000181077367625798402770000002450408123581074865_",
    style: {
      clipPath: "url(#SVGID_00000099662646400088799580000014896742790880478342_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000165194130827970832170000014900437447969785757_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000088848112379161269600000004466349606582810783_",
    style: {
      clipPath: "url(#SVGID_00000181077367625798402770000002450408123581074865_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000155126076034397606100000005133101218253453461_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000125572205165738696440000002984554890847152789_",
    style: {
      clipPath: "url(#SVGID_00000088848112379161269600000004466349606582810783_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000167360745530327391120000011907353164390079622_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs247 || (_defs247 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000095335744025788788410000015644357273831714946_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs248 || (_defs248 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000121987616139651912770000004411451228681206192_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000138532566033826522450000003940243731826964663_",
    style: {
      clipPath: "url(#SVGID_00000018218762760911776400000003110245336857957026_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000095335744025788788410000015644357273831714946_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000062872830560173132130000005495862507799263662_",
    style: {
      clipPath: "url(#SVGID_00000138532566033826522450000003940243731826964663_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000121987616139651912770000004411451228681206192_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs249 || (_defs249 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000110447951642450174050000009513488971757777547_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs250 || (_defs250 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000121981382862991618290000015330593828506782888_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs251 || (_defs251 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000170238619494872384710000010329006367268973731_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000087393503709001968720000002583440672541304750_",
    style: {
      clipPath: "url(#SVGID_00000018218762760911776400000003110245336857957026_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000110447951642450174050000009513488971757777547_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000065757630595780319270000017909749278863697056_",
    style: {
      clipPath: "url(#SVGID_00000087393503709001968720000002583440672541304750_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000121981382862991618290000015330593828506782888_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000042013547810108723970000018299004820719276726_",
    style: {
      clipPath: "url(#SVGID_00000065757630595780319270000017909749278863697056_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000170238619494872384710000010329006367268973731_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs252 || (_defs252 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000158721949257417484880000008202323551318293925_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs253 || (_defs253 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000168083260717877259500000016205011150582660746_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs254 || (_defs254 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000059277398958252529310000016253167010009618110_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs255 || (_defs255 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000025406735708383277540000009262700091576936611_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000013889770293097339410000013446367095420180399_",
    style: {
      clipPath: "url(#SVGID_00000018218762760911776400000003110245336857957026_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000158721949257417484880000008202323551318293925_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000030461521758469045500000003966073153416071857_",
    style: {
      clipPath: "url(#SVGID_00000013889770293097339410000013446367095420180399_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000168083260717877259500000016205011150582660746_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000101104226023669030680000005622742830555111869_",
    style: {
      clipPath: "url(#SVGID_00000030461521758469045500000003966073153416071857_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000059277398958252529310000016253167010009618110_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000036944974305604571430000008967339373737125297_",
    style: {
      clipPath: "url(#SVGID_00000101104226023669030680000005622742830555111869_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000025406735708383277540000009262700091576936611_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs256 || (_defs256 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000073686495968432795400000001936936187171858845_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs257 || (_defs257 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000165917487164802538310000003466142729594418827_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs258 || (_defs258 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000142872870604519299530000009343164245351441578_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs259 || (_defs259 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000107554435725048097650000002588399041796513188_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs260 || (_defs260 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000014632226036312898940000000075595900037026964_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000062159964880773242970000011185360856917725630_",
    style: {
      clipPath: "url(#SVGID_00000018218762760911776400000003110245336857957026_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000073686495968432795400000001936936187171858845_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000132792331193422222430000000920784490856491437_",
    style: {
      clipPath: "url(#SVGID_00000062159964880773242970000011185360856917725630_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000165917487164802538310000003466142729594418827_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000008854380406741192670000007129180843738013078_",
    style: {
      clipPath: "url(#SVGID_00000132792331193422222430000000920784490856491437_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000142872870604519299530000009343164245351441578_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000085951736829568965400000017020716666214061221_",
    style: {
      clipPath: "url(#SVGID_00000008854380406741192670000007129180843738013078_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000107554435725048097650000002588399041796513188_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000075147435345670845510000000777120823181503411_",
    style: {
      clipPath: "url(#SVGID_00000085951736829568965400000017020716666214061221_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000014632226036312898940000000075595900037026964_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs261 || (_defs261 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000065794598498853303250000005156941842544663475_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs262 || (_defs262 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000109752547921260135150000016373503278464641422_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs263 || (_defs263 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000012467381103694608210000002991931893275870856_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs264 || (_defs264 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000064337219076600409240000013551475050324342151_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs265 || (_defs265 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000147916696003281616070000002367309320566829231_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs266 || (_defs266 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000078726795595132060600000010434110277210959248_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000064321564634263531190000005891164731316189066_",
    style: {
      clipPath: "url(#SVGID_00000018218762760911776400000003110245336857957026_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000065794598498853303250000005156941842544663475_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000147220482946006901540000001917499746062497938_",
    style: {
      clipPath: "url(#SVGID_00000064321564634263531190000005891164731316189066_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000109752547921260135150000016373503278464641422_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000097475603525596892940000013202926730032728249_",
    style: {
      clipPath: "url(#SVGID_00000147220482946006901540000001917499746062497938_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000012467381103694608210000002991931893275870856_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000132776430408465378210000011093788851567371674_",
    style: {
      clipPath: "url(#SVGID_00000097475603525596892940000013202926730032728249_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000064337219076600409240000013551475050324342151_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000157280566526701156770000000663591945778115995_",
    style: {
      clipPath: "url(#SVGID_00000132776430408465378210000011093788851567371674_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000147916696003281616070000002367309320566829231_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000162346518189343629230000009337353870266138276_",
    style: {
      clipPath: "url(#SVGID_00000157280566526701156770000000663591945778115995_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000078726795595132060600000010434110277210959248_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000073693508600138750460000011195358174850804158_",
    gradientUnits: "userSpaceOnUse",
    x1: -281.2714,
    y1: 179.946,
    x2: -308.407,
    y2: 156.0496,
    gradientTransform: "matrix(1 0 0 -1 313.6061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000162346518189343629230000009337353870266138276_)",
      fill: "url(#SVGID_00000073693508600138750460000011195358174850804158_)"
    },
    d: " M27.9,44.3c-2.7,0-5,2.2-5,5c0,1,0.3,2,0.8,2.7l6.9-6.9C29.8,44.6,28.9,44.3,27.9,44.3z"
  })))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000154390191818313521020000007039757830447131065_",
    gradientUnits: "userSpaceOnUse",
    x1: -281.2714,
    y1: 179.946,
    x2: -308.407,
    y2: 156.0496,
    gradientTransform: "matrix(1 0 0 -1 313.6061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000018218762760911776400000003110245336857957026_)",
      mask: "url(#SVGID_00000179616600317074372900000004251686568948989353_)",
      fill: "url(#SVGID_00000154390191818313521020000007039757830447131065_)"
    },
    d: " M27.9,44.3c-2.7,0-5,2.2-5,5c0,1,0.3,2,0.8,2.7l6.9-6.9C29.8,44.6,28.9,44.3,27.9,44.3z"
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000125579474540043604040000018201652325667668122_",
    gradientUnits: "userSpaceOnUse",
    x1: -281.2714,
    y1: 179.946,
    x2: -308.407,
    y2: 156.0496,
    gradientTransform: "matrix(1 0 0 -1 313.6061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.48,
      fill: "url(#SVGID_00000125579474540043604040000018201652325667668122_)",
      enableBackground: "new"
    },
    d: " M27.9,44.3c-2.7,0-5,2.2-5,5c0,1,0.3,2,0.8,2.7l6.9-6.9C29.8,44.6,28.9,44.3,27.9,44.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs267 || (_defs267 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000041992479469164041900000017431833199349822626_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000112627664247110409170000016111798593066656959_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000041992479469164041900000017431833199349822626_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs268 || (_defs268 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000131359849913316314640000006318962519665312700_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs269 || (_defs269 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000000192037668670943120000017827542476491882904_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000005945684698093446730000002370188578754631331_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000131359849913316314640000006318962519665312700_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000002385624491058846520000009088762802310345604_",
    style: {
      clipPath: "url(#SVGID_00000005945684698093446730000002370188578754631331_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000000192037668670943120000017827542476491882904_",
    style: {
      overflow: "visible"
    }
  })), _defs270 || (_defs270 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000129926459822128133240000003349613239951595158_",
    filterUnits: "userSpaceOnUse",
    x: 24.8,
    y: 46.1,
    width: 7.9,
    height: 7.8
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 24.8,
    y: 46.1,
    width: 7.9,
    height: 7.8,
    id: "SVGID_00000172435514997990265230000013660528500153627050_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000129926459822128133240000003349613239951595158_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs271 || (_defs271 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000082361110291780687660000003846902616618631556_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs272 || (_defs272 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000139289250815005262200000007568742015704082841_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000154383640619774183450000001506495113297667230_",
    style: {
      clipPath: "url(#SVGID_00000002385624491058846520000009088762802310345604_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000082361110291780687660000003846902616618631556_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000056404004439998232850000003896816433214452354_",
    style: {
      clipPath: "url(#SVGID_00000154383640619774183450000001506495113297667230_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000139289250815005262200000007568742015704082841_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs273 || (_defs273 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000142140341772386189400000011910402088849332111_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs274 || (_defs274 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000088822870295328626270000015844916047477484458_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs275 || (_defs275 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000142141037186914289550000013437876859272335763_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000063632370516722041030000003363385465742064267_",
    style: {
      clipPath: "url(#SVGID_00000002385624491058846520000009088762802310345604_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000142140341772386189400000011910402088849332111_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000079462249799286525130000006132883649993387440_",
    style: {
      clipPath: "url(#SVGID_00000063632370516722041030000003363385465742064267_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000088822870295328626270000015844916047477484458_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000100351108884251942560000013772463202552063104_",
    style: {
      clipPath: "url(#SVGID_00000079462249799286525130000006132883649993387440_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000142141037186914289550000013437876859272335763_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs276 || (_defs276 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000003804740184122487400000006507907504684960188_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs277 || (_defs277 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000005245871159983089310000017235175239765160112_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000081640119372187984530000012161498116993257127_",
    style: {
      clipPath: "url(#SVGID_00000002385624491058846520000009088762802310345604_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000003804740184122487400000006507907504684960188_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000172423989200257293680000005963599524142283429_",
    style: {
      clipPath: "url(#SVGID_00000081640119372187984530000012161498116993257127_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000005245871159983089310000017235175239765160112_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs278 || (_defs278 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000072242773821414758340000013609354706519130265_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs279 || (_defs279 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000163039878149016860700000006456638021080283825_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs280 || (_defs280 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000042012993012930162820000005020918294700127935_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000146466198239325428190000013648034907325480110_",
    style: {
      clipPath: "url(#SVGID_00000002385624491058846520000009088762802310345604_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000072242773821414758340000013609354706519130265_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000012455999446595928970000002280081963248091308_",
    style: {
      clipPath: "url(#SVGID_00000146466198239325428190000013648034907325480110_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000163039878149016860700000006456638021080283825_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000065780803157111273300000013471885673150021013_",
    style: {
      clipPath: "url(#SVGID_00000012455999446595928970000002280081963248091308_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000042012993012930162820000005020918294700127935_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs281 || (_defs281 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000183215446146923169520000014405930575340727731_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs282 || (_defs282 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000075850742293840138870000002175171554194409350_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs283 || (_defs283 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000016049260891183066090000006537805166087382428_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs284 || (_defs284 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000115492739546784623760000011114365910995644578_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000145025670261767598820000016443199845635545003_",
    style: {
      clipPath: "url(#SVGID_00000002385624491058846520000009088762802310345604_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000183215446146923169520000014405930575340727731_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000009577586676235092430000000561732284825392287_",
    style: {
      clipPath: "url(#SVGID_00000145025670261767598820000016443199845635545003_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000075850742293840138870000002175171554194409350_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000165916651977647410090000005673148592029660081_",
    style: {
      clipPath: "url(#SVGID_00000009577586676235092430000000561732284825392287_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000016049260891183066090000006537805166087382428_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000048476915173821202350000007072468940035629481_",
    style: {
      clipPath: "url(#SVGID_00000165916651977647410090000005673148592029660081_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000115492739546784623760000011114365910995644578_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs285 || (_defs285 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000093143002114818734980000004268611206277456559_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs286 || (_defs286 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000085972012352645256350000000269927487251258553_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000054952859585036829160000017730677002947442322_",
    style: {
      clipPath: "url(#SVGID_00000002385624491058846520000009088762802310345604_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000093143002114818734980000004268611206277456559_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000047768709806597955390000003910047517948673446_",
    style: {
      clipPath: "url(#SVGID_00000054952859585036829160000017730677002947442322_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000085972012352645256350000000269927487251258553_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs287 || (_defs287 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000120548932213678579300000000131200141671208380_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs288 || (_defs288 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000013168215590347961120000005312443814587139007_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs289 || (_defs289 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000032610756098608406190000002701833966542028967_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000094595291593321388680000012563527871686089405_",
    style: {
      clipPath: "url(#SVGID_00000002385624491058846520000009088762802310345604_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000120548932213678579300000000131200141671208380_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000075848719346941521280000012304673820330090928_",
    style: {
      clipPath: "url(#SVGID_00000094595291593321388680000012563527871686089405_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000013168215590347961120000005312443814587139007_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000122000093563824481920000012077956449820880529_",
    style: {
      clipPath: "url(#SVGID_00000075848719346941521280000012304673820330090928_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000032610756098608406190000002701833966542028967_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs290 || (_defs290 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000046309103300200578900000017682058001266526381_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs291 || (_defs291 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000050626058235996581240000008632979273425456809_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs292 || (_defs292 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000160872474542713382520000001433719291992849568_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs293 || (_defs293 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000053512589415926386290000005348540205887117441_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000000207206625079124770000008491285957081842364_",
    style: {
      clipPath: "url(#SVGID_00000002385624491058846520000009088762802310345604_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000046309103300200578900000017682058001266526381_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000178182894869758928780000004378213887532191405_",
    style: {
      clipPath: "url(#SVGID_00000000207206625079124770000008491285957081842364_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000050626058235996581240000008632979273425456809_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000015316033601629938570000003115135044888526238_",
    style: {
      clipPath: "url(#SVGID_00000178182894869758928780000004378213887532191405_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000160872474542713382520000001433719291992849568_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000073711197628403769240000014108381995298227878_",
    style: {
      clipPath: "url(#SVGID_00000015316033601629938570000003115135044888526238_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000053512589415926386290000005348540205887117441_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs294 || (_defs294 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000182520923414193712950000017305729130214472083_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs295 || (_defs295 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000175324108550621918270000013194369822119964574_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs296 || (_defs296 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000086658204491036716200000017316138152217414305_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs297 || (_defs297 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000098932563174368728860000007860805134373433731_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs298 || (_defs298 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000075150639385173713960000004121085487913497989_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000085247151457739501720000012919254204784060310_",
    style: {
      clipPath: "url(#SVGID_00000002385624491058846520000009088762802310345604_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000182520923414193712950000017305729130214472083_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000146485225116626152870000001075820090213448851_",
    style: {
      clipPath: "url(#SVGID_00000085247151457739501720000012919254204784060310_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000175324108550621918270000013194369822119964574_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000141424817169055300410000005199346577420587175_",
    style: {
      clipPath: "url(#SVGID_00000146485225116626152870000001075820090213448851_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000086658204491036716200000017316138152217414305_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000003072727032141187230000011834337718590899077_",
    style: {
      clipPath: "url(#SVGID_00000141424817169055300410000005199346577420587175_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000098932563174368728860000007860805134373433731_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000100340955078840480750000001090340328222233998_",
    style: {
      clipPath: "url(#SVGID_00000003072727032141187230000011834337718590899077_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000075150639385173713960000004121085487913497989_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs299 || (_defs299 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000083073564219908611650000001274950061417402528_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs300 || (_defs300 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000018932002351673899270000007530430416000761990_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs301 || (_defs301 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000071559320900430235830000012530727694404217002_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs302 || (_defs302 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000108285076123583538010000018403883622509915293_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), _defs303 || (_defs303 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000019658979959847512710000017244425434284094649_",
    points: "54.5,0.9 53.9,0.4 54.5,0.4  "
  }))), _defs304 || (_defs304 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000127766926489625469470000013238287380823474048_",
    points: "55.6,-1.3 56.1,-0.7 55.6,-0.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000094592798650598416510000010418315390318038666_",
    style: {
      clipPath: "url(#SVGID_00000002385624491058846520000009088762802310345604_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000083073564219908611650000001274950061417402528_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000137107991479938408070000001089288084497810611_",
    style: {
      clipPath: "url(#SVGID_00000094592798650598416510000010418315390318038666_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000018932002351673899270000007530430416000761990_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000140714127218440846540000000525629014996519828_",
    style: {
      clipPath: "url(#SVGID_00000137107991479938408070000001089288084497810611_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000071559320900430235830000012530727694404217002_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000076594269647679932880000005220023745715219128_",
    style: {
      clipPath: "url(#SVGID_00000140714127218440846540000000525629014996519828_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000108285076123583538010000018403883622509915293_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000033349140899908441350000009673199163871591063_",
    style: {
      clipPath: "url(#SVGID_00000076594269647679932880000005220023745715219128_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000019658979959847512710000017244425434284094649_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000154404406585617950160000010245930908296263565_",
    style: {
      clipPath: "url(#SVGID_00000033349140899908441350000009673199163871591063_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000127766926489625469470000013238287380823474048_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047742945720625179180000016577471304206189742_",
    gradientUnits: "userSpaceOnUse",
    x1: -285.5926,
    y1: 177.7752,
    x2: -283.3924,
    y2: 156.4455,
    gradientTransform: "matrix(1 0 0 -1 313.6061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000154404406585617950160000010245930908296263565_)",
      fill: "url(#SVGID_00000047742945720625179180000016577471304206189742_)"
    },
    d: " M31.8,46.1l-7,6.9c0.5,0.4,1.1,0.7,1.7,0.9l6.2-6.2C32.5,47.2,32.1,46.6,31.8,46.1z"
  })))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057845387976374623110000008267412461164354478_",
    gradientUnits: "userSpaceOnUse",
    x1: -285.5926,
    y1: 177.7752,
    x2: -283.3924,
    y2: 156.4455,
    gradientTransform: "matrix(1 0 0 -1 313.6061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000002385624491058846520000009088762802310345604_)",
      mask: "url(#SVGID_00000172435514997990265230000013660528500153627050_)",
      fill: "url(#SVGID_00000057845387976374623110000008267412461164354478_)"
    },
    d: " M31.8,46.1l-7,6.9c0.5,0.4,1.1,0.7,1.7,0.9l6.2-6.2C32.5,47.2,32.1,46.6,31.8,46.1z"
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114761516260341537290000011236313164596129690_",
    gradientUnits: "userSpaceOnUse",
    x1: -285.5926,
    y1: 177.7752,
    x2: -283.3924,
    y2: 156.4455,
    gradientTransform: "matrix(1 0 0 -1 313.6061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.48,
      fill: "url(#SVGID_00000114761516260341537290000011236313164596129690_)",
      enableBackground: "new"
    },
    d: " M31.8,46.1l-7,6.9c0.5,0.4,1.1,0.7,1.7,0.9l6.2-6.2C32.5,47.2,32.1,46.6,31.8,46.1z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011733310712803878310000016831732286534044296_",
    gradientUnits: "userSpaceOnUse",
    x1: -522.9324,
    y1: -949.5424,
    x2: -522.9324,
    y2: -889.7373,
    gradientTransform: "matrix(1 0 0 -1 588.6593 -709.3386)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00193075,
    style: {
      stopColor: "#F9EF8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F5A017"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000011733310712803878310000016831732286534044296_)"
    },
    d: "M76.9,179.6c3,37.6-11,60.7-11,60.7 c-15.7-36.5-11.3-60.7-11.3-60.7H76.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000124141309124894974730000013230860282072301698_",
    cx: -231.4561,
    cy: 174.8703,
    r: 0,
    gradientTransform: "matrix(1 0 0 -1 313.6061 221.4703)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7316"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4358,
    style: {
      stopColor: "#FE7316"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#14161C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000124141309124894974730000013230860282072301698_)"
    },
    d: "M82.2,46.6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127025441660774317160000013520422339383686552_",
    gradientUnits: "userSpaceOnUse",
    x1: -555.2593,
    y1: -837.854,
    x2: -555.2593,
    y2: -893.0669,
    gradientTransform: "matrix(1 0 0 -1 588.6593 -709.3386)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1E110E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7931A"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000127025441660774317160000013520422339383686552_)"
    },
    points: "39.7,127.1 30.6,131.6  20.5,186.9 46.4,164.7  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000028297767776019330120000005232812405456180668_",
    gradientUnits: "userSpaceOnUse",
    x1: -490.3593,
    y1: -837.854,
    x2: -490.3593,
    y2: -893.0669,
    gradientTransform: "matrix(1 0 0 -1 588.6593 -709.3386)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1E110E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7931A"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000028297767776019330120000005232812405456180668_)"
    },
    points: "92,127.1 101.2,131.6  111.2,186.9 85.3,164.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs305 || (_defs305 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000065058408874801433500000017670432007845504168_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000029035349037123231700000007754089639170845571_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000065058408874801433500000017670432007845504168_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs306 || (_defs306 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000130614002017408205300000003213046576781589414_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs307 || (_defs307 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000036952090354165064130000001473621762736546728_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000043416915261778431700000018199095300166947985_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000130614002017408205300000003213046576781589414_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000077318814976532220420000004960225747018895773_",
    style: {
      clipPath: "url(#SVGID_00000043416915261778431700000018199095300166947985_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000036952090354165064130000001473621762736546728_",
    style: {
      overflow: "visible"
    }
  })), _defs308 || (_defs308 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000052784462680000928050000010156031471038529697_",
    filterUnits: "userSpaceOnUse",
    x: 87.9,
    y: 128.9,
    width: 14.3,
    height: 50.3
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 87.9,
    y: 128.9,
    width: 14.3,
    height: 50.3,
    id: "SVGID_00000011024488671851050180000006095091450528520113_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000052784462680000928050000010156031471038529697_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs309 || (_defs309 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000176008721838881279750000003368804079173670798_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs310 || (_defs310 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000089547308345887676750000008865441952430181771_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000153687626331644016520000006075936914454648961_",
    style: {
      clipPath: "url(#SVGID_00000077318814976532220420000004960225747018895773_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000176008721838881279750000003368804079173670798_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000146500080706599846510000003938631388962376126_",
    style: {
      clipPath: "url(#SVGID_00000153687626331644016520000006075936914454648961_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000089547308345887676750000008865441952430181771_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs311 || (_defs311 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000183946660227461219150000008024493234310356099_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs312 || (_defs312 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000093888117636200999940000007266199084950889368_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs313 || (_defs313 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000126325438041552787250000015368923519470878336_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000083075409751461967350000009159801970751301538_",
    style: {
      clipPath: "url(#SVGID_00000077318814976532220420000004960225747018895773_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000183946660227461219150000008024493234310356099_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000057830085100860784560000016640145439359919009_",
    style: {
      clipPath: "url(#SVGID_00000083075409751461967350000009159801970751301538_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000093888117636200999940000007266199084950889368_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000049194886899450144750000010148792330199338639_",
    style: {
      clipPath: "url(#SVGID_00000057830085100860784560000016640145439359919009_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000126325438041552787250000015368923519470878336_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs314 || (_defs314 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000044875080764194094660000009912476905267791039_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs315 || (_defs315 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000178163854105627815510000006344059423859957636_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000041265904542268093010000004629493177068820902_",
    style: {
      clipPath: "url(#SVGID_00000077318814976532220420000004960225747018895773_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000044875080764194094660000009912476905267791039_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000028302270966788118370000000444554151749097110_",
    style: {
      clipPath: "url(#SVGID_00000041265904542268093010000004629493177068820902_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000178163854105627815510000006344059423859957636_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs316 || (_defs316 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000047055357669010482460000016743814460021207952_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs317 || (_defs317 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000139292621840519041650000008633983360337582525_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs318 || (_defs318 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000162317427297180368190000004067462486404347009_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000152980403589888469910000008076944929893551532_",
    style: {
      clipPath: "url(#SVGID_00000077318814976532220420000004960225747018895773_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000047055357669010482460000016743814460021207952_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000003067347664198646680000005515553685848500146_",
    style: {
      clipPath: "url(#SVGID_00000152980403589888469910000008076944929893551532_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000139292621840519041650000008633983360337582525_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000084519262030812626340000004781559162486083458_",
    style: {
      clipPath: "url(#SVGID_00000003067347664198646680000005515553685848500146_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000162317427297180368190000004067462486404347009_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs319 || (_defs319 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000179622036643558200990000016550907336058537115_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs320 || (_defs320 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000142889422415104776300000018025517384934634411_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs321 || (_defs321 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000016036085219330590480000000353766946975623309_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs322 || (_defs322 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000146476934137245929620000003051381451709430161_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000027562885621894730760000013390549884051726744_",
    style: {
      clipPath: "url(#SVGID_00000077318814976532220420000004960225747018895773_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000179622036643558200990000016550907336058537115_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000160873212601064916000000013325659723904931456_",
    style: {
      clipPath: "url(#SVGID_00000027562885621894730760000013390549884051726744_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000142889422415104776300000018025517384934634411_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000129884317252320186170000013293495578124055709_",
    style: {
      clipPath: "url(#SVGID_00000160873212601064916000000013325659723904931456_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000016036085219330590480000000353766946975623309_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000178900198370820875860000009837942789792985492_",
    style: {
      clipPath: "url(#SVGID_00000129884317252320186170000013293495578124055709_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000146476934137245929620000003051381451709430161_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs323 || (_defs323 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000141422318213747484170000005008063330043851905_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs324 || (_defs324 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000083790975904010004280000006382702103571208335_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000075849322513593681120000007187257021741896120_",
    style: {
      clipPath: "url(#SVGID_00000077318814976532220420000004960225747018895773_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000141422318213747484170000005008063330043851905_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000022544718585721521050000005165360737817719966_",
    style: {
      clipPath: "url(#SVGID_00000075849322513593681120000007187257021741896120_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000083790975904010004280000006382702103571208335_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs325 || (_defs325 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000166673234596281684430000016552618136343123874_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs326 || (_defs326 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000005235632426986303130000001716093612320740483_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs327 || (_defs327 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000067235115163264925400000010116949900056191366_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000041262389886862586680000009580603272327731111_",
    style: {
      clipPath: "url(#SVGID_00000077318814976532220420000004960225747018895773_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000166673234596281684430000016552618136343123874_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000114074564147496526580000001999510687270531255_",
    style: {
      clipPath: "url(#SVGID_00000041262389886862586680000009580603272327731111_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000005235632426986303130000001716093612320740483_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000158737205420742432990000009354986836434508173_",
    style: {
      clipPath: "url(#SVGID_00000114074564147496526580000001999510687270531255_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000067235115163264925400000010116949900056191366_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs328 || (_defs328 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000131352262144193669430000018394773172779089575_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs329 || (_defs329 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000012461976416088817980000015461694789835678395_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs330 || (_defs330 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000053519618349520885080000012896226723314601903_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs331 || (_defs331 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000020370626899633168980000010241726574962754724_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000102508160354211041730000011024486615413690813_",
    style: {
      clipPath: "url(#SVGID_00000077318814976532220420000004960225747018895773_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000131352262144193669430000018394773172779089575_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000144321034777885865250000006427505199537638317_",
    style: {
      clipPath: "url(#SVGID_00000102508160354211041730000011024486615413690813_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000012461976416088817980000015461694789835678395_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000147211090097638500250000008967743568996111024_",
    style: {
      clipPath: "url(#SVGID_00000144321034777885865250000006427505199537638317_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000053519618349520885080000012896226723314601903_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000147929926052501202240000006910741886339003557_",
    style: {
      clipPath: "url(#SVGID_00000147211090097638500250000008967743568996111024_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000020370626899633168980000010241726574962754724_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs332 || (_defs332 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000110435439825664943010000011268462977921661070_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs333 || (_defs333 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000007413552609969028490000001211903221462895507_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs334 || (_defs334 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000118364854880742003200000001860242371901267102_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs335 || (_defs335 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000141432722272039813610000006171326415738478763_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs336 || (_defs336 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000088852436393265633270000012086998696450578316_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000067232011601640934000000017567927363665336481_",
    style: {
      clipPath: "url(#SVGID_00000077318814976532220420000004960225747018895773_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000110435439825664943010000011268462977921661070_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000129885645377801362980000012122034621022732952_",
    style: {
      clipPath: "url(#SVGID_00000067232011601640934000000017567927363665336481_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000007413552609969028490000001211903221462895507_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000057117762195712220370000003968618323839541158_",
    style: {
      clipPath: "url(#SVGID_00000129885645377801362980000012122034621022732952_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000118364854880742003200000001860242371901267102_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000017515318744942689620000005342026608589623175_",
    style: {
      clipPath: "url(#SVGID_00000057117762195712220370000003968618323839541158_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000141432722272039813610000006171326415738478763_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000146461796863717987500000001621170844434189469_",
    style: {
      clipPath: "url(#SVGID_00000017515318744942689620000005342026608589623175_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000088852436393265633270000012086998696450578316_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs337 || (_defs337 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000132056597208803490140000014739129885392835974_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs338 || (_defs338 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000077293337599343821210000013255643266146313393_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs339 || (_defs339 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000108297082017340673370000004789582876226928304_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs340 || (_defs340 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000170257278543593106390000004285176394495670439_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs341 || (_defs341 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000122707679775362668190000012273638272103419047_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs342 || (_defs342 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000117656913478027165450000013145712046658887603_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000134228582132435098030000013453677689042189220_",
    style: {
      clipPath: "url(#SVGID_00000077318814976532220420000004960225747018895773_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000132056597208803490140000014739129885392835974_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000175291374542543124460000018258644886747152313_",
    style: {
      clipPath: "url(#SVGID_00000134228582132435098030000013453677689042189220_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000077293337599343821210000013255643266146313393_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000087378750070492678450000015346252795361879714_",
    style: {
      clipPath: "url(#SVGID_00000175291374542543124460000018258644886747152313_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000108297082017340673370000004789582876226928304_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000181769302344898228680000012210139079143336629_",
    style: {
      clipPath: "url(#SVGID_00000087378750070492678450000015346252795361879714_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000170257278543593106390000004285176394495670439_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000065035340443500846770000002362856563232970930_",
    style: {
      clipPath: "url(#SVGID_00000181769302344898228680000012210139079143336629_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000122707679775362668190000012273638272103419047_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000142145557213386827900000010853317191071237816_",
    style: {
      clipPath: "url(#SVGID_00000065035340443500846770000002362856563232970930_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000117656913478027165450000013145712046658887603_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000115491246084824357070000015737577412042261165_",
    gradientUnits: "userSpaceOnUse",
    x1: -205.008,
    y1: 64.7349,
    x2: -267.0348,
    y2: 82.0888,
    gradientTransform: "matrix(1 0 0 -1 313.6061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000142145557213386827900000010853317191071237816_)",
      fill: "url(#SVGID_00000115491246084824357070000015737577412042261165_)"
    },
    points: " 87.9,167 102.2,179.2 97.8,130 95.8,128.9  "
  })))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150090941350627455290000014503081008581784498_",
    gradientUnits: "userSpaceOnUse",
    x1: -205.008,
    y1: 64.7349,
    x2: -267.0348,
    y2: 82.0888,
    gradientTransform: "matrix(1 0 0 -1 313.6061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000077318814976532220420000004960225747018895773_)",
      mask: "url(#SVGID_00000011024488671851050180000006095091450528520113_)",
      fill: "url(#SVGID_00000150090941350627455290000014503081008581784498_)"
    },
    points: " 87.9,167 102.2,179.2 97.8,130 95.8,128.9  "
  }))))), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "87.9,167 102.2,179.2 97.8,130 95.8,128.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs343 || (_defs343 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000076575539460696934770000014087492269596027032_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000065070762537331764160000005916754446658952349_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000076575539460696934770000014087492269596027032_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs344 || (_defs344 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000009570216237241970040000002398202787267058837_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs345 || (_defs345 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000181085042661011630310000008395549343631294625_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000033326678500115000420000003289389503679096474_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000009570216237241970040000002398202787267058837_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000030448169433146791700000001236604018548898719_",
    style: {
      clipPath: "url(#SVGID_00000033326678500115000420000003289389503679096474_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000181085042661011630310000008395549343631294625_",
    style: {
      overflow: "visible"
    }
  })), _defs346 || (_defs346 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000040533033601774872400000009762104916423504287_",
    filterUnits: "userSpaceOnUse",
    x: 29.6,
    y: 128.9,
    width: 14.3,
    height: 50.3
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 29.6,
    y: 128.9,
    width: 14.3,
    height: 50.3,
    id: "SVGID_00000062904498422152936080000001791277987459333050_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000040533033601774872400000009762104916423504287_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs347 || (_defs347 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000026163436576234985930000015847187752361992360_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs348 || (_defs348 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000098185319973399687400000011237484021017515945_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000147197711755807349500000002714479961501255863_",
    style: {
      clipPath: "url(#SVGID_00000030448169433146791700000001236604018548898719_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000026163436576234985930000015847187752361992360_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000152230696004845162100000011556681103994239117_",
    style: {
      clipPath: "url(#SVGID_00000147197711755807349500000002714479961501255863_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000098185319973399687400000011237484021017515945_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs349 || (_defs349 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000018923584792103606950000014821545793100944285_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs350 || (_defs350 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000101079884547523001010000003490913507174164643_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs351 || (_defs351 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000044178862803079099530000004882484720156397442_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000053524421302339406770000008404982076356283038_",
    style: {
      clipPath: "url(#SVGID_00000030448169433146791700000001236604018548898719_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000018923584792103606950000014821545793100944285_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000044870864869490360130000000709879761430499773_",
    style: {
      clipPath: "url(#SVGID_00000053524421302339406770000008404982076356283038_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000101079884547523001010000003490913507174164643_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000171702955053076065580000008875385453798598565_",
    style: {
      clipPath: "url(#SVGID_00000044870864869490360130000000709879761430499773_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000044178862803079099530000004882484720156397442_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs352 || (_defs352 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000129916352350304946410000001217563645899704720_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs353 || (_defs353 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000127745290510232792220000016232908782819147184_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000100357237984278927110000018277603423417350325_",
    style: {
      clipPath: "url(#SVGID_00000030448169433146791700000001236604018548898719_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000129916352350304946410000001217563645899704720_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000091735150281010466210000007952148894506763441_",
    style: {
      clipPath: "url(#SVGID_00000100357237984278927110000018277603423417350325_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000127745290510232792220000016232908782819147184_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs354 || (_defs354 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000140008511728331336770000012543811178073836929_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs355 || (_defs355 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000103260405463554363030000004323696794267274388_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs356 || (_defs356 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000087377364619128960180000010572259701542968203_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000170274903941190578850000014951012595149085611_",
    style: {
      clipPath: "url(#SVGID_00000030448169433146791700000001236604018548898719_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000140008511728331336770000012543811178073836929_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000110472770919103936660000013350118503562786477_",
    style: {
      clipPath: "url(#SVGID_00000170274903941190578850000014951012595149085611_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000103260405463554363030000004323696794267274388_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000116230929322267306280000006914968661079473310_",
    style: {
      clipPath: "url(#SVGID_00000110472770919103936660000013350118503562786477_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000087377364619128960180000010572259701542968203_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs357 || (_defs357 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000052067768539024802690000004396207105663436963_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs358 || (_defs358 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000051375460378739026950000007453460886397119663_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs359 || (_defs359 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000176022993985752791120000010808569840857772931_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs360 || (_defs360 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000077296237665031775700000012526768907337623446_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000029758411110338326300000017760942229464935555_",
    style: {
      clipPath: "url(#SVGID_00000030448169433146791700000001236604018548898719_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000052067768539024802690000004396207105663436963_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000062168845688807134580000017506336873402915479_",
    style: {
      clipPath: "url(#SVGID_00000029758411110338326300000017760942229464935555_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000051375460378739026950000007453460886397119663_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000115477883791898078760000007351621966205818760_",
    style: {
      clipPath: "url(#SVGID_00000062168845688807134580000017506336873402915479_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000176022993985752791120000010808569840857772931_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000174568991094952689230000016332697499790109091_",
    style: {
      clipPath: "url(#SVGID_00000115477883791898078760000007351621966205818760_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000077296237665031775700000012526768907337623446_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs361 || (_defs361 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000044891249681111719160000016838719202457822385_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs362 || (_defs362 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000047056022509536496950000005162621997710607008_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000137102914625794585370000011022682122602269592_",
    style: {
      clipPath: "url(#SVGID_00000030448169433146791700000001236604018548898719_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000044891249681111719160000016838719202457822385_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000168112260483276266050000000187492373216376726_",
    style: {
      clipPath: "url(#SVGID_00000137102914625794585370000011022682122602269592_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000047056022509536496950000005162621997710607008_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs363 || (_defs363 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000002368807162443395620000015484790503614306722_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs364 || (_defs364 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000031896383205345443280000007479155061751310998_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs365 || (_defs365 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000182486600885247491410000012191221184670017976_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000132789649929793442150000005529870587959378582_",
    style: {
      clipPath: "url(#SVGID_00000030448169433146791700000001236604018548898719_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000002368807162443395620000015484790503614306722_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000114056378932891366250000002755689565217521067_",
    style: {
      clipPath: "url(#SVGID_00000132789649929793442150000005529870587959378582_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000031896383205345443280000007479155061751310998_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000079447973134116943680000002279536033062599601_",
    style: {
      clipPath: "url(#SVGID_00000114056378932891366250000002755689565217521067_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000182486600885247491410000012191221184670017976_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs366 || (_defs366 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000082369159496752247940000005621709159411465346_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs367 || (_defs367 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000067915878629700050710000000240609549613233294_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs368 || (_defs368 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000178169112492680369220000009773395618153829554_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs369 || (_defs369 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000142175983903765033690000009582011024712567704_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000005229175395991469550000011733424042718322109_",
    style: {
      clipPath: "url(#SVGID_00000030448169433146791700000001236604018548898719_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000082369159496752247940000005621709159411465346_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000052782429145445254910000013598134350911347612_",
    style: {
      clipPath: "url(#SVGID_00000005229175395991469550000011733424042718322109_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000067915878629700050710000000240609549613233294_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000181064066069186222700000010734940516773640069_",
    style: {
      clipPath: "url(#SVGID_00000052782429145445254910000013598134350911347612_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000178169112492680369220000009773395618153829554_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000096751543422313527300000000346272378599881638_",
    style: {
      clipPath: "url(#SVGID_00000181064066069186222700000010734940516773640069_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000142175983903765033690000009582011024712567704_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs370 || (_defs370 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000043451361806699112460000000719564215931375792_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs371 || (_defs371 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000136382137670025021950000008856295589099513759_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs372 || (_defs372 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000155847453742399160530000015810147589676194444_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs373 || (_defs373 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000059298665376381875360000013050965308078285974_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs374 || (_defs374 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000146473198238160079920000006554239585646084009_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000120559785834364709870000008998188783405254022_",
    style: {
      clipPath: "url(#SVGID_00000030448169433146791700000001236604018548898719_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000043451361806699112460000000719564215931375792_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000101800997193247884180000016802540433120243630_",
    style: {
      clipPath: "url(#SVGID_00000120559785834364709870000008998188783405254022_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000136382137670025021950000008856295589099513759_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000147196437884566648670000000810697384349942441_",
    style: {
      clipPath: "url(#SVGID_00000101800997193247884180000016802540433120243630_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000155847453742399160530000015810147589676194444_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000164477363864693794630000011815714189637037499_",
    style: {
      clipPath: "url(#SVGID_00000147196437884566648670000000810697384349942441_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000059298665376381875360000013050965308078285974_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000039852691920889914600000004511192524711703425_",
    style: {
      clipPath: "url(#SVGID_00000164477363864693794630000011815714189637037499_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000146473198238160079920000006554239585646084009_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs375 || (_defs375 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000052824671706696142350000010310936926317605273_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs376 || (_defs376 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000127041757564815427520000012924837735528905385_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs377 || (_defs377 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000149383940737732513940000009363008603372475019_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs378 || (_defs378 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000146494814484042428130000008516281464687283076_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs379 || (_defs379 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000150786598171987423400000003526140440071925891_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs380 || (_defs380 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000063618333867423160840000002871466601880669332_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000168109250354831151390000004725341427397478558_",
    style: {
      clipPath: "url(#SVGID_00000030448169433146791700000001236604018548898719_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000052824671706696142350000010310936926317605273_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000026147913575410807530000013527570310182508695_",
    style: {
      clipPath: "url(#SVGID_00000168109250354831151390000004725341427397478558_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000127041757564815427520000012924837735528905385_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000167398157075861289480000016283065426007762827_",
    style: {
      clipPath: "url(#SVGID_00000026147913575410807530000013527570310182508695_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000149383940737732513940000009363008603372475019_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000068640071433733540750000007786434612845138331_",
    style: {
      clipPath: "url(#SVGID_00000167398157075861289480000016283065426007762827_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000146494814484042428130000008516281464687283076_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000072255628742892702960000013982349269613704320_",
    style: {
      clipPath: "url(#SVGID_00000068640071433733540750000007786434612845138331_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000150786598171987423400000003526140440071925891_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000181808614566031430630000002550481207837048716_",
    style: {
      clipPath: "url(#SVGID_00000072255628742892702960000013982349269613704320_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000063618333867423160840000002871466601880669332_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000113328718082376399090000014203725455254748063_",
    gradientUnits: "userSpaceOnUse",
    x1: -277.6336,
    y1: 58.9919,
    x2: -284.7889,
    y2: 163.4607,
    gradientTransform: "matrix(1 0 0 -1 313.6061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000181808614566031430630000002550481207837048716_)",
      fill: "url(#SVGID_00000113328718082376399090000014203725455254748063_)"
    },
    points: " 43.9,167 29.6,179.2 34,130 36.1,128.9  "
  })))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000139278418015655591480000006125196370850750342_",
    gradientUnits: "userSpaceOnUse",
    x1: -277.6336,
    y1: 58.9919,
    x2: -284.7889,
    y2: 163.4607,
    gradientTransform: "matrix(1 0 0 -1 313.6061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000030448169433146791700000001236604018548898719_)",
      mask: "url(#SVGID_00000062904498422152936080000001791277987459333050_)",
      fill: "url(#SVGID_00000139278418015655591480000006125196370850750342_)"
    },
    points: " 43.9,167 29.6,179.2 34,130 36.1,128.9  "
  }))))), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "43.9,167 29.6,179.2 34,130 36.1,128.9  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000001663521034337300930000017128343533153184958_",
    gradientUnits: "userSpaceOnUse",
    x1: -522.9093,
    y1: -886.5065,
    x2: -522.9093,
    y2: -878.7489,
    gradientTransform: "matrix(1 0 0 -1 588.6593 -709.3386)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1E110E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7931A"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000001663521034337300930000017128343533153184958_)"
    },
    points: "84.2,167.7 47.3,167.7  47.3,177.7 84.2,177.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs381 || (_defs381 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000170980346432982802030000001873637337656828808_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000140702457928548076390000010427149732416731776_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000170980346432982802030000001873637337656828808_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs382 || (_defs382 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000075870525185934059580000015189274350336710274_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs383 || (_defs383 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000103239238166050316360000016202916025850118296_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000014611822432385803590000003581626503149491089_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000075870525185934059580000015189274350336710274_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000075875147606694295120000011902330451895641996_",
    style: {
      clipPath: "url(#SVGID_00000014611822432385803590000003581626503149491089_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000103239238166050316360000016202916025850118296_",
    style: {
      overflow: "visible"
    }
  })), _defs384 || (_defs384 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000085961533320102587210000006454935205499169209_",
    filterUnits: "userSpaceOnUse",
    x: 47.3,
    y: 167.7,
    width: 37,
    height: 10
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 47.3,
    y: 167.7,
    width: 37,
    height: 10,
    id: "SVGID_00000129906697429501440260000012177575606192798911_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000085961533320102587210000006454935205499169209_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs385 || (_defs385 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000179620874367767605630000009502073606215940497_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs386 || (_defs386 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000128467267251720781580000018441041519209628861_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000125604695295101818410000010831260506910809782_",
    style: {
      clipPath: "url(#SVGID_00000075875147606694295120000011902330451895641996_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000179620874367767605630000009502073606215940497_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000161624433219402527830000006864602557774127745_",
    style: {
      clipPath: "url(#SVGID_00000125604695295101818410000010831260506910809782_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000128467267251720781580000018441041519209628861_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs387 || (_defs387 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000156560384717417349210000003890684192492822172_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs388 || (_defs388 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000005232444694635033040000005151006944049269917_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs389 || (_defs389 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000034091748699443181260000002610221426890326687_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000099642561416769314510000007878319593657893543_",
    style: {
      clipPath: "url(#SVGID_00000075875147606694295120000011902330451895641996_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000156560384717417349210000003890684192492822172_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000040567387858560243900000012422155064714974091_",
    style: {
      clipPath: "url(#SVGID_00000099642561416769314510000007878319593657893543_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000005232444694635033040000005151006944049269917_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000182530814100698216770000006206280080723372704_",
    style: {
      clipPath: "url(#SVGID_00000040567387858560243900000012422155064714974091_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000034091748699443181260000002610221426890326687_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs390 || (_defs390 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000176742480655381251510000016666226322410902913_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs391 || (_defs391 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000075872477864694922080000010242381495193086865_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000084492388080393817600000014339424623236244383_",
    style: {
      clipPath: "url(#SVGID_00000075875147606694295120000011902330451895641996_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000176742480655381251510000016666226322410902913_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000123441279893707401570000008413815595439953030_",
    style: {
      clipPath: "url(#SVGID_00000084492388080393817600000014339424623236244383_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000075872477864694922080000010242381495193086865_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs392 || (_defs392 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000114065954041433903270000003105900028653846930_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs393 || (_defs393 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000030487198101999070530000009051407827963789464_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs394 || (_defs394 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000160187896595039036400000014705951421686935454_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000114037694592892291070000012920332157660754330_",
    style: {
      clipPath: "url(#SVGID_00000075875147606694295120000011902330451895641996_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000114065954041433903270000003105900028653846930_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000096061353006280862910000014915592111253215660_",
    style: {
      clipPath: "url(#SVGID_00000114037694592892291070000012920332157660754330_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000030487198101999070530000009051407827963789464_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000148628444009033327010000003359615901184498826_",
    style: {
      clipPath: "url(#SVGID_00000096061353006280862910000014915592111253215660_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000160187896595039036400000014705951421686935454_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs395 || (_defs395 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000117645914174234685810000002946888540041029790_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs396 || (_defs396 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000086678039502061811460000007368359915184087705_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs397 || (_defs397 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000142875669007043396530000003529048449629387418_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs398 || (_defs398 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000067221394572530220880000010297541704267297413_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000152955295804022457160000016694309231778718605_",
    style: {
      clipPath: "url(#SVGID_00000075875147606694295120000011902330451895641996_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000117645914174234685810000002946888540041029790_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000005957685634485084120000002364862780096039098_",
    style: {
      clipPath: "url(#SVGID_00000152955295804022457160000016694309231778718605_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000086678039502061811460000007368359915184087705_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000132068721307255478320000017957163453546646661_",
    style: {
      clipPath: "url(#SVGID_00000005957685634485084120000002364862780096039098_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000142875669007043396530000003529048449629387418_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000168813233958054597950000013838361544503759259_",
    style: {
      clipPath: "url(#SVGID_00000132068721307255478320000017957163453546646661_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000067221394572530220880000010297541704267297413_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs399 || (_defs399 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000045616186170451996390000008398908785105514399_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs400 || (_defs400 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000170241070508186682350000015286893258546770847_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000000194036410137468460000007073114513878124448_",
    style: {
      clipPath: "url(#SVGID_00000075875147606694295120000011902330451895641996_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000045616186170451996390000008398908785105514399_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000077288853017091400710000009011571203677079963_",
    style: {
      clipPath: "url(#SVGID_00000000194036410137468460000007073114513878124448_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000170241070508186682350000015286893258546770847_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs401 || (_defs401 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000005969953410047346950000008088361989461141666_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs402 || (_defs402 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000142153945457929279830000002126456363225968004_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs403 || (_defs403 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000059285890125921302440000003153440102190486666_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000139262307528252468330000011879865046005081515_",
    style: {
      clipPath: "url(#SVGID_00000075875147606694295120000011902330451895641996_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000005969953410047346950000008088361989461141666_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000004535358687919484620000010594775535890123428_",
    style: {
      clipPath: "url(#SVGID_00000139262307528252468330000011879865046005081515_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000142153945457929279830000002126456363225968004_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000065779704857903301440000009831245708160953488_",
    style: {
      clipPath: "url(#SVGID_00000004535358687919484620000010594775535890123428_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000059285890125921302440000003153440102190486666_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs404 || (_defs404 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000002343612638476617240000003069533663455555202_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs405 || (_defs405 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000029729356208772358170000008999692374104546201_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs406 || (_defs406 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000072986188238482709930000014605337702809785266_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs407 || (_defs407 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000066474155707878269320000015001392964275977635_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000128476968486167942420000015889258270926846114_",
    style: {
      clipPath: "url(#SVGID_00000075875147606694295120000011902330451895641996_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000002343612638476617240000003069533663455555202_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000052826186499070142120000008877347595126314631_",
    style: {
      clipPath: "url(#SVGID_00000128476968486167942420000015889258270926846114_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000029729356208772358170000008999692374104546201_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000077282134609202100480000009417431720793064117_",
    style: {
      clipPath: "url(#SVGID_00000052826186499070142120000008877347595126314631_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000072986188238482709930000014605337702809785266_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000077296841337334556920000000978818287657172639_",
    style: {
      clipPath: "url(#SVGID_00000077282134609202100480000009417431720793064117_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000066474155707878269320000015001392964275977635_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs408 || (_defs408 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000039107423758113585020000004379663092162092720_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs409 || (_defs409 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000145038152056843421380000010516904188127808159_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs410 || (_defs410 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000059279975975325635110000001712948375206729622_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs411 || (_defs411 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000114053041745206952280000009813957711080083864_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs412 || (_defs412 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000040576377842228561490000009851751766506178227_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000083066025954072712490000011395116920204451506_",
    style: {
      clipPath: "url(#SVGID_00000075875147606694295120000011902330451895641996_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000039107423758113585020000004379663092162092720_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000127028773101757858670000009823007932518019982_",
    style: {
      clipPath: "url(#SVGID_00000083066025954072712490000011395116920204451506_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000145038152056843421380000010516904188127808159_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000104670567717434989560000002663935965246123656_",
    style: {
      clipPath: "url(#SVGID_00000127028773101757858670000009823007932518019982_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000059279975975325635110000001712948375206729622_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000103946353518783459530000001485009159612417687_",
    style: {
      clipPath: "url(#SVGID_00000104670567717434989560000002663935965246123656_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000114053041745206952280000009813957711080083864_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000123437795546859486740000007468072833237707415_",
    style: {
      clipPath: "url(#SVGID_00000103946353518783459530000001485009159612417687_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000040576377842228561490000009851751766506178227_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs413 || (_defs413 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000152261395919243996100000005234055116484986280_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs414 || (_defs414 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000037694106087645462720000013798776804889779598_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs415 || (_defs415 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000008117079898165587820000017061112861191824024_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs416 || (_defs416 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000027604873009871172660000018045791953908686495_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs417 || (_defs417 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000007395024489897514180000017704369119977508751_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs418 || (_defs418 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000106847028723861008770000014381994112951220146_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000118378278763211665440000009399195647601960602_",
    style: {
      clipPath: "url(#SVGID_00000075875147606694295120000011902330451895641996_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000152261395919243996100000005234055116484986280_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000102538838979785158670000003989717257915508662_",
    style: {
      clipPath: "url(#SVGID_00000118378278763211665440000009399195647601960602_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000037694106087645462720000013798776804889779598_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000001665478948876127130000014766000551668587934_",
    style: {
      clipPath: "url(#SVGID_00000102538838979785158670000003989717257915508662_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000008117079898165587820000017061112861191824024_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000040543417284618713240000004902321001510150582_",
    style: {
      clipPath: "url(#SVGID_00000001665478948876127130000014766000551668587934_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000027604873009871172660000018045791953908686495_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000003789304121723095790000013008354782308428185_",
    style: {
      clipPath: "url(#SVGID_00000040543417284618713240000004902321001510150582_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000007395024489897514180000017704369119977508751_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000067920511166974934690000003644205659599736455_",
    style: {
      clipPath: "url(#SVGID_00000003789304121723095790000013008354782308428185_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000106847028723861008770000014381994112951220146_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070090107587124576910000012281404354740024450_",
    gradientUnits: "userSpaceOnUse",
    x1: -247.3017,
    y1: 41.2085,
    x2: -250.9965,
    y2: 114.2636,
    gradientTransform: "matrix(1 0 0 -1 313.6061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000067920511166974934690000003644205659599736455_)",
      fill: "url(#SVGID_00000070090107587124576910000012281404354740024450_)"
    },
    points: " 47.3,170.9 81.5,170.9 81.5,177.7 84.2,177.7 84.2,167.7 47.3,167.7  "
  })))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000162341391085469132040000015878007730320140457_",
    gradientUnits: "userSpaceOnUse",
    x1: -247.3017,
    y1: 41.2085,
    x2: -250.9965,
    y2: 114.2636,
    gradientTransform: "matrix(1 0 0 -1 313.6061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000075875147606694295120000011902330451895641996_)",
      mask: "url(#SVGID_00000129906697429501440260000012177575606192798911_)",
      fill: "url(#SVGID_00000162341391085469132040000015878007730320140457_)"
    },
    points: " 47.3,170.9 81.5,170.9 81.5,177.7 84.2,177.7 84.2,167.7 47.3,167.7  "
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181774479683199000560000007138379557215420049_",
    gradientUnits: "userSpaceOnUse",
    x1: -247.3017,
    y1: 41.2085,
    x2: -250.9965,
    y2: 114.2636,
    gradientTransform: "matrix(1 0 0 -1 313.6061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#06090F"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000181774479683199000560000007138379557215420049_)"
    },
    points: "47.3,170.9 81.5,170.9  81.5,177.7 84.2,177.7 84.2,167.7 47.3,167.7  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065053115044921268820000017468488778091838624_",
    gradientUnits: "userSpaceOnUse",
    x1: -538.6093,
    y1: -887.9886,
    x2: -507.0726,
    y2: -887.9886,
    gradientTransform: "matrix(1 0 0 -1 588.6593 -709.3386)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1E110E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7931A"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000065053115044921268820000017468488778091838624_)"
    },
    points: "81.5,177.7 50.1,177.7  50.1,179.6 81.5,179.6  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057869359792798083090000003524204076218051994_",
    gradientUnits: "userSpaceOnUse",
    x1: -522.8593,
    y1: -870.6083,
    x2: -522.8593,
    y2: -788.4031,
    gradientTransform: "matrix(1 0 0 -1 588.6593 -709.3386)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1E110E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7931A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057869359792798083090000003524204076218051994_)"
    },
    d: "M97.8,91.7c0,8.6-0.3,16.5-0.8,23.7 c-2.4,33.4-9.3,52.3-9.3,52.3H65.8l0,0h-22c0,0-6.9-18.9-9.3-52.3c-0.5-7.3-0.8-15.2-0.8-23.7c0-9.7,1.3-18.9,3.4-27.5 C45.5,30.1,65.8,6,65.8,6l0,0l0,0c0.4,0.5,20.5,24.4,28.7,58.2C96.5,72.8,97.8,82.1,97.8,91.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000090278268224644145720000008858791049981806214_",
    gradientUnits: "userSpaceOnUse",
    x1: -213.6513,
    y1: 187.4117,
    x2: -305.9558,
    y2: 178.1095,
    gradientTransform: "matrix(1 0 0 -1 313.6061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1E110E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7931A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000090278268224644145720000008858791049981806214_)"
    },
    d: "M65.8,6c0,0-20.4,24.1-28.8,58.2 c9.1,2.8,18.7,4.3,28.7,4.3s19.6-1.5,28.7-4.3C86.2,30.1,65.8,6,65.8,6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs419 || (_defs419 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000021800789808309049000000011767335006984763063_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000139982882652466970650000002161901151978491520_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000021800789808309049000000011767335006984763063_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs420 || (_defs420 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000035493338085862814320000013944526646769125563_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs421 || (_defs421 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000174584333616158228590000003158618063502649490_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000105393650973387614340000003427821046324282274_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000035493338085862814320000013944526646769125563_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000008108070973813401380000003168513893652838570_",
    style: {
      clipPath: "url(#SVGID_00000105393650973387614340000003427821046324282274_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000174584333616158228590000003158618063502649490_",
    style: {
      overflow: "visible"
    }
  })), _defs422 || (_defs422 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000123439401421184139580000013652063851908593590_",
    filterUnits: "userSpaceOnUse",
    x: 65.8,
    y: 6,
    width: 32,
    height: 161.7
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 65.8,
    y: 6,
    width: 32,
    height: 161.7,
    id: "SVGID_00000065761686033015311660000016149903317097060276_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000123439401421184139580000013652063851908593590_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs423 || (_defs423 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000094604554840743593530000001779033230712508339_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs424 || (_defs424 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000145751116904180523570000003279044523967454113_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000077315738250294729330000012999775232988490428_",
    style: {
      clipPath: "url(#SVGID_00000008108070973813401380000003168513893652838570_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000094604554840743593530000001779033230712508339_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000168106993221572200370000004543703293579911344_",
    style: {
      clipPath: "url(#SVGID_00000077315738250294729330000012999775232988490428_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000145751116904180523570000003279044523967454113_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs425 || (_defs425 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000033340641645302928600000007294346247148433037_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs426 || (_defs426 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000044163037696466178440000004368403098643517354_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs427 || (_defs427 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000117668243526119160000000015695587146240056204_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000090278343905184944300000015647933322828130697_",
    style: {
      clipPath: "url(#SVGID_00000008108070973813401380000003168513893652838570_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000033340641645302928600000007294346247148433037_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000103225862001986598560000010481112880941731995_",
    style: {
      clipPath: "url(#SVGID_00000090278343905184944300000015647933322828130697_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000044163037696466178440000004368403098643517354_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000173869472012459905490000007803048259195896242_",
    style: {
      clipPath: "url(#SVGID_00000103225862001986598560000010481112880941731995_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000117668243526119160000000015695587146240056204_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs428 || (_defs428 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000065057883128456549550000006178459317921421204_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs429 || (_defs429 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000148619864474876950640000013482268723907051684_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000013907647179759597470000010380072825801437369_",
    style: {
      clipPath: "url(#SVGID_00000008108070973813401380000003168513893652838570_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000065057883128456549550000006178459317921421204_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000106105879964331067170000017748937800928463288_",
    style: {
      clipPath: "url(#SVGID_00000013907647179759597470000010380072825801437369_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000148619864474876950640000013482268723907051684_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs430 || (_defs430 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000177461274228363014570000001492138585925185439_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs431 || (_defs431 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000118363007242435464910000012971696046861779087_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs432 || (_defs432 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000112615939138957794710000017173454922718207363_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000098918813292876336380000006430387081730897808_",
    style: {
      clipPath: "url(#SVGID_00000008108070973813401380000003168513893652838570_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000177461274228363014570000001492138585925185439_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000126322651610133128750000014417986963413017009_",
    style: {
      clipPath: "url(#SVGID_00000098918813292876336380000006430387081730897808_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000118363007242435464910000012971696046861779087_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000026127661626046216980000004118190953882380975_",
    style: {
      clipPath: "url(#SVGID_00000126322651610133128750000014417986963413017009_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000112615939138957794710000017173454922718207363_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs433 || (_defs433 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000110431613191349925300000016699426980764761514_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs434 || (_defs434 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000064343026688347756440000007963996581399688104_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs435 || (_defs435 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000140732612439132482180000011124032186444887457_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs436 || (_defs436 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000139251340584562678810000001702064513713336977_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000170956768187142787560000014003209348661736858_",
    style: {
      clipPath: "url(#SVGID_00000008108070973813401380000003168513893652838570_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000110431613191349925300000016699426980764761514_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000029740088296299499240000014084996986037261462_",
    style: {
      clipPath: "url(#SVGID_00000170956768187142787560000014003209348661736858_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000064343026688347756440000007963996581399688104_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000149344297334452312100000013459634584421073564_",
    style: {
      clipPath: "url(#SVGID_00000029740088296299499240000014084996986037261462_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000140732612439132482180000011124032186444887457_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000025414785209917455600000017582927132790299569_",
    style: {
      clipPath: "url(#SVGID_00000149344297334452312100000013459634584421073564_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000139251340584562678810000001702064513713336977_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs437 || (_defs437 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000150066158664309988530000014005780288735824804_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs438 || (_defs438 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000033350111050788236560000012648105227614507685_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000029030011206834258260000014088432089395540913_",
    style: {
      clipPath: "url(#SVGID_00000008108070973813401380000003168513893652838570_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000150066158664309988530000014005780288735824804_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000141431317258427688510000001383176949826189229_",
    style: {
      clipPath: "url(#SVGID_00000029030011206834258260000014088432089395540913_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000033350111050788236560000012648105227614507685_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs439 || (_defs439 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000087396787881837873960000009129233578831804863_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs440 || (_defs440 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000008846903906112509780000002406962227144229298_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs441 || (_defs441 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000145058354780686872940000002290130535653857672_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000092423010992990127280000011230196827384590240_",
    style: {
      clipPath: "url(#SVGID_00000008108070973813401380000003168513893652838570_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000087396787881837873960000009129233578831804863_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000016761039324802713400000001519178867761286825_",
    style: {
      clipPath: "url(#SVGID_00000092423010992990127280000011230196827384590240_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000008846903906112509780000002406962227144229298_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000142177916936141162670000007880271069339069353_",
    style: {
      clipPath: "url(#SVGID_00000016761039324802713400000001519178867761286825_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000145058354780686872940000002290130535653857672_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs442 || (_defs442 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000167358521057093601070000003741243360223721125_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs443 || (_defs443 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000183232250569782934840000015665329072964277892_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs444 || (_defs444 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000106106775382371701560000005027837554724610963_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs445 || (_defs445 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000176030962785677519060000016251617195847093411_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000098908424679332741630000006355204654737722814_",
    style: {
      clipPath: "url(#SVGID_00000008108070973813401380000003168513893652838570_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000167358521057093601070000003741243360223721125_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000169541166625848675210000003205445894785905541_",
    style: {
      clipPath: "url(#SVGID_00000098908424679332741630000006355204654737722814_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000183232250569782934840000015665329072964277892_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000041975915728470234280000007485887738441457030_",
    style: {
      clipPath: "url(#SVGID_00000169541166625848675210000003205445894785905541_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000106106775382371701560000005027837554724610963_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000096742926594590451380000012827974605449633966_",
    style: {
      clipPath: "url(#SVGID_00000041975915728470234280000007485887738441457030_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000176030962785677519060000016251617195847093411_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs446 || (_defs446 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000033337162061970127110000014135400624609536698_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs447 || (_defs447 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000147931204104977138060000018050337595058384012_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs448 || (_defs448 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000166647759824834877870000005881847043769123205_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs449 || (_defs449 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000165234126161547166830000012689270862126726067_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs450 || (_defs450 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000062892208570176547370000016299053088735640223_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000083790322640548576220000008439370615636404646_",
    style: {
      clipPath: "url(#SVGID_00000008108070973813401380000003168513893652838570_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000033337162061970127110000014135400624609536698_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000064348352107842412770000010335026906647288193_",
    style: {
      clipPath: "url(#SVGID_00000083790322640548576220000008439370615636404646_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000147931204104977138060000018050337595058384012_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000159471428246911796040000000290916626706072766_",
    style: {
      clipPath: "url(#SVGID_00000064348352107842412770000010335026906647288193_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000166647759824834877870000005881847043769123205_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000031911270774993583540000017897575285853102994_",
    style: {
      clipPath: "url(#SVGID_00000159471428246911796040000000290916626706072766_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000165234126161547166830000012689270862126726067_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000097484436484006966440000011499532456479273150_",
    style: {
      clipPath: "url(#SVGID_00000031911270774993583540000017897575285853102994_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000062892208570176547370000016299053088735640223_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs451 || (_defs451 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000099656594579422775010000007730017640940498573_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs452 || (_defs452 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000039845961473590556910000015236542705317952400_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs453 || (_defs453 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000001664364083724863020000002072896681418130850_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs454 || (_defs454 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000060026565255552467060000008522642802623375261_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs455 || (_defs455 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000018956984768895318220000018359243474440660916_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs456 || (_defs456 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000130604841986646461560000015180281876901720237_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000022522950241142681300000003959122954132325526_",
    style: {
      clipPath: "url(#SVGID_00000008108070973813401380000003168513893652838570_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000099656594579422775010000007730017640940498573_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000141452496183582894180000001848412535706359980_",
    style: {
      clipPath: "url(#SVGID_00000022522950241142681300000003959122954132325526_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000039845961473590556910000015236542705317952400_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000045616253017947635600000014299827125677892751_",
    style: {
      clipPath: "url(#SVGID_00000141452496183582894180000001848412535706359980_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000001664364083724863020000002072896681418130850_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000080178543342143731830000008977866221332418492_",
    style: {
      clipPath: "url(#SVGID_00000045616253017947635600000014299827125677892751_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000060026565255552467060000008522642802623375261_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000155855280294038608370000013698891149577126301_",
    style: {
      clipPath: "url(#SVGID_00000080178543342143731830000008977866221332418492_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000018956984768895318220000018359243474440660916_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000181056961630003085340000017578926746596596405_",
    style: {
      clipPath: "url(#SVGID_00000155855280294038608370000013698891149577126301_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000130604841986646461560000015180281876901720237_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000059286309957469237530000002609229156819104686_",
    gradientUnits: "userSpaceOnUse",
    x1: -265.0887,
    y1: 154.3969,
    x2: 19.069,
    y2: -81.8977,
    gradientTransform: "matrix(1 0 0 -1 313.6061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000181056961630003085340000017578926746596596405_)",
      fill: "url(#SVGID_00000059286309957469237530000002609229156819104686_)"
    },
    d: " M94.5,64.2C86.3,30.4,66.2,6.5,65.8,6c0.4,0.9,36.8,76.5,12.9,161.7h9c0,0,6.9-18.9,9.3-52.3 c0.5-7.3,0.8-15.2,0.8-23.7C97.8,82.1,96.5,72.8,94.5,64.2z"
  })))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067207714726532696160000003403569812684239258_",
    gradientUnits: "userSpaceOnUse",
    x1: -265.0887,
    y1: 154.3969,
    x2: 19.069,
    y2: -81.8977,
    gradientTransform: "matrix(1 0 0 -1 313.6061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000008108070973813401380000003168513893652838570_)",
      mask: "url(#SVGID_00000065761686033015311660000016149903317097060276_)",
      fill: "url(#SVGID_00000067207714726532696160000003403569812684239258_)"
    },
    d: " M94.5,64.2C86.3,30.4,66.2,6.5,65.8,6c0.4,0.9,36.8,76.5,12.9,161.7h9c0,0,6.9-18.9,9.3-52.3c0.5-7.3,0.8-15.2,0.8-23.7 C97.8,82.1,96.5,72.8,94.5,64.2z"
  }))))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M94.5,64.2C86.3,30.4,66.2,6.5,65.8,6c0.4,0.9,36.8,76.5,12.9,161.7h9c0,0,6.9-18.9,9.3-52.3 c0.5-7.3,0.8-15.2,0.8-23.7C97.8,82.1,96.5,72.8,94.5,64.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs457 || (_defs457 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000148622126001459865540000009798609746117876398_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000003794794469037990110000017213666118473925780_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000148622126001459865540000009798609746117876398_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs458 || (_defs458 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000091703546236095923280000000189433612616945846_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs459 || (_defs459 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000109728664053413173360000016329833782023048845_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000042013620935282598490000002233697810328792221_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000091703546236095923280000000189433612616945846_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000006670473337753701990000004936432234802701757_",
    style: {
      clipPath: "url(#SVGID_00000042013620935282598490000002233697810328792221_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000109728664053413173360000016329833782023048845_",
    style: {
      overflow: "visible"
    }
  })), _defs460 || (_defs460 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000093173826879420492740000000703386965951209603_",
    filterUnits: "userSpaceOnUse",
    x: 34.1,
    y: 6,
    width: 32,
    height: 161.7
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 34.1,
    y: 6,
    width: 32,
    height: 161.7,
    id: "SVGID_00000157303756271952430730000002227046807094341819_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000093173826879420492740000000703386965951209603_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs461 || (_defs461 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000064343560760378237440000007155607165406243218_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs462 || (_defs462 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000148621149954981851660000015876223555572793534_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000075880711510858974380000011630380577331750320_",
    style: {
      clipPath: "url(#SVGID_00000006670473337753701990000004936432234802701757_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000064343560760378237440000007155607165406243218_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000037681693003470553100000011922721908761947527_",
    style: {
      clipPath: "url(#SVGID_00000075880711510858974380000011630380577331750320_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000148621149954981851660000015876223555572793534_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs463 || (_defs463 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000166654349287512325130000014405448081413768353_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs464 || (_defs464 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000054237087271759175950000011423503805110843309_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs465 || (_defs465 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000065767796433252405700000003485014749134790834_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000061442820039245658700000015864412791052501904_",
    style: {
      clipPath: "url(#SVGID_00000006670473337753701990000004936432234802701757_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000166654349287512325130000014405448081413768353_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000176740630719853801580000001427100532738282890_",
    style: {
      clipPath: "url(#SVGID_00000061442820039245658700000015864412791052501904_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000054237087271759175950000011423503805110843309_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000044879627429186711660000003123831541400826544_",
    style: {
      clipPath: "url(#SVGID_00000176740630719853801580000001427100532738282890_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000065767796433252405700000003485014749134790834_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs466 || (_defs466 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000109014893431194529060000000821391600033657784_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs467 || (_defs467 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000080187814898696534600000012884845977627127717_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000106126828261693577910000000280442249093063583_",
    style: {
      clipPath: "url(#SVGID_00000006670473337753701990000004936432234802701757_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000109014893431194529060000000821391600033657784_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000013911555347805996510000013014767664980603799_",
    style: {
      clipPath: "url(#SVGID_00000106126828261693577910000000280442249093063583_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000080187814898696534600000012884845977627127717_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs468 || (_defs468 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000127027059283841021040000009308738119649236380_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs469 || (_defs469 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000150080007583710736150000006882545137614819253_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs470 || (_defs470 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000008840855493636163530000003853568438441681537_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000052101385202971810520000017349763327421099430_",
    style: {
      clipPath: "url(#SVGID_00000006670473337753701990000004936432234802701757_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000127027059283841021040000009308738119649236380_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000075123813391114776430000006024927107524256669_",
    style: {
      clipPath: "url(#SVGID_00000052101385202971810520000017349763327421099430_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000150080007583710736150000006882545137614819253_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000071522866444202647120000006086568767673538198_",
    style: {
      clipPath: "url(#SVGID_00000075123813391114776430000006024927107524256669_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000008840855493636163530000003853568438441681537_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs471 || (_defs471 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000158748960218501282200000005998343029706219704_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs472 || (_defs472 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000142164039330291863820000005255660801463420069_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs473 || (_defs473 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000014621782369925746700000018401793393524392329_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs474 || (_defs474 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000042014112410748943460000015171228470051079614_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000116237506841539920470000010543058493014016689_",
    style: {
      clipPath: "url(#SVGID_00000006670473337753701990000004936432234802701757_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000158748960218501282200000005998343029706219704_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000142866641074889300400000015460402650666489268_",
    style: {
      clipPath: "url(#SVGID_00000116237506841539920470000010543058493014016689_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000142164039330291863820000005255660801463420069_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000026148212433386135970000011049419514635376551_",
    style: {
      clipPath: "url(#SVGID_00000142866641074889300400000015460402650666489268_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000014621782369925746700000018401793393524392329_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000000217053003551415540000009908221357857188224_",
    style: {
      clipPath: "url(#SVGID_00000026148212433386135970000011049419514635376551_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000042014112410748943460000015171228470051079614_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs475 || (_defs475 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000080909358227367303760000011472601394603714440_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs476 || (_defs476 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000014606091484973415030000010433343859983235252_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000034075960861144609220000004125089355436819355_",
    style: {
      clipPath: "url(#SVGID_00000006670473337753701990000004936432234802701757_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000080909358227367303760000011472601394603714440_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000003825207761621495000000010808715853638770067_",
    style: {
      clipPath: "url(#SVGID_00000034075960861144609220000004125089355436819355_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000014606091484973415030000010433343859983235252_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs477 || (_defs477 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000088837957738069906690000011335643305152863875_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs478 || (_defs478 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000020386845855682164120000011628682059509058454_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs479 || (_defs479 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000077325720195981925480000007386872041271769222_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000106853976589064259340000008293541436319055551_",
    style: {
      clipPath: "url(#SVGID_00000006670473337753701990000004936432234802701757_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000088837957738069906690000011335643305152863875_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000012452751889245994450000012632794489732098956_",
    style: {
      clipPath: "url(#SVGID_00000106853976589064259340000008293541436319055551_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000020386845855682164120000011628682059509058454_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000032642167875657077340000012136582681457955246_",
    style: {
      clipPath: "url(#SVGID_00000012452751889245994450000012632794489732098956_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000077325720195981925480000007386872041271769222_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs480 || (_defs480 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000114784722894584718540000007807709759735749547_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs481 || (_defs481 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000099646060369690765020000012607336520537564330_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs482 || (_defs482 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000011724419976363952470000016496498888337725057_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs483 || (_defs483 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000011731448126468218250000018308782967038542740_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000042713874515068223210000003819112742240282552_",
    style: {
      clipPath: "url(#SVGID_00000006670473337753701990000004936432234802701757_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000114784722894584718540000007807709759735749547_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000103982340946546486530000015009381713074829209_",
    style: {
      clipPath: "url(#SVGID_00000042713874515068223210000003819112742240282552_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000099646060369690765020000012607336520537564330_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000022558161234927396530000014138206528285680035_",
    style: {
      clipPath: "url(#SVGID_00000103982340946546486530000015009381713074829209_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000011724419976363952470000016496498888337725057_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000115500886059413318840000003016965156893163437_",
    style: {
      clipPath: "url(#SVGID_00000022558161234927396530000014138206528285680035_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000011731448126468218250000018308782967038542740_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs484 || (_defs484 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000046302354493548441690000002068205512268229558_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs485 || (_defs485 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000105389501541692449370000008642074033622318503_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs486 || (_defs486 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000090253415031743992360000000722881597657525397_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs487 || (_defs487 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000101784616716484456750000009509416566735952056_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs488 || (_defs488 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000103267262036717869640000007366131214033867191_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000021837529160965921210000011964786068991787961_",
    style: {
      clipPath: "url(#SVGID_00000006670473337753701990000004936432234802701757_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000046302354493548441690000002068205512268229558_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000157285042487606419830000010344249390601525143_",
    style: {
      clipPath: "url(#SVGID_00000021837529160965921210000011964786068991787961_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000105389501541692449370000008642074033622318503_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000072980673799689148090000011916639039063130557_",
    style: {
      clipPath: "url(#SVGID_00000157285042487606419830000010344249390601525143_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000090253415031743992360000000722881597657525397_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000088093644965412292950000012247730003508171965_",
    style: {
      clipPath: "url(#SVGID_00000072980673799689148090000011916639039063130557_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000101784616716484456750000009509416566735952056_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000003074130391675167250000015075205488703436735_",
    style: {
      clipPath: "url(#SVGID_00000088093644965412292950000012247730003508171965_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000103267262036717869640000007366131214033867191_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs489 || (_defs489 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000090990613641650972500000015108843643149618620_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs490 || (_defs490 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000176746233373437665090000003302641688759384982_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs491 || (_defs491 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000155141316443179041840000015110128816308295044_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs492 || (_defs492 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000137095465785312453600000007815343696638111872_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs493 || (_defs493 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000085217502869170824430000004514174315478525346_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs494 || (_defs494 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000060749434956079000450000002029468083401735068_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000161631625838343744730000014187172520555468956_",
    style: {
      clipPath: "url(#SVGID_00000006670473337753701990000004936432234802701757_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000090990613641650972500000015108843643149618620_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000148645834750742166140000012197237913962958763_",
    style: {
      clipPath: "url(#SVGID_00000161631625838343744730000014187172520555468956_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000176746233373437665090000003302641688759384982_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000077306597981027319480000005257029994852747704_",
    style: {
      clipPath: "url(#SVGID_00000148645834750742166140000012197237913962958763_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000155141316443179041840000015110128816308295044_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000134943176255376236980000008770216806523351475_",
    style: {
      clipPath: "url(#SVGID_00000077306597981027319480000005257029994852747704_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000137095465785312453600000007815343696638111872_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000162323863426925163560000008146328329089427075_",
    style: {
      clipPath: "url(#SVGID_00000134943176255376236980000008770216806523351475_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000085217502869170824430000004514174315478525346_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000014630713129688586560000007363147462768660627_",
    style: {
      clipPath: "url(#SVGID_00000162323863426925163560000008146328329089427075_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000060749434956079000450000002029468083401735068_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054969726069040278730000001914013336300771483_",
    gradientUnits: "userSpaceOnUse",
    x1: -245.8625,
    y1: 108.3173,
    x2: -326.6987,
    y2: 276.4841,
    gradientTransform: "matrix(1 0 0 -1 313.6061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000014630713129688586560000007363147462768660627_)",
      fill: "url(#SVGID_00000054969726069040278730000001914013336300771483_)"
    },
    d: " M37.4,64.2C45.6,30.4,65.7,6.5,66.1,6c-0.5,0.9-36.8,76.5-12.9,161.7h-9c0,0-6.9-18.9-9.3-52.3 c-0.5-7.3-0.8-15.2-0.8-23.7C34.1,82.1,35.4,72.8,37.4,64.2z"
  })))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000139984170724958833240000018134955905052760995_",
    gradientUnits: "userSpaceOnUse",
    x1: -245.8625,
    y1: 108.3173,
    x2: -326.6987,
    y2: 276.4841,
    gradientTransform: "matrix(1 0 0 -1 313.6061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000006670473337753701990000004936432234802701757_)",
      mask: "url(#SVGID_00000157303756271952430730000002227046807094341819_)",
      fill: "url(#SVGID_00000139984170724958833240000018134955905052760995_)"
    },
    d: " M37.4,64.2C45.6,30.4,65.7,6.5,66.1,6c-0.5,0.9-36.8,76.5-12.9,161.7h-9c0,0-6.9-18.9-9.3-52.3 c-0.5-7.3-0.8-15.2-0.8-23.7C34.1,82.1,35.4,72.8,37.4,64.2z"
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129182473002723495770000016519825769388743051_",
    gradientUnits: "userSpaceOnUse",
    x1: -246.1583,
    y1: 108.3086,
    x2: -326.9946,
    y2: 276.4754,
    gradientTransform: "matrix(1 0 0 -1 313.6061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.48,
      fill: "url(#SVGID_00000129182473002723495770000016519825769388743051_)",
      enableBackground: "new"
    },
    d: " M37.1,64.2C45.3,30.4,65.3,6.5,65.8,6C65.2,6.9,29,82.5,52.9,167.7h-9c0,0-6.9-18.9-9.3-52.3c-0.5-7.3-0.8-15.2-0.8-23.7 C33.8,82.1,35.1,72.8,37.1,64.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000019670951915237432870000002045200007869226122_",
    gradientUnits: "userSpaceOnUse",
    x1: -523.9093,
    y1: -859.7859,
    x2: -523.9093,
    y2: -888.4233,
    gradientTransform: "matrix(1 0 0 -1 588.6593 -709.3386)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1E110E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7931A"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000019670951915237432870000002045200007869226122_)"
    },
    points: "63.7,174.2 65.8,194.6  65.8,125.3  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000171711461231120553750000001285415522447214490_",
    gradientUnits: "userSpaceOnUse",
    x1: -521.7093,
    y1: -889.667,
    x2: -521.7093,
    y2: -867.6392,
    gradientTransform: "matrix(1 0 0 -1 588.6593 -709.3386)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1E110E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7931A"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000171711461231120553750000001285415522447214490_)"
    },
    points: "68,174.2 65.8,194.6  65.8,125.3  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs495 || (_defs495 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000176026239189102610640000000319085864971976083_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000119818016911670574680000009923705471105175432_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000176026239189102610640000000319085864971976083_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs496 || (_defs496 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000093866978456832013340000016613026597143501186_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs497 || (_defs497 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000080923698244246303630000016288150795510234525_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000104679227602257033470000013820939372310821779_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000093866978456832013340000016613026597143501186_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000061437734190857183210000010794870715271831687_",
    style: {
      clipPath: "url(#SVGID_00000104679227602257033470000013820939372310821779_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000080923698244246303630000016288150795510234525_",
    style: {
      overflow: "visible"
    }
  })), _defs498 || (_defs498 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000021100399195304435040000005912993886435159730_",
    filterUnits: "userSpaceOnUse",
    x: 52.7,
    y: 77.4,
    width: 28,
    height: 28
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 52.7,
    y: 77.4,
    width: 28,
    height: 28,
    id: "SVGID_00000084504480041518429150000012038922080463095702_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000021100399195304435040000005912993886435159730_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs499 || (_defs499 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000087402219824708642980000009593335677912343463_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs500 || (_defs500 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000169558375611381266330000010138697718389618316_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000093866706912996414140000010990849196033680012_",
    style: {
      clipPath: "url(#SVGID_00000061437734190857183210000010794870715271831687_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000087402219824708642980000009593335677912343463_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000026885609684121856740000004936690620577565825_",
    style: {
      clipPath: "url(#SVGID_00000093866706912996414140000010990849196033680012_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000169558375611381266330000010138697718389618316_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs501 || (_defs501 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000067195293471000570570000012856766870714487466_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs502 || (_defs502 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000152948787064318990650000003938089726367379128_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs503 || (_defs503 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000087410987817542924330000013341308357052828554_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000037677634051412417450000007866574461841902725_",
    style: {
      clipPath: "url(#SVGID_00000061437734190857183210000010794870715271831687_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000067195293471000570570000012856766870714487466_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000032619039771107860460000008581200343080107393_",
    style: {
      clipPath: "url(#SVGID_00000037677634051412417450000007866574461841902725_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000152948787064318990650000003938089726367379128_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000114048866141248208330000008229206809322566036_",
    style: {
      clipPath: "url(#SVGID_00000032619039771107860460000008581200343080107393_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000087410987817542924330000013341308357052828554_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs504 || (_defs504 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000062160285355809698740000012203262243243237559_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs505 || (_defs505 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000121260024412623025440000001282559969801647262_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000039831088248474587170000012314191611971088559_",
    style: {
      clipPath: "url(#SVGID_00000061437734190857183210000010794870715271831687_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000062160285355809698740000012203262243243237559_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000088126506111194426230000002016841786183962032_",
    style: {
      clipPath: "url(#SVGID_00000039831088248474587170000012314191611971088559_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000121260024412623025440000001282559969801647262_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs506 || (_defs506 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000117668447305841179740000000881165774091804833_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs507 || (_defs507 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000150077947119763148460000001867874415115487889_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs508 || (_defs508 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000057853028391267770540000015021774657712513975_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000142172296219526960480000002708824309026899119_",
    style: {
      clipPath: "url(#SVGID_00000061437734190857183210000010794870715271831687_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000117668447305841179740000000881165774091804833_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000077297438190585908270000014714774253013663110_",
    style: {
      clipPath: "url(#SVGID_00000142172296219526960480000002708824309026899119_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000150077947119763148460000001867874415115487889_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000119119048693652521650000013873301348153418900_",
    style: {
      clipPath: "url(#SVGID_00000077297438190585908270000014714774253013663110_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000057853028391267770540000015021774657712513975_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs509 || (_defs509 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000035531930385639851130000014668800205485114525_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs510 || (_defs510 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000101810384098714498690000000991659876379026604_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs511 || (_defs511 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000014620995202059887820000015951950671500966793_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs512 || (_defs512 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000127031973614343659730000014944431333741056418_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000075148961212781873510000001632550645530349968_",
    style: {
      clipPath: "url(#SVGID_00000061437734190857183210000010794870715271831687_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000035531930385639851130000014668800205485114525_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000054946980063768088830000004521243613487157891_",
    style: {
      clipPath: "url(#SVGID_00000075148961212781873510000001632550645530349968_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000101810384098714498690000000991659876379026604_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000023252342462831710560000013131245807907309444_",
    style: {
      clipPath: "url(#SVGID_00000054946980063768088830000004521243613487157891_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000014620995202059887820000015951950671500966793_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000134235689006501675880000009778620277890119351_",
    style: {
      clipPath: "url(#SVGID_00000023252342462831710560000013131245807907309444_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000127031973614343659730000014944431333741056418_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs513 || (_defs513 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000059311367767791419930000013676307114635563961_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs514 || (_defs514 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000178924192179224368170000015400268577490755458_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000051352376936369297330000007449391898148193691_",
    style: {
      clipPath: "url(#SVGID_00000061437734190857183210000010794870715271831687_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000059311367767791419930000013676307114635563961_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000081648761783025140960000001624502142108263825_",
    style: {
      clipPath: "url(#SVGID_00000051352376936369297330000007449391898148193691_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000178924192179224368170000015400268577490755458_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs515 || (_defs515 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000173873080125480220260000009148473574866692537_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs516 || (_defs516 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000069365647703641556140000006022839060519339402_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs517 || (_defs517 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000078003000212190092130000014805929888563808680_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000078755269555925502770000004376974218243324598_",
    style: {
      clipPath: "url(#SVGID_00000061437734190857183210000010794870715271831687_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000173873080125480220260000009148473574866692537_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000173857984481383237950000009900977274645283255_",
    style: {
      clipPath: "url(#SVGID_00000078755269555925502770000004376974218243324598_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000069365647703641556140000006022839060519339402_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000124142636713455455140000011536805391094399162_",
    style: {
      clipPath: "url(#SVGID_00000173857984481383237950000009900977274645283255_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000078003000212190092130000014805929888563808680_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs518 || (_defs518 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000132082721465559880190000006591885499269648778_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs519 || (_defs519 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000078035385761210788600000010908148654041434031_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs520 || (_defs520 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000005961534086045055680000011299251503594620578_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs521 || (_defs521 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000098922766585608237920000002802212221124939161_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000182508416987668167560000008585647793817073798_",
    style: {
      clipPath: "url(#SVGID_00000061437734190857183210000010794870715271831687_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000132082721465559880190000006591885499269648778_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000157267004911293237940000009445002296397751209_",
    style: {
      clipPath: "url(#SVGID_00000182508416987668167560000008585647793817073798_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000078035385761210788600000010908148654041434031_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000119083141228334565530000000428410900440007351_",
    style: {
      clipPath: "url(#SVGID_00000157267004911293237940000009445002296397751209_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000005961534086045055680000011299251503594620578_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000111192705297485156540000002823993963873093818_",
    style: {
      clipPath: "url(#SVGID_00000119083141228334565530000000428410900440007351_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000098922766585608237920000002802212221124939161_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs522 || (_defs522 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000149346925712918978540000007334313674657389979_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs523 || (_defs523 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000146493463967739511250000016153035602831537560_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs524 || (_defs524 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000082339811910131889320000003695078757792197302_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs525 || (_defs525 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000009561927555068894610000003172496295239292834_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs526 || (_defs526 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000152235750575704537240000018202308880172626080_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000031908224858121025900000006552919454225137334_",
    style: {
      clipPath: "url(#SVGID_00000061437734190857183210000010794870715271831687_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000149346925712918978540000007334313674657389979_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000008106798487439196400000009354751079095300521_",
    style: {
      clipPath: "url(#SVGID_00000031908224858121025900000006552919454225137334_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000146493463967739511250000016153035602831537560_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000116226177980530713060000009944091975729543327_",
    style: {
      clipPath: "url(#SVGID_00000008106798487439196400000009354751079095300521_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000082339811910131889320000003695078757792197302_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000102516049118069957150000005633624964335822267_",
    style: {
      clipPath: "url(#SVGID_00000116226177980530713060000009944091975729543327_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000009561927555068894610000003172496295239292834_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000112622484481005363210000008953700149618367646_",
    style: {
      clipPath: "url(#SVGID_00000102516049118069957150000005633624964335822267_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000152235750575704537240000018202308880172626080_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs527 || (_defs527 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000079483718604465257730000003170846116093487283_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs528 || (_defs528 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000168104794215554903960000012167804475417632403_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs529 || (_defs529 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000055684727127751489650000015601674501625149577_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs530 || (_defs530 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000083056716264706411560000011760720312409367471_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs531 || (_defs531 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000021098270841409338340000009998328302044814977_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs532 || (_defs532 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000045591446167477385980000017716514970550490786_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000168087001206862446010000009776336122317256364_",
    style: {
      clipPath: "url(#SVGID_00000061437734190857183210000010794870715271831687_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000079483718604465257730000003170846116093487283_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000027582418701575477050000007515243061707533476_",
    style: {
      clipPath: "url(#SVGID_00000168087001206862446010000009776336122317256364_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000168104794215554903960000012167804475417632403_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000151532936895617203670000000955912875321640364_",
    style: {
      clipPath: "url(#SVGID_00000027582418701575477050000007515243061707533476_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000055684727127751489650000015601674501625149577_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000174578580768437817860000006113734048985024148_",
    style: {
      clipPath: "url(#SVGID_00000151532936895617203670000000955912875321640364_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000083056716264706411560000011760720312409367471_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000116954119754037549090000012380328227554742194_",
    style: {
      clipPath: "url(#SVGID_00000174578580768437817860000006113734048985024148_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000021098270841409338340000009998328302044814977_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000065073950943192594700000003261639412021151145_",
    style: {
      clipPath: "url(#SVGID_00000116954119754037549090000012380328227554742194_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000045591446167477385980000017716514970550490786_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114038539742690501690000001717463962581893283_",
    gradientUnits: "userSpaceOnUse",
    x1: -238.3528,
    y1: 124.3381,
    x2: -311.8275,
    y2: 173.2932,
    gradientTransform: "matrix(1 0 0 -1 313.6061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      clipPath: "url(#SVGID_00000065073950943192594700000003261639412021151145_)",
      fill: "url(#SVGID_00000114038539742690501690000001717463962581893283_)"
    },
    cx: 66.7,
    cy: 91.4,
    r: 14
  })))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000104689086201952054110000007263037936512310437_",
    gradientUnits: "userSpaceOnUse",
    x1: -238.3528,
    y1: 124.3381,
    x2: -311.8275,
    y2: 173.2932,
    gradientTransform: "matrix(1 0 0 -1 313.6061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      clipPath: "url(#SVGID_00000061437734190857183210000010794870715271831687_)",
      mask: "url(#SVGID_00000084504480041518429150000012038922080463095702_)",
      fill: "url(#SVGID_00000104689086201952054110000007263037936512310437_)"
    },
    cx: 66.7,
    cy: 91.4,
    r: 14
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070114885872420072460000016248720229359957137_",
    gradientUnits: "userSpaceOnUse",
    x1: -238.3528,
    y1: 124.3381,
    x2: -311.8275,
    y2: 173.2932,
    gradientTransform: "matrix(1 0 0 -1 313.6061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#06090F"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000070114885872420072460000016248720229359957137_)"
    },
    cx: 66.7,
    cy: 91.4,
    r: 14
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152972577316504161750000002505016788245635221_",
    gradientUnits: "userSpaceOnUse",
    x1: -522.8093,
    y1: -786.9028,
    x2: -522.8093,
    y2: -807.4207,
    gradientTransform: "matrix(1 0 0 -1 588.6593 -709.3386)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09148491,
    style: {
      stopColor: "#14161C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2348,
    style: {
      stopColor: "#3A2317"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7931A"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000152972577316504161750000002505016788245635221_)"
    },
    cx: 65.8,
    cy: 90.6,
    r: 12.9
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114779846738093584980000014096359753120749983_",
    gradientUnits: "userSpaceOnUse",
    x1: -518.3647,
    y1: -807.0712,
    x2: -524.973,
    y2: -796.7278,
    gradientTransform: "matrix(1 0 0 -1 588.6593 -709.3386)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09148491,
    style: {
      stopColor: "#14161C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2348,
    style: {
      stopColor: "#3A2317"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7931A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000114779846738093584980000014096359753120749983_)"
    },
    d: "M74.4,87.9c-0.4-1.2-1-2.2-1.7-3.1 c-0.6-0.7-1.2-1.3-2-1.8c-1.5-1-3.2-1.5-5-1.5c-5,0-9.1,4.1-9.1,9.1c0,1.9,0.6,3.6,1.5,5c0.5,0.7,1.1,1.4,1.8,2 c0.9,0.8,2,1.3,3.1,1.7c0.9,0.2,1.8,0.4,2.8,0.4c5,0,9.1-4.1,9.1-9.1C74.9,89.6,74.8,88.7,74.4,87.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs533 || (_defs533 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000061459267044217446080000012229187313106419863_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000028298864255366498070000003215989789398837416_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000061459267044217446080000012229187313106419863_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs534 || (_defs534 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000094589509842954794560000010917273529786221986_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs535 || (_defs535 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000050621546360291919700000009352530035571604645_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000026850234770347705420000003974806516807267506_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000094589509842954794560000010917273529786221986_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000148641401464228233170000011532459565455221158_",
    style: {
      clipPath: "url(#SVGID_00000026850234770347705420000003974806516807267506_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000050621546360291919700000009352530035571604645_",
    style: {
      overflow: "visible"
    }
  })), _defs536 || (_defs536 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000001636993172465121890000005230158983085689526_",
    filterUnits: "userSpaceOnUse",
    x: 56.8,
    y: 81.5,
    width: 14.1,
    height: 14.1
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 56.8,
    y: 81.5,
    width: 14.1,
    height: 14.1,
    id: "SVGID_00000029031480218474137670000017068951029419592372_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000001636993172465121890000005230158983085689526_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs537 || (_defs537 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000070829995252724472550000007375150911417723821_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs538 || (_defs538 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000012433729523374845440000012818396305133942916_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000076589487414773798690000010878507572261333182_",
    style: {
      clipPath: "url(#SVGID_00000148641401464228233170000011532459565455221158_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000070829995252724472550000007375150911417723821_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000076564510132642565960000007638660402409599149_",
    style: {
      clipPath: "url(#SVGID_00000076589487414773798690000010878507572261333182_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000012433729523374845440000012818396305133942916_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs539 || (_defs539 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000124868691608353314030000015002635282044826031_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs540 || (_defs540 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000013884249641066612510000013430464478671770559_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs541 || (_defs541 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000077324154159453791950000015278190773524007358_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000142175597556537253120000011187637250991185060_",
    style: {
      clipPath: "url(#SVGID_00000148641401464228233170000011532459565455221158_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000124868691608353314030000015002635282044826031_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000112604613484586478570000003262579015229318025_",
    style: {
      clipPath: "url(#SVGID_00000142175597556537253120000011187637250991185060_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000013884249641066612510000013430464478671770559_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000098218523753159116530000017487808657515260094_",
    style: {
      clipPath: "url(#SVGID_00000112604613484586478570000003262579015229318025_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000077324154159453791950000015278190773524007358_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs542 || (_defs542 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000116236482699302053780000007225558674356655242_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs543 || (_defs543 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000064325700512035804780000016913857563261288368_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000023277822091880868950000007057884737856788656_",
    style: {
      clipPath: "url(#SVGID_00000148641401464228233170000011532459565455221158_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000116236482699302053780000007225558674356655242_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000136387007771628240610000011327782151850190736_",
    style: {
      clipPath: "url(#SVGID_00000023277822091880868950000007057884737856788656_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000064325700512035804780000016913857563261288368_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs544 || (_defs544 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000170280349398210451030000006176528105680273317_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs545 || (_defs545 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000152956810844381972600000014726678855945586816_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs546 || (_defs546 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000041273394020010711330000011117119335709463688_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000076587387186762400450000011314890268517942927_",
    style: {
      clipPath: "url(#SVGID_00000148641401464228233170000011532459565455221158_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000170280349398210451030000006176528105680273317_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000079486387495095248030000009576305227179632270_",
    style: {
      clipPath: "url(#SVGID_00000076587387186762400450000011314890268517942927_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000152956810844381972600000014726678855945586816_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000180327002385402806830000003590079150520649096_",
    style: {
      clipPath: "url(#SVGID_00000079486387495095248030000009576305227179632270_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000041273394020010711330000011117119335709463688_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs547 || (_defs547 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000031901597438883495990000008886186716730988714_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs548 || (_defs548 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000093137058303210565160000013019610368919726981_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs549 || (_defs549 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000127042241942407546880000008608328658272655283_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs550 || (_defs550 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000167380597592985909260000008900993995333309599_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000109741807907682141550000005938930703458832055_",
    style: {
      clipPath: "url(#SVGID_00000148641401464228233170000011532459565455221158_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000031901597438883495990000008886186716730988714_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000157309932157792470750000016099248554598870198_",
    style: {
      clipPath: "url(#SVGID_00000109741807907682141550000005938930703458832055_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000093137058303210565160000013019610368919726981_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000112603616962837910180000011164657467200045734_",
    style: {
      clipPath: "url(#SVGID_00000157309932157792470750000016099248554598870198_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000127042241942407546880000008608328658272655283_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000059311666151013387430000011136062369881040556_",
    style: {
      clipPath: "url(#SVGID_00000112603616962837910180000011164657467200045734_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000167380597592985909260000008900993995333309599_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs551 || (_defs551 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000117672390557796326290000008101315667917478554_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs552 || (_defs552 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000052799695398009242310000012516921944388795567_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000006680913071705203110000017236541226817664944_",
    style: {
      clipPath: "url(#SVGID_00000148641401464228233170000011532459565455221158_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000117672390557796326290000008101315667917478554_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000140709282973139405450000003764959643769852857_",
    style: {
      clipPath: "url(#SVGID_00000006680913071705203110000017236541226817664944_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000052799695398009242310000012516921944388795567_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs553 || (_defs553 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000152228973772969925310000007209667392680036543_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs554 || (_defs554 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000026157010784375973970000001912444427554314125_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs555 || (_defs555 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000076589067981083399260000014292845656455928255_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000027602362198263371930000010109136250317515661_",
    style: {
      clipPath: "url(#SVGID_00000148641401464228233170000011532459565455221158_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000152228973772969925310000007209667392680036543_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000175289663205454376030000006960495963495786628_",
    style: {
      clipPath: "url(#SVGID_00000027602362198263371930000010109136250317515661_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000026157010784375973970000001912444427554314125_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000116221115028382538150000008626714416087176337_",
    style: {
      clipPath: "url(#SVGID_00000175289663205454376030000006960495963495786628_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000076589067981083399260000014292845656455928255_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs556 || (_defs556 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000098208646025080708400000000973287406960730298_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs557 || (_defs557 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000072274455287744581400000002101273879134075808_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs558 || (_defs558 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000104705100907474488980000009198292484111958939_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs559 || (_defs559 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000173137084794843034740000003069117277493380505_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000080172705158927916420000006934740707583826875_",
    style: {
      clipPath: "url(#SVGID_00000148641401464228233170000011532459565455221158_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000098208646025080708400000000973287406960730298_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000101791749664324535660000001353933577383249070_",
    style: {
      clipPath: "url(#SVGID_00000080172705158927916420000006934740707583826875_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000072274455287744581400000002101273879134075808_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000092441303240943303350000000942939228223958965_",
    style: {
      clipPath: "url(#SVGID_00000101791749664324535660000001353933577383249070_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000104705100907474488980000009198292484111958939_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000137831449743848032140000001396566310139449484_",
    style: {
      clipPath: "url(#SVGID_00000092441303240943303350000000942939228223958965_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000173137084794843034740000003069117277493380505_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs560 || (_defs560 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000078030376201839753100000009850477015521134509_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs561 || (_defs561 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000163774868420739690690000011071047050085823116_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs562 || (_defs562 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000161633707715074447130000000573837091320563117_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs563 || (_defs563 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000052098778065016798800000006923162351270820275_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs564 || (_defs564 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000068668569902337339220000010150610395696940735_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000011025908170203974140000003195314883421472446_",
    style: {
      clipPath: "url(#SVGID_00000148641401464228233170000011532459565455221158_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000078030376201839753100000009850477015521134509_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000036952863201655350470000014515106822240053431_",
    style: {
      clipPath: "url(#SVGID_00000011025908170203974140000003195314883421472446_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000163774868420739690690000011071047050085823116_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000001648091291881649900000009918180917815185302_",
    style: {
      clipPath: "url(#SVGID_00000036952863201655350470000014515106822240053431_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000161633707715074447130000000573837091320563117_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000088114712186297753400000004549365873259594650_",
    style: {
      clipPath: "url(#SVGID_00000001648091291881649900000009918180917815185302_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000052098778065016798800000006923162351270820275_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000179629953541952774140000001449446226315849632_",
    style: {
      clipPath: "url(#SVGID_00000088114712186297753400000004549365873259594650_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000068668569902337339220000010150610395696940735_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs565 || (_defs565 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000098179980854879829890000001483213188010935216_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs566 || (_defs566 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000041980243621548355280000017431358217725062016_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs567 || (_defs567 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000019668151067122498480000003044162141508166021_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs568 || (_defs568 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000109726690309146872660000006766670278302467968_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs569 || (_defs569 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000140730578108073933400000017221232290285373623_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs570 || (_defs570 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000096047786221171729380000004838393771582966189_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000044155188670284452470000003181169427412872874_",
    style: {
      clipPath: "url(#SVGID_00000148641401464228233170000011532459565455221158_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000098179980854879829890000001483213188010935216_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000070824210032202963880000001832146378273953214_",
    style: {
      clipPath: "url(#SVGID_00000044155188670284452470000003181169427412872874_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000041980243621548355280000017431358217725062016_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000157291430232596374330000013894349987921507756_",
    style: {
      clipPath: "url(#SVGID_00000070824210032202963880000001832146378273953214_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000019668151067122498480000003044162141508166021_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000090978568358306517210000002591878216232521143_",
    style: {
      clipPath: "url(#SVGID_00000157291430232596374330000013894349987921507756_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000109726690309146872660000006766670278302467968_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000166656648422282849990000000303258568219466388_",
    style: {
      clipPath: "url(#SVGID_00000090978568358306517210000002591878216232521143_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000140730578108073933400000017221232290285373623_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000119093069990264150280000008886438434389290933_",
    style: {
      clipPath: "url(#SVGID_00000166656648422282849990000000303258568219466388_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000096047786221171729380000004838393771582966189_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065063005333439259920000015674126085382635174_",
    gradientUnits: "userSpaceOnUse",
    x1: -239.5211,
    y1: 145.0226,
    x2: -289.232,
    y2: 101.2457,
    gradientTransform: "matrix(1 0 0 -1 313.6061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000119093069990264150280000008886438434389290933_)",
      fill: "url(#SVGID_00000065063005333439259920000015674126085382635174_)"
    },
    d: " M65.8,81.5c-5,0-9.1,4.1-9.1,9.1c0,1.9,0.6,3.6,1.5,5L70.8,83C69.3,82,67.7,81.5,65.8,81.5z"
  })))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065039719644588347790000000300268387451379376_",
    gradientUnits: "userSpaceOnUse",
    x1: -239.5211,
    y1: 145.0226,
    x2: -289.232,
    y2: 101.2457,
    gradientTransform: "matrix(1 0 0 -1 313.6061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000148641401464228233170000011532459565455221158_)",
      mask: "url(#SVGID_00000029031480218474137670000017068951029419592372_)",
      fill: "url(#SVGID_00000065039719644588347790000000300268387451379376_)"
    },
    d: " M65.8,81.5c-5,0-9.1,4.1-9.1,9.1c0,1.9,0.6,3.6,1.5,5L70.8,83C69.3,82,67.7,81.5,65.8,81.5z"
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096756560167308294260000006373352607113405862_",
    gradientUnits: "userSpaceOnUse",
    x1: -239.5211,
    y1: 145.0226,
    x2: -289.232,
    y2: 101.2457,
    gradientTransform: "matrix(1 0 0 -1 313.6061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.48,
      fill: "url(#SVGID_00000096756560167308294260000006373352607113405862_)",
      enableBackground: "new"
    },
    d: " M65.8,81.5c-5,0-9.1,4.1-9.1,9.1c0,1.9,0.6,3.6,1.5,5L70.8,83C69.3,82,67.7,81.5,65.8,81.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs571 || (_defs571 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000142174081086317578040000013191681123457150363_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000108282529844164306800000001046778154659821493_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000142174081086317578040000013191681123457150363_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs572 || (_defs572 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000109716161090609126280000001437804093850822035_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs573 || (_defs573 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000091712142294428911970000001856772001944069012_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000151516185891179635380000013230882431194623366_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000109716161090609126280000001437804093850822035_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000062884563405512065260000018318026035598986668_",
    style: {
      clipPath: "url(#SVGID_00000151516185891179635380000013230882431194623366_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000091712142294428911970000001856772001944069012_",
    style: {
      overflow: "visible"
    }
  })), _defs574 || (_defs574 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000075125102201907178290000015604321626948224409_",
    filterUnits: "userSpaceOnUse",
    x: 60.1,
    y: 84.8,
    width: 14.5,
    height: 14.4
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 60.1,
    y: 84.8,
    width: 14.5,
    height: 14.4,
    id: "SVGID_00000169544227182250955240000014722914001369640358_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000075125102201907178290000015604321626948224409_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs575 || (_defs575 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000003064596188216256110000000383502872735985070_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs576 || (_defs576 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000013907758523029389840000003975686684499042977_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000079446089691602823030000008603688663451065002_",
    style: {
      clipPath: "url(#SVGID_00000062884563405512065260000018318026035598986668_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000003064596188216256110000000383502872735985070_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000071533190028000432220000017138979276610973590_",
    style: {
      clipPath: "url(#SVGID_00000079446089691602823030000008603688663451065002_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000013907758523029389840000003975686684499042977_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs577 || (_defs577 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000168832600718227607900000014183362690570109611_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs578 || (_defs578 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000127756073317069064860000017349282259910858172_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs579 || (_defs579 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000080892064274431997110000012432324077017501630_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000002369830090483294400000007762775840658718390_",
    style: {
      clipPath: "url(#SVGID_00000062884563405512065260000018318026035598986668_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000168832600718227607900000014183362690570109611_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000120535472061473930650000003781028480143081858_",
    style: {
      clipPath: "url(#SVGID_00000002369830090483294400000007762775840658718390_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000127756073317069064860000017349282259910858172_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000008146022272614895820000015402555618983150215_",
    style: {
      clipPath: "url(#SVGID_00000120535472061473930650000003781028480143081858_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000080892064274431997110000012432324077017501630_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs580 || (_defs580 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000092441278387765926220000004264728843145778836_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs581 || (_defs581 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000159439817231129404560000010016300567415052475_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000069378706248619895900000006940361357605964956_",
    style: {
      clipPath: "url(#SVGID_00000062884563405512065260000018318026035598986668_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000092441278387765926220000004264728843145778836_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000080186185835275678580000000249874787925996680_",
    style: {
      clipPath: "url(#SVGID_00000069378706248619895900000006940361357605964956_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000159439817231129404560000010016300567415052475_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs582 || (_defs582 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000015345776450997893960000002401871140070966711_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs583 || (_defs583 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000136402568236726830920000008509157730933653167_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs584 || (_defs584 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000063629776086916282380000002420754524739948966_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000168097738955761580190000014558887119890985117_",
    style: {
      clipPath: "url(#SVGID_00000062884563405512065260000018318026035598986668_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000015345776450997893960000002401871140070966711_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000026884810985740644260000003034438082340875447_",
    style: {
      clipPath: "url(#SVGID_00000168097738955761580190000014558887119890985117_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000136402568236726830920000008509157730933653167_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000124872181812777216080000017484536501027332480_",
    style: {
      clipPath: "url(#SVGID_00000026884810985740644260000003034438082340875447_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000063629776086916282380000002420754524739948966_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs585 || (_defs585 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000108301233647557404870000000871817104412050107_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs586 || (_defs586 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000107579890519776186630000015686988404621844404_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs587 || (_defs587 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000064352841708169096850000007187855832869541521_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs588 || (_defs588 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000096033018774674162560000011326309713848245142_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000037664330791828325900000010038189283160255919_",
    style: {
      clipPath: "url(#SVGID_00000062884563405512065260000018318026035598986668_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000108301233647557404870000000871817104412050107_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000157299989313875884890000017912422834388361626_",
    style: {
      clipPath: "url(#SVGID_00000037664330791828325900000010038189283160255919_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000107579890519776186630000015686988404621844404_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000013176393750661714320000012021078632283507122_",
    style: {
      clipPath: "url(#SVGID_00000157299989313875884890000017912422834388361626_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000064352841708169096850000007187855832869541521_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000004539789631126153720000007887342931708190877_",
    style: {
      clipPath: "url(#SVGID_00000013176393750661714320000012021078632283507122_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000096033018774674162560000011326309713848245142_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs589 || (_defs589 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000044871917476449199830000007843799588093153947_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs590 || (_defs590 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000040559106959579867780000006635616978582992006_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000048479217491498663830000012728432597095174785_",
    style: {
      clipPath: "url(#SVGID_00000062884563405512065260000018318026035598986668_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000044871917476449199830000007843799588093153947_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000116207028625410936700000009590170934141132984_",
    style: {
      clipPath: "url(#SVGID_00000048479217491498663830000012728432597095174785_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000040559106959579867780000006635616978582992006_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs591 || (_defs591 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000171685161216221155200000002128704399427436216_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs592 || (_defs592 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000029009306402508849690000007110820327326195347_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs593 || (_defs593 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000125561959072164919290000012561564425876778643_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000160161165729588619220000016748638646631970215_",
    style: {
      clipPath: "url(#SVGID_00000062884563405512065260000018318026035598986668_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000171685161216221155200000002128704399427436216_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000115502596571192720770000006624082284749246117_",
    style: {
      clipPath: "url(#SVGID_00000160161165729588619220000016748638646631970215_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000029009306402508849690000007110820327326195347_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000044141351789855712270000013999166151095062185_",
    style: {
      clipPath: "url(#SVGID_00000115502596571192720770000006624082284749246117_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000125561959072164919290000012561564425876778643_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs594 || (_defs594 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000084519125618018573360000016988691905190810291_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs595 || (_defs595 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000041990477579647050260000003149350800970747051_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs596 || (_defs596 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000118358225257906481500000001405522894406739119_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs597 || (_defs597 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000054957392823087593440000010075843725183165069_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000014617362894444428240000014567905917049906311_",
    style: {
      clipPath: "url(#SVGID_00000062884563405512065260000018318026035598986668_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000084519125618018573360000016988691905190810291_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000026148327990595702550000003876251897494322860_",
    style: {
      clipPath: "url(#SVGID_00000014617362894444428240000014567905917049906311_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000041990477579647050260000003149350800970747051_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000072981503255295620250000015301169473231994769_",
    style: {
      clipPath: "url(#SVGID_00000026148327990595702550000003876251897494322860_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000118358225257906481500000001405522894406739119_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000042716917100323000890000016069007701440493703_",
    style: {
      clipPath: "url(#SVGID_00000072981503255295620250000015301169473231994769_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000054957392823087593440000010075843725183165069_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs598 || (_defs598 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000027573217315942906610000008459775509664454825_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs599 || (_defs599 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000061443732080789874520000017833365289626199687_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs600 || (_defs600 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000158739203893093504770000012366709493752719514_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs601 || (_defs601 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000173870977113937762890000011109979721293661360_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs602 || (_defs602 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000174585737855099454440000011944195478319609264_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000115500940299716473650000013834652737986340763_",
    style: {
      clipPath: "url(#SVGID_00000062884563405512065260000018318026035598986668_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000027573217315942906610000008459775509664454825_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000093146754208458521460000009733334667370264461_",
    style: {
      clipPath: "url(#SVGID_00000115500940299716473650000013834652737986340763_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000061443732080789874520000017833365289626199687_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000174582004304194610860000008604345787104652708_",
    style: {
      clipPath: "url(#SVGID_00000093146754208458521460000009733334667370264461_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000158739203893093504770000012366709493752719514_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000094577908480480742540000005235652467492145320_",
    style: {
      clipPath: "url(#SVGID_00000174582004304194610860000008604345787104652708_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000173870977113937762890000011109979721293661360_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000093857155843882490570000006944365179013026488_",
    style: {
      clipPath: "url(#SVGID_00000094577908480480742540000005235652467492145320_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000174585737855099454440000011944195478319609264_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs603 || (_defs603 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000034074342213581369320000001810454567915048852_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs604 || (_defs604 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000037676833005291786660000018414240105276540032_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs605 || (_defs605 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000054266773606210300090000014670481475243490188_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs606 || (_defs606 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000116926421164230570800000003887828224467220396_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), _defs607 || (_defs607 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000054976132136224102670000004624561298799026840_",
    points: "114.4,2 113.4,1 114.4,1  "
  }))), _defs608 || (_defs608 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000052102025893921112960000004433044382478468777_",
    points: "116.4,-2 117.4,-1 116.4,-1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000139986182045661888900000000607425235792636846_",
    style: {
      clipPath: "url(#SVGID_00000062884563405512065260000018318026035598986668_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000034074342213581369320000001810454567915048852_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000138558716875837808060000010951015052832492952_",
    style: {
      clipPath: "url(#SVGID_00000139986182045661888900000000607425235792636846_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000037676833005291786660000018414240105276540032_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000014601849665093189180000015540994041087263393_",
    style: {
      clipPath: "url(#SVGID_00000138558716875837808060000010951015052832492952_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000054266773606210300090000014670481475243490188_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000104706784889856509330000008471336547014163587_",
    style: {
      clipPath: "url(#SVGID_00000014601849665093189180000015540994041087263393_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000116926421164230570800000003887828224467220396_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000180329543700020910030000000688495582099316407_",
    style: {
      clipPath: "url(#SVGID_00000104706784889856509330000008471336547014163587_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000054976132136224102670000004624561298799026840_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000131345682595107931070000000576456646340667811_",
    style: {
      clipPath: "url(#SVGID_00000180329543700020910030000000688495582099316407_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000052102025893921112960000004433044382478468777_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085252743622289479390000017092804431050098083_",
    gradientUnits: "userSpaceOnUse",
    x1: -247.5726,
    y1: 141.0988,
    x2: -243.542,
    y2: 102.0241,
    gradientTransform: "matrix(1 0 0 -1 313.6061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000131345682595107931070000000576456646340667811_)",
      fill: "url(#SVGID_00000085252743622289479390000017092804431050098083_)"
    },
    d: " M72.8,84.8L60.1,97.5c0.9,0.8,2,1.3,3.1,1.7l11.4-11.4C74.2,86.7,73.5,85.7,72.8,84.8z"
  })))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096019375472299160970000014799818378256855212_",
    gradientUnits: "userSpaceOnUse",
    x1: -247.5726,
    y1: 141.0988,
    x2: -243.542,
    y2: 102.0241,
    gradientTransform: "matrix(1 0 0 -1 313.6061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000062884563405512065260000018318026035598986668_)",
      mask: "url(#SVGID_00000169544227182250955240000014722914001369640358_)",
      fill: "url(#SVGID_00000096019375472299160970000014799818378256855212_)"
    },
    d: " M72.8,84.8L60.1,97.5c0.9,0.8,2,1.3,3.1,1.7l11.4-11.4C74.2,86.7,73.5,85.7,72.8,84.8z"
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000126293219305046516320000001826286631429884342_",
    gradientUnits: "userSpaceOnUse",
    x1: -247.5726,
    y1: 141.0988,
    x2: -243.542,
    y2: 102.0241,
    gradientTransform: "matrix(1 0 0 -1 313.6061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.48,
      fill: "url(#SVGID_00000126293219305046516320000001826286631429884342_)",
      enableBackground: "new"
    },
    d: " M72.8,84.8L60.1,97.5c0.9,0.8,2,1.3,3.1,1.7l11.4-11.4C74.2,86.7,73.5,85.7,72.8,84.8z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeWidget2);
export default __webpack_public_path__ + "static/media/home-widget-2.fe354ffbe5d57b9ae13ee9f6107b3b32.svg";
export { ForwardRef as ReactComponent };